import { ESpot } from "./enums"


export type Location = {
    x: number
    y: number
    z: number
}


export const spotLocations: Record<string, Location[]> = {
      [ESpot.SCATTERING_OF_PEBBLE]: [
        {x: 6143.94, y: -555.08, z: 1.67},
        {x: 5998.041992, y: -190.072388, z: 6.612902},
        {x: 5962.616211, y: -398.056702, z: 15.635506},
        {x: 5864.993652, y: -301.424896, z: 43.145996},
        {x: 5878.316895, y: -353.401184, z: 26.86467},
        {x: 5909.471191, y: -238.666626, z: 4.145582},
        {x: 5953.661621, y: -122.339867, z: 104.236923},
        {x: 5948.452637, y: -139.772064, z: 4.452765},
        {x: 5843.258301, y: -232.379929, z: 0.129042},
        {x: 5818.07666, y: -132.414703, z: 0.273765},
        {x: 5893.726562, y: -353.180573, z: 10.661937},
        {x: 5975.346191, y: -429.242065, z: 67.121368},
        {x: 6085.94873, y: -335.632599, z: -0.005781},
        {x: 6040.939453, y: -370.828491, z: 36.324993},
        {x: 6049.699219, y: -342.306458, z: 19.856874},
        {x: 6026.066895, y: -332.564209, z: 2.509641},
        {x: 6041.253418, y: -345.32312, z: 2.394156},
        {x: 5917.932129, y: -302.799652, z: 16.033195},
        {x: 5926.880859, y: -302.834229, z: 1.922414},
        {x: 5978.351074, y: -267.398895, z: 0.321713},
        {x: 6007.729492, y: -242.320312, z: 2.080964},
        {x: 6054.599121, y: -116.866592, z: 0.079706},
        {x: 5975.800781, y: 137.212845, z: 1.602036},
        {x: 6027.663086, y: 239.765991, z: 5.684411},
        {x: 6098.517578, y: 203.898315, z: -0.40476},
        {x: 6136.075684, y: 294.264435, z: 0.142892},
        {x: 5993.19043, y: 202.134033, z: 29.537222},
        {x: 5900.528809, y: 76.644943, z: 13.223063},
        {x: 5765.246094, y: -5.068484, z: 0.253126},
        {x: 5814.075684, y: -16.437893, z: -6.378747},
        {x: 5818.786621, y: -24.363388, z: -6.158013},
        {x: 5940.688965, y: -59.889137, z: -0.595829},
        {x: 5943.530273, y: -6.252446, z: -0.499997},
        {x: 5894.06543, y: 39.718849, z: 13.571279},
        {x: 5911.858887, y: 9.445391, z: -0.467614},
        {x: 6024.930176, y: -41.209648, z: 8.657013},
        {x: 6119.778809, y: -441.659454, z: 13.188375},
        {x: 6076.239258, y: -483.660156, z: 3.156908},
        {x: 6046.457031, y: -212.916, z: -0.394482},
        {x: 6030.661621, y: -31.919603, z: 2.448035},
        {x: 6133.854004, y: 60.393818, z: 72.597397},
        {x: 6031.871582, y: -498.673889, z: 127.31266},
        {x: 5868.682129, y: -573.001587, z: 192.657379},
        {x: 6087.300781, y: -750.156738, z: 109.72374},
        {x: 6062.905762, y: 195.50563, z: 53.85376},
        {x: 5962.292969, y: 283.597382, z: 8.17},
        {x: 6028.358398, y: 348.718231, z: -3.886956},
        {x: 6139.716309, y: 361.828339, z: -7.386898},
        {x: 6217.474121, y: 444.040924, z: -2.83756},
        {x: 6187.817871, y: 239.71994, z: -11.023449},
        {x: 6117.0625, y: 74.268593, z: 16.812885},
        {x: 6219.447266, y: -105.943184, z: -17.714039},
        {x: 6302.975098, y: -171.761292, z: -18.452574},
        {x: 6274.892578, y: -330.152649, z: -38.646179},
        {x: 6299.228516, y: -407.155792, z: -47.285904},
        {x: 6175.220215, y: -546.404419, z: -5.82885},
        {x: 6149.512695, y: -427.050873, z: -5.646041},
        {x: 6097.396973, y: -390.164062, z: -5.599554},
        {x: 6058.855469, y: -160.48436, z: -6.378973},
        {x: 6141.369629, y: 49.11277, z: 87.138519},
        {x: 5741.74, y: -1505.54, z: 3.13},
        {x: 5838.54, y: -1546.52, z: 57.65},
        {x: 5925.79, y: -1617.18, z: 30.63},
        {x: 5122.78, y: -1463.72, z: 8.25},
        {x: 5261.77, y: -1488.02, z: -0.03},
        {x: 5535.0, y: -2085.0, z: 23.0},
        {x: 5730.02, y: -1738.96, z: 0.34},
        {x: 5791.66, y: -1808.57, z: 1.81},
        {x: 5777.83, y: -1673.43, z: 0.11},
        {x: 5777.511, y: -1769.93, z: 46.071},
        {x: 5909.191, y: -1816.718, z: -0.515},
        {x: 6029.377, y: -1901.274, z: -0.103},
        {x: 5776.956, y: -2211.804, z: -24.534},
        {x: 6072.271, y: -2282.381, z: -13.285},
        {x: 6169.934, y: -2316.91, z: 14.171},
        {x: 6251.201, y: -2145.652, z: -0.257},
        {x: 6351.14, y: -2113.83, z: 56.84},
        {x: 6310.1, y: -2086.42, z: 68.98},
        {x: 6082.025, y: -1844.669, z: 46.426},
        {x: 6157.04, y: -1963.3, z: 0.05},
        {x: 6522.137695, y: 839.042419, z: -34.050877},
        {x: 6506.40625, y: 703.009583, z: -17.512962},
        {x: 6507.532227, y: 831.009338, z: -40.301868},
        {x: 6390.563965, y: 1000.861084, z: -24.929787},
        {x: 6259.051758, y: 1161.022827, z: -3.503444},
        {x: 6063.722656, y: 1026.737427, z: 6.532279},
        {x: 5928.066406, y: 1161.093506, z: 155.450699},
        {x: 5986.799805, y: 861.467163, z: 12.766994},
        {x: 6004.523926, y: 893.544861, z: 16.748718},
        {x: 6275.854004, y: 776.539246, z: 18.372698},
        {x: 6139.141113, y: 1172.391846, z: 4.715564},
        {x: 6242.199707, y: 1288.131714, z: 25.559341},
        {x: 5600.774902, y: 934.905151, z: 70.68},
        {x: 6099.228027, y: 518.41333, z: 12.504223},
        {x: 6005.20166, y: 973.297974, z: 13.809468},
        {x: 6003.503906, y: 1219.709717, z: 224.792648},
        {x: 6204.115234, y: 1316.954834, z: 48.449062},
        {x: 6249.090332, y: 1195.498779, z: 15.889366},
        {x: 6375.978027, y: 1032.222534, z: -25.151157},
        {x: 6430.227539, y: 1061.907715, z: -15.06413},
        {x: 6129.272949, y: -500.90799, z: 0.391027},
        {x: 5980.791504, y: 173.854996, z: 28.04891},
        {x: 5985.213379, y: 68.001556, z: -0.051046},
        {x: 5920.463379, y: 362.228638, z: 1.911379},
        {x: 6007.993164, y: 332.658936, z: -0.052815},
        {x: 6059.73877, y: -282.783936, z: -0.007635},
        {x: 6052.172852, y: -517.06311, z: 95.551971},
        {x: 6011.601074, y: -315.86557, z: 2.01071},
        {x: 6030.728027, y: -61.833965, z: 4.083804},
        {x: 5791.476562, y: -91.21344, z: 0.265724},
        {x: 5835.515625, y: 3.488263, z: 0.319805},
        {x: 5816.348145, y: 146.936523, z: 6.006292},
        {x: 6049.206543, y: 182.964157, z: 0.091472},
        {x: 6005.754395, y: 386.050537, z: 11.371301},
        {x: 6173.036621, y: 479.698883, z: -0.021614},
        {x: 6325.574707, y: 863.259766, z: 2.325436},
        {x: 6165.542969, y: 961.538452, z: -0.062653},
        {x: 6037.919434, y: 850.316895, z: 12.640758},
        {x: 6316.052246, y: 770.567322, z: 12.102049},
        {x: 5973.742676, y: -450.726562, z: 130.052475}
      ],
      [ESpot.SILVER_VEIN]: [
        {x: 4241.730957, y: -2089.220947, z: 90.290413},
        {x: 4228.067871, y: -2053.931885, z: 68.364067},
        {x: 4273.362793, y: -2089.921387, z: 115.767784},
        {x: 4298.875488, y: -2076.611328, z: 95.337158},
        {x: 4293.515625, y: -2065.334229, z: 64.368851},
        {x: 4299.54834, y: -2043.046265, z: 44.286335},
        {x: 4261.85791, y: -2079.271973, z: 67.269554},
        {x: 4327.658203, y: -1922.314941, z: 34.949799},
        {x: 4388.383301, y: -1929.929077, z: 37.03231},
        {x: 4415.124512, y: -1880.684692, z: 34.92054},
        {x: 4529.203613, y: -1938.761475, z: 59.052658},
        {x: 4564.921387, y: -1792.553345, z: 82.147575},
        {x: 4563.450684, y: -1845.78418, z: 80.336838},
        {x: 4625.052734, y: -1805.859863, z: 74.222046},
        {x: 4595.369141, y: -1795.292725, z: 66.388954},
        {x: 4602.810059, y: -1812.706665, z: 74.604927},
        {x: 4645.44043, y: -1743.044678, z: 124.020432},
        {x: 4633.125977, y: -1771.213867, z: 118.22435},
        {x: 4623.845703, y: -1797.946655, z: 129.80072},
        {x: 4600.597656, y: -1739.841064, z: 117.015862},
        {x: 4394.079102, y: -1762.044556, z: 58.972916},
        {x: 4396.799316, y: -1661.359741, z: 90.075539},
        {x: 4333.589355, y: -1646.02478, z: 71.804016},
        {x: 4292.002441, y: -1680.064331, z: 51.62936},
        {x: 4266.225586, y: -1739.430054, z: 82.536949},
        {x: 4279.734863, y: -1650.14917, z: 92.302528},
        {x: 4140.981445, y: -1671.937866, z: 121.56929},
        {x: 4163.743652, y: -1739.84436, z: 104.117729},
        {x: 4257.081543, y: -1766.543701, z: 51.198471},
        {x: 4230.263184, y: -1740.015259, z: 56.003521},
        {x: 4232.867188, y: -1825.776489, z: 51.022587},
        {x: 4284.543945, y: -1810.070068, z: 38.146896},
        {x: 4360.198242, y: -1764.348633, z: 41.084171},
        {x: 4415.685547, y: -1711.831177, z: 69.153671},
        {x: 4392.141602, y: -1711.62439, z: 61.666763},
        {x: 4443.391602, y: -1650.489746, z: 87.023628},
        {x: 4382.0, y: -1698.5177, z: 55.60376},
        {x: 4306.5625, y: -1640.743896, z: 131.443329},
        {x: 4321.102539, y: -1581.834839, z: 135.332626},
        {x: 4216.254883, y: -1529.126465, z: 183.507904},
        {x: 4251.835938, y: -1620.761963, z: 143.92514},
        {x: 4144.462891, y: -1611.897949, z: 139.313171},
        {x: 4236.226074, y: -1694.459106, z: 106.005707},
        {x: 4180.974121, y: -1783.51355, z: 135.238312},
        {x: 4090.845215, y: -1840.287476, z: 111.71476},
        {x: 4153.918945, y: -1973.477661, z: 80.797546},
        {x: 4152.62793, y: -1942.34436, z: 108.023224},
        {x: 4113.384277, y: -1922.484619, z: 172.145142},
        {x: 4415.844727, y: -1940.718872, z: 84.595749},
        {x: 4311.220215, y: -2028.880981, z: 44.759541},
        {x: 4338.087891, y: -2006.928345, z: 55.313251},
        {x: 4198.438477, y: -2081.039307, z: 62.991348},
        {x: 4390.85791, y: -1841.506104, z: 42.046368},
        {x: 4335.931641, y: -1894.451904, z: 38.833725},
        {x: 4458.071777, y: -1924.240845, z: 71.77356},
        {x: 4577.564453, y: -1890.259766, z: 60.970001},
        {x: 4541.175293, y: -1858.778076, z: 65.21109},
        {x: 4522.069336, y: -1767.145752, z: 80.275261},
        {x: 4414.108887, y: -1604.655884, z: 151.865601},
        {x: 4407.174316, y: -1689.169189, z: 81.095917},
        {x: 4424.94873, y: -1915.346069, z: 43.977905},
        {x: 4500.338379, y: -1750.308472, z: 62.47234},
        {x: 4493.041016, y: -1707.726685, z: 74.410446},
        {x: 4212.321289, y: -1908.125488, z: 38.828537},
        {x: 4229.583496, y: -2019.500732, z: 44.085781},
        {x: 4378.312988, y: -1816.138184, z: 39.926178},
        {x: 4337.540527, y: -1763.773438, z: 39.853596},
        {x: 4449.115234, y: -1845.548462, z: 49.35437},
        {x: 4528.284668, y: -1786.697266, z: 61.380219},
        {x: 4269.85498, y: -1891.109375, z: 39.493446},
        {x: 4321.938477, y: -1991.990967, z: 41.093933},
        {x: 4248.589844, y: -2003.893921, z: 44.534416},
        {x: 4225.189453, y: -1687.536621, z: 48.864063},
        {x: 4225.487793, y: -1856.255981, z: 40.705791},
        {x: 4259.911621, y: -1879.005249, z: 39.331715},
        {x: 4352.161621, y: -1962.406738, z: 39.580547},
        {x: 4467.656738, y: -1877.342285, z: 60.131493},
        {x: 4194.544922, y: -1977.297974, z: 45.622784},
        {x: 4203.379883, y: -1932.732422, z: 53.732239},
        {x: 4406.614746, y: -1917.582397, z: 49.910992}
      ],
      [ESpot.COPPER_VEIN]: [
        {x: 5223.651367, y: -2652.83374, z: 33.001877},
        {x: 5285.100098, y: -2637.4729, z: 42.291611},
        {x: 5346.055176, y: -2735.049805, z: 15.820734},
        {x: 5248.203613, y: -2614.956787, z: -11.660694},
        {x: 5510.061035, y: -2763.40918, z: -3.131161},
        {x: 5535.150879, y: -2753.777588, z: -5.227847},
        {x: 5524.510254, y: -2742.164062, z: -3.765834},
        {x: 5461.262695, y: -2611.313477, z: 48.026001},
        {x: 5472.852051, y: -2709.103516, z: 57.59845},
        {x: 5499.273926, y: -2648.942627, z: 16.906279},
        {x: 5431.654297, y: -2530.655762, z: 21.23913},
        {x: 5379.541992, y: -2461.279297, z: 21.184629},
        {x: 5364.787109, y: -2440.753174, z: 48.041584},
        {x: 5388.000977, y: -2361.162109, z: 17.435778},
        {x: 5765.696, y: -2118.022, z: -38.683},
        {x: 5598.058105, y: -2367.756592, z: -2.881481},
        {x: 5568.692871, y: -2352.264893, z: -5.110594},
        {x: 5670.487793, y: -2319.944824, z: -7.77387},
        {x: 5583.57373, y: -2400.967041, z: -5.269962},
        {x: 5449.257324, y: -2584.717529, z: 14.618911},
        {x: 5442.793945, y: -2716.397705, z: 0.963868},
        {x: 5695.333008, y: -2471.590576, z: -4.22669},
        {x: 5541.302734, y: -2382.685059, z: -3.595804},
        {x: 5739.09668, y: -2281.746094, z: -14.711535},
        {x: 5671.400391, y: -2443.775635, z: -4.024502},
        {x: 5577.626953, y: -2520.540283, z: -4.949759},
        {x: 5548.166504, y: -2547.453857, z: -4.917044},
        {x: 5551.148438, y: -2724.710938, z: -2.924203},
        {x: 5569.206543, y: -2687.37793, z: -3.628104},
        {x: 5573.755371, y: -2635.713867, z: -4.845338},
        {x: 5627.053223, y: -2585.310791, z: -5.263842},
        {x: 5573.884277, y: -2728.920898, z: -4.600582},
        {x: 5888.192383, y: -2346.921143, z: -17.832253},
        {x: 5530.876953, y: -2482.188477, z: -3.916545},
        {x: 5573.324707, y: -2517.45166, z: -4.99198},
        {x: 5819.317871, y: -2384.733643, z: -50.21735},
        {x: 5862.158691, y: -2447.070068, z: -62.342751},
        {x: 5825.740723, y: -2576.77417, z: -60.068241},
        {x: 5888.807617, y: -2639.248047, z: -37.155586},
        {x: 5913.166016, y: -2567.226562, z: -86.728828},
        {x: 5973.494141, y: -2580.95459, z: -107.240845},
        {x: 5858.804, y: -2238.017, z: -27.151},
        {x: 5923.804688, y: -2334.998047, z: -57.831295},
        {x: 5880.815, y: -2280.741, z: -32.969},
        {x: 5989.210449, y: -2632.439697, z: -96.008133},
        {x: 5988.34668, y: -2668.541748, z: -65.37648},
        {x: 5975.583008, y: -2622.412598, z: -73.116074},
        {x: 6058.275879, y: -2635.228271, z: -107.441742},
        {x: 5380.09082, y: -2387.837158, z: 3.869994},
        {x: 5443.563477, y: -2556.262207, z: 3.418904},
        {x: 5411.341797, y: -2786.318848, z: -2.96451},
        {x: 5656.233887, y: -2703.496094, z: -8.567941},
        {x: 5543.422852, y: -2606.141113, z: -2.236109},
        {x: 5500.647949, y: -2432.671631, z: -2.956233},
        {x: 5595.155273, y: -2275.910156, z: -2.164041},
        {x: 5600.951, y: -2307.664, z: -4.799},
        {x: 5404.454102, y: -2501.543457, z: 7.29032},
        {x: 5389.852051, y: -2298.101318, z: 24.364105},
        {x: 5354.621094, y: -2383.957275, z: 60.400524},
        {x: 5772.796875, y: -2609.004639, z: -6.8884},
        {x: 2810.647461, y: 1063.290161, z: -13.494127},
        {x: 5459.726562, y: -1860.174805, z: -6.27},
        {x: 5929.453, y: -1504.914, z: -15.745},
        {x: 6038.347, y: -1601.349, z: -8.35},
        {x: 5711.922, y: -1934.518, z: -37.54},
        {x: 5446.08, y: -1827.677, z: -11.278},
        {x: 765.282654, y: 1949.334961, z: 99.698051},
        {x: 524.745422, y: 1959.305298, z: 27.749998},
        {x: 515.732117, y: 2073.901611, z: 29.835197},
        {x: 658.347656, y: 1891.077271, z: 72.685989},
        {x: 494.740723, y: 2158.812744, z: 13.271482},
        {x: 544.421082, y: 2060.720947, z: -19.554955},
        {x: 593.16449, y: 1913.877563, z: 54.685604},
        {x: 1562.058838, y: 500.487579, z: -44.555912},
        {x: 1864.532227, y: 405.619049, z: -15.690152},
        {x: 2342.415527, y: 663.674377, z: -51.667137},
        {x: 1444.97522, y: 923.043823, z: -13.499999},
        {x: 1462.606934, y: 1045.654053, z: -117.085472},
        {x: 1825.183105, y: 1084.684814, z: -13.499999},
        {x: 2218.163818, y: 1042.144287, z: -4.011024},
        {x: 2898.056396, y: 855.051392, z: -25.456177},
        {x: 5673.833, y: -1943.112, z: -39.934},
        {x: 5708.688, y: -2038.698, z: -30.962},
        {x: 5489.512695, y: -2187.924561, z: 8.980188},
        {x: 5892.388, y: -2395.96, z: -46.04},
        {x: 5521.029297, y: -2714.17041, z: 58.200615},
        {x: 5477.816406, y: -2404.278076, z: -0.85292},
        {x: 5528.706055, y: -2469.678711, z: -3.356072},
        {x: 5488.552246, y: -2647.633301, z: 48.348305},
        {x: 5523.666016, y: -2726.644531, z: 5.005261},
        {x: 5548.141113, y: -2688.528076, z: -0.687103},
        {x: 5543.082031, y: -2342.052734, z: -1.936038},
        {x: 5492.859863, y: -2338.780273, z: -0.3299},
        {x: 5409.476074, y: -2205.065674, z: 30.829014},
        {x: 5709.65, y: -2430.645, z: -9.276},
        {x: 5434.672363, y: -2595.752686, z: 66.86731},
        {x: 5510.722168, y: -2676.567139, z: 9.750904},
        {x: 5592.853516, y: -2133.072266, z: -0.429039},
        {x: 5543.932, y: -2093.201, z: 11.729},
        {x: 5592.419434, y: -2030.471436, z: -0.616614}
      ],
      [ESpot.GOLD_VEIN]: [
        {x: 4246.721191, y: 1122.732788, z: -12.82946},
        {x: 4186.576172, y: 1138.165405, z: 4.998246},
        {x: 4193.586426, y: 1114.637329, z: -4.070418},
        {x: 4233.706543, y: 1108.332397, z: -12.635452},
        {x: 4253.094238, y: 1126.322388, z: -5.276742},
        {x: 4233.66748, y: 1168.817505, z: -8.75275},
        {x: 4206.900391, y: 1167.28125, z: -4.382612},
        {x: 4329.524902, y: 1187.219482, z: 159.822861},
        {x: 4216.305176, y: 1054.626587, z: 164.282181},
        {x: 4325.51123, y: 1121.115479, z: 1.813065},
        {x: 4354.349609, y: 1124.304199, z: 1.81},
        {x: 4304.050781, y: 1038.103882, z: 2.688807},
        {x: 4293.027832, y: 1058.266846, z: 18.458628},
        {x: 4363.729004, y: 1037.886108, z: 85.725784},
        {x: 4348.268066, y: 1172.070679, z: 111.527687},
        {x: 4448.473633, y: 1160.495605, z: 192.596725},
        {x: 4447.899902, y: 1116.311523, z: -6.091297},
        {x: 4471.805176, y: 1130.35437, z: 10.764425},
        {x: 4469.743164, y: 1141.257324, z: 68.623604},
        {x: 4444.578125, y: 1204.879517, z: 138.72963},
        {x: 4358.630859, y: 1278.285522, z: 24.452639},
        {x: 4253.274902, y: 1282.678711, z: 31.014786},
        {x: 4045.051025, y: 1227.949585, z: 36.386803},
        {x: 4064.804443, y: 1276.563721, z: 29.483332},
        {x: 4077.165527, y: 1314.493652, z: 31.876537},
        {x: 4192.966309, y: 1314.623779, z: 31.624298},
        {x: 4279.640625, y: 1252.560913, z: 29.410364},
        {x: 4373.966797, y: 1304.697876, z: 25.970451},
        {x: 5412.959473, y: 1126.224365, z: -32.774998},
        {x: 5398.432129, y: 1236.036621, z: -43.546589},
        {x: 5359.987793, y: 1127.227051, z: -32.967857},
        {x: 4921.905273, y: 1104.505493, z: 99.192535},
        {x: 4899.806152, y: 1060.793945, z: 124.69545},
        {x: 4851.178711, y: 848.844543, z: 130.150085},
        {x: 4849.008301, y: 825.315552, z: 171.398697},
        {x: 4764.922363, y: 765.125732, z: 158.19017},
        {x: 4816.612305, y: 928.302063, z: 24.136707},
        {x: 5011.028809, y: 901.507812, z: 20.675053},
        {x: 5065.739746, y: 931.204712, z: 0.609481},
        {x: 4608.182617, y: 562.082886, z: 359.374908},
        {x: 4490.214355, y: 737.292847, z: 163.681686},
        {x: 4464.463867, y: 788.391235, z: 106.054527},
        {x: 4630.307129, y: 918.693848, z: -16.413979},
        {x: 4863.598145, y: 915.710327, z: 22.549614},
        {x: 4877.946777, y: 902.867798, z: 59.880272},
        {x: 4953.458984, y: 846.089478, z: -5.045746},
        {x: 5070.164551, y: 843.862854, z: -7.317938},
        {x: 5096.498047, y: 848.131042, z: -7.446781},
        {x: 5104.674316, y: 840.62207, z: -5.97828},
        {x: 5168.88623, y: 889.15686, z: 0.288807},
        {x: 5303.132812, y: 908.76178, z: 13.740147},
        {x: 5213.747559, y: 958.002808, z: -0.142329},
        {x: 5165.953125, y: 1196.686279, z: 25.982885},
        {x: 5101.140137, y: 1226.381348, z: 18.390503},
        {x: 5154.911621, y: 1193.453491, z: 38.706364},
        {x: 5140.388184, y: 975.94165, z: -8.977902},
        {x: 5093.479492, y: 1080.695557, z: 6.101203},
        {x: 4953.419922, y: 974.577148, z: 39.039757},
        {x: 4948.516113, y: 1037.643311, z: 11.400992},
        {x: 4507.578125, y: 905.345947, z: 3.445274},
        {x: 5132.535156, y: 729.342041, z: 50.623375},
        {x: 5236.962891, y: 934.779297, z: 15.822391},
        {x: 5059.692871, y: 849.607849, z: 22.87079},
        {x: 4643.10498, y: 1186.517822, z: 17.706068},
        {x: 4528.60791, y: 839.180542, z: 19.622435},
        {x: 4204.163086, y: 1373.758179, z: 29.693264},
        {x: 4240.050293, y: 1415.527588, z: 36.29055},
        {x: 4141.240723, y: 1372.781982, z: 8.541776},
        {x: 4206.084473, y: 1341.084961, z: 31.998783},
        {x: 4208.146484, y: 1299.897461, z: 30.616026},
        {x: 4034.740967, y: 1295.054199, z: 31.724489},
        {x: 4305.929688, y: 1102.449829, z: 2.090432},
        {x: 4192.825684, y: 1145.165894, z: -2.273022},
        {x: 4387.519043, y: 1046.921509, z: 1.0},
        {x: 4350.269531, y: 1080.450684, z: 0.937672},
        {x: 5345.347168, y: 954.014221, z: 22.962229},
        {x: 5240.824707, y: 873.88562, z: 0.540842},
        {x: 4853.294434, y: 1004.393494, z: 16.613062},
        {x: 4586.297363, y: 813.186035, z: -16.265903},
        {x: 5070.037109, y: 756.761047, z: 27.71489}
      ],
      [ESpot.IRON_VEIN]: [
        {x: 1216.423584, y: 604.491089, z: -94.228302},
        {x: 1198.526367, y: 742.054199, z: -49.367115},
        {x: 1011.945618, y: 628.629822, z: -187.754578},
        {x: 1108.816528, y: 535.612122, z: -15.624673},
        {x: 822.072815, y: 621.049744, z: -263.3992},
        {x: 1038.792725, y: 765.22821, z: -13.502851},
        {x: 1173.919312, y: 615.593445, z: -148.398346},
        {x: 1343.654541, y: 624.594666, z: -179.724075},
        {x: 1579.976562, y: 554.994873, z: -13.499999},
        {x: 1439.517456, y: 708.778564, z: 0.284212},
        {x: 1348.71814, y: 316.188568, z: -13.499999},
        {x: 1818.956787, y: 296.842712, z: -61.348598},
        {x: 998.794189, y: 524.299805, z: 0.21225},
        {x: 1270.939453, y: 267.284637, z: 4.44},
        {x: 1474.501587, y: 307.00824, z: -88.254951},
        {x: 1549.350464, y: 412.464172, z: -213.731171},
        {x: 1514.455444, y: 423.686035, z: -190.754593},
        {x: 1549.792358, y: 221.028931, z: -25.334244},
        {x: 1768.885986, y: 249.282867, z: -13.499999},
        {x: 1398.895264, y: 174.004517, z: -0.497795},
        {x: 1286.551025, y: 320.651855, z: 8.03051},
        {x: 1883.162476, y: 248.61142, z: -13.499999},
        {x: 2113.364502, y: 262.895477, z: 6.922066},
        {x: 2480.702148, y: 607.896851, z: -8.751528},
        {x: 2204.318604, y: -157.77597, z: 126.856842},
        {x: 2146.71582, y: -26.433956, z: 97.804176},
        {x: 2459.02002, y: -385.490295, z: 45.055668},
        {x: 2449.59668, y: -287.642059, z: 131.171738},
        {x: 2302.082275, y: 102.181252, z: 94.638161},
        {x: 2309.211914, y: 240.693329, z: -13.019986},
        {x: 2454.5271, y: 485.484558, z: 6.591387},
        {x: 2220.929932, y: 383.499054, z: -73.846085},
        {x: 2179.714111, y: 437.737854, z: -47.870045},
        {x: 1846.73291, y: 484.089203, z: -16.439009},
        {x: 1566.640015, y: 24.952715, z: 124.082794},
        {x: 1897.705933, y: 99.300247, z: 62.973061},
        {x: 1965.263916, y: 30.789276, z: 84.406403},
        {x: 1789.981934, y: -871.148682, z: 657.505005},
        {x: 1958.139282, y: -474.836914, z: 155.750168},
        {x: 2022.549194, y: -447.525787, z: 122.272987},
        {x: 2230.820312, y: -531.114563, z: 114.214607},
        {x: 2762.94458, y: 367.635132, z: 222.482697},
        {x: 2808.638672, y: 438.278564, z: 229.490524},
        {x: 2743.034424, y: 316.973816, z: 174.918747},
        {x: 2706.074463, y: 196.155914, z: 118.234177},
        {x: 2707.712646, y: 77.254478, z: 168.452591},
        {x: 2615.878174, y: 119.305984, z: 90.549118},
        {x: 2534.387451, y: -33.661678, z: 79.756271},
        {x: 2491.878174, y: 5.365913, z: 77.513908},
        {x: 2363.064209, y: 191.920547, z: 93.055023},
        {x: 2318.38916, y: 260.772858, z: 75.703552},
        {x: 2094.505859, y: 230.232086, z: 69.380005},
        {x: 1987.239746, y: -44.528538, z: 87.303047},
        {x: 1550.264771, y: -339.129883, z: 122.157097},
        {x: 1413.237915, y: -338.760345, z: 34.479897},
        {x: 1335.730835, y: -53.306057, z: 48.919411},
        {x: 1582.442993, y: 149.314209, z: 1.19},
        {x: 2031.58374, y: 136.791, z: 57.523457},
        {x: 2185.461182, y: 4.048247, z: 94.268166},
        {x: 2240.543701, y: -231.529022, z: 115.713249},
        {x: 2357.585693, y: 527.987488, z: 0.50184},
        {x: 1793.211548, y: 260.243561, z: 0.847407},
        {x: 1238.390747, y: 517.057922, z: -13.499999},
        {x: 1462.446777, y: 660.804199, z: 0.333875},
        {x: 1395.541626, y: 432.873993, z: -13.499999},
        {x: 1599.974609, y: 355.488342, z: -50.010345},
        {x: 1813.834473, y: 459.959991, z: -15.104905},
        {x: 1663.4552, y: 484.758118, z: -14.356406},
        {x: 1471.032227, y: 249.392349, z: -13.450007},
        {x: 1621.214478, y: 299.096039, z: -13.499999},
        {x: 2095.886719, y: 127.93367, z: 65.395012},
        {x: 2126.287842, y: 96.398514, z: 68.219116},
        {x: 2190.878418, y: 47.915203, z: 82.051041},
        {x: 2275.515869, y: -197.77626, z: 123.868546},
        {x: 2340.632568, y: 89.010338, z: 101.617455},
        {x: 2257.686768, y: 92.458427, z: 107.476624},
        {x: 2566.220947, y: -320.650665, z: 73.724335},
        {x: 2586.015869, y: -270.000366, z: 111.259766},
        {x: 2611.932861, y: -118.380798, z: 78.657829},
        {x: 2627.0979, y: -353.291534, z: 54.281822},
        {x: 2557.187012, y: -473.99765, z: 38.039154},
        {x: 2207.176758, y: -140.307083, z: 110.950958},
        {x: 2445.0354, y: -90.399239, z: 81.144455},
        {x: 2641.106201, y: 19.898474, z: 77.844978},
        {x: 2754.306885, y: 54.398102, z: 155.685226},
        {x: 2827.14502, y: -247.502319, z: 174.152115},
        {x: 2812.751465, y: -399.406677, z: 8.343157},
        {x: 2835.240234, y: -468.195343, z: -8.296781},
        {x: 2255.370117, y: -405.052429, z: 76.878876},
        {x: 2133.05127, y: -202.810349, z: 101.588875}
      ],
      [ESpot.SPINEL_VEIN]: [
        {x: 1253.586548, y: 1923.611938, z: 265.634888},
        {x: 1383.442261, y: 1787.771851, z: 249.151886},
        {x: 1471.067871, y: 2152.15332, z: 390.416443},
        {x: 1495.410156, y: 1960.119263, z: 243.002136},
        {x: 1450.398193, y: 1978.807251, z: 249.758026},
        {x: 1530.158691, y: 1904.619751, z: 243.151993},
        {x: 1549.325317, y: 1845.001343, z: 250.817612},
        {x: 1623.29834, y: 1826.999512, z: 243.509476},
        {x: 2156.470947, y: 1771.133423, z: 242.368118},
        {x: 2178.770752, y: 1821.472778, z: 247.217361},
        {x: 2316.80249, y: 1825.936523, z: 241.479996},
        {x: 2274.407959, y: 2143.434814, z: 237.180801},
        {x: 2264.284668, y: 1928.54187, z: 245.468201},
        {x: 2249.291504, y: 1846.114624, z: 247.160004},
        {x: 2141.29, y: 1883.97, z: 242.979},
        {x: 2094.766846, y: 745.112793, z: 49.711182},
        {x: 2317.234863, y: 985.097351, z: -86.151001},
        {x: 2178.942871, y: 993.693481, z: -112.452347},
        {x: 2009.023438, y: 1063.238159, z: -157.873184},
        {x: 1938.396362, y: 1025.694824, z: -95.599144},
        {x: 1702.655884, y: 1034.350952, z: -32.902515},
        {x: 1710.096313, y: 953.257141, z: -95.544952},
        {x: 1569.748047, y: 1024.607788, z: -100.580803},
        {x: 1475.511353, y: 1061.965332, z: -111.872032},
        {x: 1448.341675, y: 1161.197632, z: 0.733943},
        {x: 1468.953735, y: 1150.688354, z: -20.840435},
        {x: 1312.029297, y: 956.718201, z: -24.933512},
        {x: 1547.408081, y: 971.737549, z: -51.233238},
        {x: 1687.093872, y: 912.812988, z: -57.200508},
        {x: 1811.334351, y: 1001.3974, z: -13.499999},
        {x: 1853.163696, y: 1063.921631, z: -21.638395},
        {x: 2107.572021, y: 1223.437256, z: 0.121586},
        {x: 2440.013184, y: 1004.71637, z: -57.820061},
        {x: 2402.101807, y: 964.947205, z: -128.171463},
        {x: 2676.418701, y: 971.500916, z: -45.660763},
        {x: 3013.134521, y: 939.66748, z: -79.972206},
        {x: 2515.788574, y: 1057.310303, z: -13.499999},
        {x: 2335.396729, y: 1091.115356, z: -13.499999},
        {x: 2067.434082, y: 1175.343262, z: -13.499999},
        {x: 1998.884888, y: 1077.781616, z: -145.758743},
        {x: 1772.725464, y: 652.552002, z: 245.471329},
        {x: 1867.048584, y: 618.078247, z: 245.401947},
        {x: 1852.054565, y: 719.160645, z: 254.71936},
        {x: 1781.131348, y: 664.319824, z: 249.609055},
        {x: 1682.307983, y: 1123.607056, z: -7.159999},
        {x: 1934.148804, y: 426.702301, z: -121.917175},
        {x: 1753.854736, y: 403.279388, z: -125.137695},
        {x: 2118.727783, y: 545.688354, z: -13.499999},
        {x: 1463.265015, y: 459.423004, z: -108.368217},
        {x: 1588.890137, y: 558.63855, z: -4.822508},
        {x: 2314.825195, y: 762.117004, z: -58.783714},
        {x: 2143.368652, y: 392.434387, z: -13.003901},
        {x: 2635.75415, y: 843.443237, z: -13.499999},
        {x: 2864.636963, y: 935.566528, z: -61.973763},
        {x: 3078.608643, y: 930.195435, z: -51.989071},
        {x: 3282.968994, y: 1035.386963, z: -1.108931},
        {x: 3420.737549, y: 755.290771, z: -13.397484},
        {x: 3307.165283, y: 707.427246, z: 68.562187},
        {x: 3238.405762, y: 729.89032, z: 30.619999},
        {x: 2760.62207, y: 459.204071, z: 336.432495},
        {x: 1901.441895, y: 1008.42981, z: -47.309097},
        {x: 1598.609375, y: 1022.760559, z: -0.865273},
        {x: 1534.252686, y: 1187.244629, z: 5.851898},
        {x: 1838.994629, y: 1058.482788, z: -22.507568},
        {x: 2471.273926, y: 878.177063, z: -13.512184},
        {x: 1435.941406, y: 1121.754272, z: -13.499999},
        {x: 1600.907227, y: 884.710754, z: -13.499999},
        {x: 1622.194946, y: 1025.018799, z: -13.499999},
        {x: 1577.411133, y: 1148.069946, z: -13.499986},
        {x: 1918.645264, y: 895.593933, z: -13.499999},
        {x: 1865.084351, y: 1128.988647, z: -7.652311},
        {x: 1944.350342, y: 1120.410522, z: -47.428116},
        {x: 1989.949463, y: 997.684448, z: -89.255112},
        {x: 2341.35498, y: 1029.353882, z: -13.499999},
        {x: 2290.189209, y: 546.024841, z: -25.345844},
        {x: 2192.200195, y: 389.782959, z: -13.418316},
        {x: 1874.047485, y: 329.289856, z: -14.965822},
        {x: 1964.253174, y: 295.705719, z: 4.14261},
        {x: 2240.70752, y: 776.096985, z: 17.224981},
        {x: 2077.756348, y: 984.194031, z: -76.917068}
      ],
      [ESpot.BAUXITE_VEIN]: [
        {x: 681.389771, y: 360.497711, z: 33.065289},
        {x: 193.535599, y: -507.244751, z: 28.542974},
        {x: 183.762497, y: -294.155365, z: 16.655586},
        {x: 198.250824, y: -106.40892, z: 2.492949},
        {x: 250.630402, y: 143.207947, z: 89.492004},
        {x: 283.222229, y: 160.661804, z: 51.490303},
        {x: 312.3927, y: 171.660828, z: 51.43},
        {x: 448.151855, y: 231.033585, z: 54.484333},
        {x: 499.010956, y: 404.002869, z: 52.267895},
        {x: 542.699402, y: 460.776306, z: 49.511986},
        {x: 458.06778, y: 207.888031, z: 42.171951},
        {x: 227.411682, y: 193.234695, z: 63.877663},
        {x: 37.005497, y: -166.168198, z: -0.284974},
        {x: 36.381409, y: -325.529877, z: 6.95303},
        {x: -32.974998, y: -408.322418, z: 8.301756},
        {x: -133.863602, y: -317.007721, z: 8.086108},
        {x: 490.446075, y: 709.13208, z: -91.02359},
        {x: 527.811951, y: 567.71051, z: -156.039673},
        {x: 513.745117, y: 598.46875, z: -399.994934},
        {x: 678.047241, y: 650.671936, z: -324.697571},
        {x: 905.393066, y: 506.823914, z: 1.73},
        {x: 883.644409, y: 699.432312, z: -54.204037},
        {x: 367.662354, y: 630.254883, z: -12.845798},
        {x: 676.176331, y: 673.653809, z: -80.169907},
        {x: 809.47467, y: 695.957947, z: -131.533035},
        {x: 697.371704, y: 538.864746, z: -142.128906},
        {x: 539.145142, y: 770.897522, z: -9.617008},
        {x: 1043.62793, y: 574.269592, z: -141.830002},
        {x: 939.5625, y: 729.089355, z: -46.229996},
        {x: 550.736511, y: 699.090515, z: -274.197357},
        {x: 440.209717, y: 616.352539, z: -167.264008},
        {x: 479.785156, y: 408.473907, z: -12.632492},
        {x: -89.830345, y: 205.319366, z: 92.572372},
        {x: 238.290344, y: 175.090439, z: 87.857208},
        {x: 632.441589, y: 294.720856, z: 32.089336},
        {x: 526.708923, y: 291.266571, z: 37.080845},
        {x: 126.633347, y: 100.883957, z: 54.480896},
        {x: 56.722847, y: 64.635674, z: 30.016762},
        {x: 67.169083, y: -275.24176, z: -0.456588},
        {x: 54.499195, y: -388.750336, z: 0.888424},
        {x: -121.808456, y: 252.939972, z: 96.610374},
        {x: 185.563446, y: 26.087051, z: 15.950843},
        {x: 178.181061, y: -191.475998, z: 8.369425},
        {x: 226.35199, y: -207.901505, z: 20.982706},
        {x: 347.341095, y: 34.715748, z: 51.180984},
        {x: 398.746521, y: -189.350571, z: 24.369135},
        {x: 530.262451, y: -254.643845, z: 23.052797},
        {x: 1111.783325, y: -318.685181, z: 26.877645},
        {x: 1339.443726, y: -149.28978, z: 40.053017},
        {x: 83.060471, y: -352.003357, z: 6.070511},
        {x: 157.900024, y: 187.334457, z: 87.32122},
        {x: 150.199982, y: 167.493011, z: 91.515396},
        {x: 348.648865, y: 244.297562, z: 50.89246},
        {x: 683.167236, y: 381.150513, z: -9.039999},
        {x: 50.405201, y: 171.040268, z: 102.664398},
        {x: 143.494171, y: -222.147491, z: 18.708649},
        {x: 490.087463, y: 1069.358154, z: 101.150322},
        {x: 289.071198, y: 917.325928, z: 54.955765},
        {x: 367.465668, y: 838.064575, z: 102.212608},
        {x: 240.435104, y: 635.234558, z: 63.303307},
        {x: 234.214966, y: 217.422272, z: 55.342159},
        {x: 397.670563, y: 406.236084, z: 47.171894},
        {x: 400.101349, y: 286.389343, z: 54.512184},
        {x: 592.110535, y: 350.122192, z: 44.706924},
        {x: 479.939209, y: 226.318222, z: 39.086601},
        {x: 171.265045, y: 16.921366, z: 25.963533},
        {x: -147.531693, y: -208.580399, z: 0.917661},
        {x: -184.823532, y: -310.996735, z: 17.68265},
        {x: 132.898926, y: -177.057251, z: 1.699538},
        {x: 58.250965, y: -49.590851, z: 7.765228},
        {x: 308.244202, y: 50.152794, z: 57.738316},
        {x: 334.35141, y: 418.959076, z: 56.258396},
        {x: 411.858398, y: 584.05957, z: -36.455868},
        {x: 529.067627, y: 694.027649, z: -83.154083},
        {x: 493.30954, y: 500.603912, z: -88.551346},
        {x: 384.566284, y: 505.289276, z: -10.53921},
        {x: 361.797363, y: 639.612915, z: 2.243245},
        {x: 296.25119, y: 632.974182, z: 65.80024},
        {x: 310.728485, y: 480.764557, z: 65.144676}
      ],
      [ESpot.LIMONITE_VEIN]: [
        {x: -1727.51062, y: 387.802856, z: 204.029953},
        {x: -1567.487305, y: 366.629761, z: 186.752838},
        {x: -1580.300049, y: 268.184662, z: 184.653015},
        {x: -1639.047241, y: 514.214783, z: 266.639771},
        {x: -1546.429688, y: 571.210144, z: 222.099945},
        {x: -1439.264526, y: 735.481445, z: 295.410583},
        {x: -1435.51355, y: 780.253113, z: 272.105164},
        {x: -1317.149902, y: 732.088928, z: 219.728668},
        {x: -1326.093628, y: 772.904663, z: 202.533798},
        {x: -1384.207397, y: 811.921936, z: 213.312317},
        {x: -2067.569824, y: 254.441467, z: 172.445267},
        {x: -2144.17334, y: 330.490662, z: 248.411087},
        {x: -2146.259766, y: 478.458618, z: 298.195953},
        {x: -1848.348022, y: 381.167542, z: 105.385551},
        {x: -1664.893066, y: 149.841003, z: 100.139992},
        {x: -1989.521851, y: 145.252731, z: 96.779999},
        {x: -2014.401855, y: 69.120514, z: 140.876526},
        {x: -2088.959961, y: 33.070816, z: 121.658821},
        {x: -2160.838379, y: -46.713593, z: 121.434624},
        {x: -2199.612305, y: 28.420221, z: 153.520294},
        {x: -1815.024902, y: 265.52713, z: 94.853317},
        {x: -1920.187012, y: 376.253479, z: 100.415672},
        {x: -1787.312134, y: 474.977753, z: 110.608513},
        {x: -1403.354858, y: 658.076172, z: 296.790894},
        {x: -2259.268555, y: 147.709381, z: 142.659988},
        {x: -2181.824219, y: -39.398876, z: 145.477325},
        {x: -1916.109497, y: -133.17717, z: 26.554388},
        {x: -2081.888916, y: 384.220642, z: 245.985901},
        {x: -2065.495117, y: 712.232727, z: 144.89325},
        {x: -2028.106567, y: 746.14679, z: 137.395615},
        {x: -1571.24939, y: 643.998352, z: 175.843445},
        {x: -1502.981445, y: 242.626862, z: 148.368774},
        {x: -1086.014648, y: 254.531845, z: 107.90081},
        {x: -1393.551392, y: 378.634888, z: 215.610931},
        {x: -953.346924, y: 291.09137, z: 150.880371},
        {x: -816.750183, y: -94.275993, z: -40.245838},
        {x: -1034.941528, y: 196.058289, z: 51.18729},
        {x: -759.832336, y: 38.619293, z: 78.616356},
        {x: -716.58606, y: 51.896835, z: 47.759995},
        {x: -1050.930786, y: 111.400925, z: 2.089428},
        {x: -861.327515, y: -12.326283, z: 6.909589},
        {x: -1088.583252, y: 31.993551, z: 113.850716},
        {x: -1076.353638, y: -66.902733, z: 98.599991},
        {x: -1086.930664, y: -220.030228, z: 173.68158},
        {x: -1082.92395, y: -246.951324, z: 305.908508},
        {x: -561.022278, y: -205.09935, z: 54.18095},
        {x: -730.022705, y: -190.369278, z: 52.007553},
        {x: -625.995972, y: -102.893623, z: 55.76218},
        {x: -677.279236, y: -63.498711, z: 52.559784},
        {x: -771.744385, y: -1.387914, z: 50.49749},
        {x: -839.880371, y: -67.441704, z: 26.542143},
        {x: -551.106018, y: -140.07045, z: 53.418087},
        {x: -1299.595337, y: 510.514435, z: 261.936218},
        {x: -2343.634766, y: 525.662964, z: 136.746536},
        {x: -2199.425293, y: 465.980316, z: 243.221527},
        {x: -2259.788818, y: 402.99823, z: 217.295029},
        {x: -2150.313477, y: 502.491333, z: 271.544708},
        {x: -1989.675415, y: 307.882385, z: 170.348068},
        {x: -1976.677246, y: 235.109146, z: 169.052979},
        {x: -1556.67334, y: 139.69278, z: 67.835976},
        {x: -1902.361694, y: 539.835449, z: 97.733109},
        {x: -2003.568726, y: 181.484665, z: 143.006424},
        {x: -1585.494385, y: 756.753113, z: 217.12677},
        {x: -1634.025757, y: 541.917664, z: 180.549957},
        {x: -1959.338745, y: 426.351379, z: 108.980003},
        {x: -1967.761353, y: 527.485352, z: 107.889854},
        {x: -2233.313721, y: 749.975403, z: 89.46183},
        {x: -1809.101562, y: 608.142578, z: 108.986511},
        {x: -2018.80835, y: 582.275146, z: 92.747681},
        {x: -2077.566895, y: 672.843201, z: 128.515167},
        {x: -1696.834595, y: 221.239334, z: 128.886017},
        {x: -1881.054321, y: 388.360352, z: 105.148407},
        {x: -1590.648438, y: 722.791138, z: 175.525528},
        {x: -1568.230957, y: 790.838562, z: 216.513382},
        {x: -1447.074341, y: 803.795776, z: 252.287964},
        {x: -1518.259888, y: 624.936035, z: 222.07486},
        {x: -2015.365356, y: 533.002808, z: 110.218643},
        {x: -2078.188477, y: 683.915894, z: 91.095352},
        {x: -1766.39563, y: 211.838669, z: 93.29554},
        {x: -2073.637939, y: 787.596497, z: 108.256256}
      ],
      [ESpot.AMETRINE_VEIN]: [
        {x: -339.143585, y: 1308.401855, z: 47.1035},
        {x: -847.944153, y: 1463.186523, z: 273.849731},
        {x: -1060.362305, y: 1501.206543, z: 446.677734},
        {x: -1088.633545, y: 1578.567383, z: 469.030579},
        {x: -942.289307, y: 1409.964233, z: 366.696136},
        {x: -1022.96228, y: 1670.677368, z: 334.07608},
        {x: -1063.232788, y: 1616.275635, z: 418.612427},
        {x: -1357.220947, y: 1277.799561, z: 425.86322},
        {x: -1209.279297, y: 1201.944092, z: 489.033691},
        {x: -1144.238037, y: 936.357666, z: -121.9534},
        {x: -1036.94751, y: 998.418335, z: 221.991287},
        {x: -1084.185547, y: 872.150757, z: 228.736481},
        {x: -745.651306, y: 1158.202637, z: 126.950546},
        {x: -1151.951172, y: 992.375793, z: 308.346222},
        {x: -1138.747437, y: 897.76825, z: 295.489685},
        {x: -1240.47229, y: 1129.027344, z: 517.89325},
        {x: -737.260681, y: 1168.092651, z: 135.764465},
        {x: 825.549622, y: 4024.865967, z: 42.521347},
        {x: 764.850647, y: 4114.810547, z: 4.107366},
        {x: 455.623627, y: 3779.532959, z: 0.26},
        {x: 470.587158, y: 4278.349121, z: 21.720695},
        {x: 376.442535, y: 4127.870605, z: 2.144818},
        {x: 355.992432, y: 3926.688232, z: 6.925773},
        {x: 729.469666, y: 3950.95459, z: 0.691388},
        {x: 572.605835, y: 3439.504883, z: -0.05765},
        {x: 322.474792, y: 3388.98877, z: 0.663741},
        {x: 552.896545, y: 2827.807129, z: 0.956751},
        {x: 629.181152, y: 2770.380371, z: 77.022087},
        {x: 724.299133, y: 2823.515869, z: 248.838852},
        {x: 760.810486, y: 2760.700684, z: 355.542236},
        {x: 766.082031, y: 2810.112549, z: 306.172272},
        {x: 681.297974, y: 3022.011963, z: 178.758286},
        {x: 413.151611, y: 2861.851562, z: 116.917061},
        {x: 285.718689, y: 2819.874512, z: 192.867203},
        {x: 449.101227, y: 2987.143799, z: 284.156525},
        {x: 152.54126, y: 2825.161865, z: 284.034302},
        {x: 602.485962, y: 3019.525879, z: 82.486473},
        {x: 1066.819946, y: 2590.645752, z: 568.724609},
        {x: 1120.667114, y: 2686.562256, z: 494.572723},
        {x: 1035.791626, y: 3172.040039, z: 167.306244},
        {x: 796.292847, y: 3127.667969, z: 169.585861},
        {x: 528.182922, y: 3081.232666, z: 31.986242},
        {x: 791.237671, y: 3410.962158, z: 0.183649},
        {x: 772.144287, y: 2717.770508, z: 383.058319},
        {x: 423.960541, y: 2402.960693, z: -0.657323},
        {x: 548.499939, y: 2588.612793, z: 30.504862},
        {x: 191.625687, y: 2927.206787, z: 243.237961},
        {x: 521.006775, y: 2977.526855, z: 20.424456},
        {x: 626.700317, y: 2974.720215, z: 12.213234},
        {x: 707.503967, y: 2922.807617, z: 29.816084},
        {x: 1012.279419, y: 2751.984863, z: 398.574646},
        {x: -403.714508, y: 1256.06665, z: 141.079895},
        {x: -463.055664, y: 1342.804199, z: 36.882812},
        {x: -1244.652466, y: 1338.501709, z: 454.180328},
        {x: -1292.734497, y: 1660.540161, z: 599.585266},
        {x: -853.91864, y: 1416.787109, z: 311.340302},
        {x: -604.447144, y: 1180.651489, z: 208.438675},
        {x: -524.101746, y: 794.425964, z: 282.525574},
        {x: -521.462463, y: 822.470764, z: 274.486206},
        {x: -680.279602, y: 1039.060059, z: 225.622559},
        {x: -393.722168, y: 975.892578, z: 256.897705},
        {x: -479.669922, y: 995.618774, z: 230.052094},
        {x: -387.198975, y: 1090.726685, z: 207.321838},
        {x: -522.484558, y: 1177.607178, z: 195.914841},
        {x: -533.00061, y: 1321.729614, z: 42.209473},
        {x: -794.116699, y: 1250.358643, z: 269.787903},
        {x: -817.473083, y: 1406.518921, z: 295.550842},
        {x: -1503.901001, y: 1614.046021, z: 347.049225},
        {x: 488.122101, y: 2423.435059, z: 16.563671},
        {x: 234.68576, y: 2282.949951, z: 9.860408},
        {x: 474.731201, y: 2660.039551, z: 40.369305},
        {x: 596.445984, y: 2700.317871, z: 24.596764},
        {x: 564.304932, y: 2733.958496, z: 20.216747},
        {x: 535.570007, y: 2839.976562, z: 58.422672},
        {x: 403.836243, y: 2890.620605, z: 31.101452},
        {x: 498.011078, y: 2916.682129, z: 30.981194},
        {x: 685.395447, y: 2900.178955, z: 1.329648},
        {x: 707.510071, y: 2912.854004, z: 57.107815},
        {x: 554.148865, y: 3299.923828, z: 0.587503},
        {x: 146.489014, y: 3262.878906, z: 98.883652},
        {x: 327.828003, y: 3937.225586, z: 0.938375},
        {x: 725.37677, y: 3948.12207, z: 21.3927},
        {x: 792.921875, y: 3958.366943, z: 59.914959},
        {x: 719.8573, y: 4106.185547, z: 60.811951},
        {x: 550.838135, y: 4075.194336, z: 95.004936},
        {x: 617.409607, y: 3716.62793, z: 0.918586},
        {x: -1162.758057, y: 939.206604, z: 325.68692},
        {x: -1105.842285, y: 1182.623169, z: 424.641998},
        {x: -1020.156738, y: 990.244202, z: 191.17334},
        {x: -1067.199707, y: 889.173584, z: 178.75798}
      ],
      [ESpot.JADE_VEIN]: [
        {x: 2920.403564, y: 359.419281, z: 175.43364},
        {x: 2831.893066, y: 330.361359, z: 165.456039},
        {x: 2761.011475, y: 358.784119, z: 221.174026},
        {x: 2828.587891, y: 416.980438, z: 234.365845},
        {x: 2939.763184, y: 416.367371, z: 191.798248},
        {x: 2982.364746, y: 445.534119, z: 160.024902},
        {x: 3155.676758, y: 488.326263, z: 124.719559},
        {x: 3162.014893, y: 457.995361, z: 116.226624},
        {x: 3259.789551, y: 487.471375, z: 83.051414},
        {x: 3270.316895, y: 509.401581, z: 82.686401},
        {x: 3185.806885, y: 603.518677, z: 110.096687},
        {x: 3324.963379, y: 514.818176, z: 72.788872},
        {x: 3257.824219, y: 584.937744, z: 70.035095},
        {x: 3230.459473, y: 654.995178, z: 77.349098},
        {x: 3390.445801, y: 494.035645, z: 72.831543},
        {x: 3228.894775, y: 504.109039, z: 99.267433},
        {x: 3197.130371, y: 530.36438, z: 119.721596},
        {x: 3039.685791, y: 283.1138, z: 135.42894},
        {x: 2885.176758, y: 337.364807, z: 137.494797},
        {x: 3174.846924, y: 268.235107, z: 135.044434},
        {x: 3345.012695, y: 59.349052, z: 74.357353},
        {x: 3399.947021, y: -190.690872, z: 78.714119},
        {x: 3466.725342, y: -302.186432, z: 98.454277},
        {x: 3331.131592, y: -294.527466, z: 158.324051},
        {x: 3433.259766, y: -173.449951, z: 111.509933},
        {x: 3623.699707, y: 246.901627, z: 104.842453},
        {x: 3675.526123, y: 511.40979, z: 61.109314},
        {x: 3515.273193, y: 572.784912, z: 180.097794},
        {x: 3475.342529, y: 504.0289, z: 119.208122},
        {x: 3418.577637, y: 383.096619, z: 72.554359},
        {x: 3187.764404, y: 276.960541, z: 121.156555},
        {x: 3005.340576, y: 258.996368, z: 139.484894},
        {x: 2956.518311, y: 241.199203, z: 100.936539},
        {x: 2887.739502, y: 146.681274, z: 122.98053},
        {x: 2946.917725, y: 427.624054, z: 135.190002},
        {x: 3076.658447, y: 386.512726, z: 137.009995},
        {x: 3038.658447, y: -44.066311, z: 118.656769},
        {x: 3140.488525, y: -12.48058, z: 92.144272},
        {x: 3364.003662, y: -237.03685, z: 119.304771},
        {x: 3448.460205, y: -145.180099, z: 106.135521},
        {x: 3428.536133, y: -331.787048, z: 125.19725},
        {x: 3435.881104, y: -306.554993, z: 68.284065},
        {x: 3394.76416, y: -285.316254, z: 69.531319},
        {x: 3308.552734, y: 97.238319, z: 74.143883},
        {x: 3468.379639, y: 298.073792, z: 73.316864},
        {x: 3531.105713, y: 693.30011, z: 92.945343},
        {x: 3267.980225, y: 584.828552, z: 74.066948},
        {x: 3042.0979, y: 354.179749, z: 133.737183},
        {x: 3013.425049, y: 440.329681, z: 141.518356},
        {x: 3151.646729, y: -85.042084, z: 102.635445},
        {x: 3057.467041, y: -114.836746, z: 170.659653},
        {x: 2953.856445, y: -162.586441, z: 138.812561},
        {x: 3404.154541, y: -146.070572, z: 77.433853},
        {x: 3411.407959, y: -74.520676, z: 69.282806},
        {x: 3490.024658, y: -14.31355, z: 70.490822},
        {x: 3538.482422, y: 107.16848, z: 71.362808},
        {x: 3556.28833, y: 242.123581, z: 76.29525},
        {x: 3344.927002, y: 699.963379, z: 75.119362},
        {x: 3227.632812, y: 144.666687, z: 77.590767},
        {x: 3263.973145, y: -134.135025, z: 89.65184},
        {x: 3508.61792, y: 379.025269, z: 86.939354},
        {x: 3265.696533, y: 440.566833, z: 89.56356},
        {x: 3280.376953, y: 337.337494, z: 90.95388},
        {x: 2913.91, y: 462.14, z: 250.81},
        {x: 3090.37915, y: 222.840286, z: 129.011749},
        {x: 3019.56, y: 462.71, z: 180.7},
        {x: 2964.974121, y: 445.865814, z: 192.896057},
        {x: 2999.31, y: 575.02, z: 203.8},
        {x: 3257.779785, y: 413.989075, z: 114.119804},
        {x: 3370.462158, y: 421.414368, z: 74.848534},
        {x: 3448.595947, y: 332.867462, z: 73.409615},
        {x: 3546.705078, y: 364.85144, z: 111.295914},
        {x: 3624.62, y: 537.06, z: 185.05},
        {x: 3371.67749, y: 759.767456, z: 2.06764},
        {x: 3127.234863, y: 447.590729, z: 133.328903},
        {x: 2857.945801, y: 321.72345, z: 138.76799},
        {x: 2915.084961, y: 168.434982, z: 151.632477},
        {x: 3199.774902, y: 503.981049, z: 112.664726},
        {x: 3356.051025, y: 484.442047, z: 73.965897},
        {x: 3425.567139, y: 618.297913, z: 76.452827}
      ],
      [ESpot.RHYOLITE_VEIN]: [
        {x: -2764.114502, y: -1442.684814, z: 175.256012},
        {x: -2693.73291, y: -1442.730225, z: 219.722153},
        {x: -2879.420898, y: -1564.506958, z: 75.066864},
        {x: -2583.792969, y: -1309.391113, z: 61.543785},
        {x: -2509.706787, y: -1368.510254, z: 73.091026},
        {x: -2765.502197, y: -1188.498535, z: 139.674408},
        {x: -2819.350586, y: -1138.359253, z: 140.296066},
        {x: -2947.55127, y: -1196.296265, z: 160.543594},
        {x: -2923.101562, y: -1199.503784, z: 159.879776},
        {x: -2924.719482, y: -1345.100098, z: 173.884811},
        {x: -2902.914795, y: -1457.070679, z: 191.573563},
        {x: -2958.552002, y: -1589.675537, z: 171.377045},
        {x: -2659.802979, y: -1429.74292, z: 186.115555},
        {x: -2929.512939, y: -277.106628, z: 256.315948},
        {x: -2686.970947, y: -257.911407, z: 220.848343},
        {x: -2750.998291, y: -289.319061, z: 226.190979},
        {x: -3062.931641, y: -353.466736, z: 256.245331},
        {x: -2958.237061, y: -366.732086, z: 211.244019},
        {x: -2679.169189, y: -425.672119, z: 148.827911},
        {x: -2628.629639, y: -368.97168, z: 136.968903},
        {x: -2546.151123, y: -265.999146, z: 122.57373},
        {x: -2444.849854, y: -249.484711, z: 138.960205},
        {x: -2073.736328, y: -796.679565, z: 201.313919},
        {x: -1981.266113, y: -870.231567, z: 179.745163},
        {x: -2093.034668, y: -1229.614746, z: 186.784378},
        {x: -2078.989746, y: -1034.079468, z: 167.418335},
        {x: -2094.776855, y: -1120.817993, z: 160.697144},
        {x: -2101.783936, y: -1379.734253, z: 161.395248},
        {x: -2198.742188, y: -1481.586792, z: 159.51004},
        {x: -2134.790039, y: -1072.464233, z: 157.420288},
        {x: -2132.436035, y: -1248.099487, z: 178.876022},
        {x: -2174.235107, y: -1460.304443, z: 161.445419},
        {x: -2307.895996, y: -1728.292969, z: 135.576309},
        {x: -2315.046631, y: -1516.431152, z: 113.379494},
        {x: -2917.552246, y: -651.205566, z: 144.523834},
        {x: -2876.830322, y: -297.750702, z: 227.8396},
        {x: -2752.675537, y: -263.888184, z: 233.370499},
        {x: -2741.19458, y: -315.207306, z: 212.873383},
        {x: -2663.696777, y: -433.104156, z: 127.307747},
        {x: -2387.608398, y: -337.677643, z: 114.080345},
        {x: -2454.036377, y: -376.432922, z: 119.094017},
        {x: -2375.664795, y: -650.483459, z: 91.841095},
        {x: -2428.801758, y: -718.13739, z: 89.651062},
        {x: -2186.594238, y: -688.637573, z: 185.999985},
        {x: -1921.382568, y: -959.568176, z: 123.106384},
        {x: -2080.532471, y: -1378.307373, z: 169.923279},
        {x: -2143.709961, y: -1579.630981, z: 176.050735},
        {x: -2447.292236, y: -1182.251221, z: 99.091728},
        {x: -2938.668213, y: -1318.739624, z: 165.167801},
        {x: -2436.111572, y: -108.358345, z: 142.056091},
        {x: -2685.948975, y: -669.319641, z: 135.216217},
        {x: -2553.610596, y: -770.105103, z: 117.816696},
        {x: -2581.524658, y: -969.973267, z: 119.444275},
        {x: -2469.249512, y: -1310.747314, z: 84.625107},
        {x: -2857.047119, y: -1564.216431, z: 83.568047},
        {x: -2794.181396, y: -1491.438477, z: 100.606056},
        {x: -2883.199219, y: -1317.060303, z: 141.71788},
        {x: -2667.508057, y: -1300.464478, z: 119.537392},
        {x: -2255.725586, y: -1016.580383, z: 101.650764},
        {x: -2172.142822, y: -966.157166, z: 112.210808},
        {x: -2378.965332, y: -501.460815, z: 92.7556},
        {x: -2454.056152, y: -419.040863, z: 117.876923},
        {x: -2846.780762, y: -310.515625, z: 233.922729},
        {x: -2749.838623, y: -1280.103149, z: 146.237015},
        {x: -2797.236328, y: -1378.158691, z: 117.327461},
        {x: -2682.918213, y: -1570.142456, z: 160.401535},
        {x: -2959.25, y: -1508.105103, z: 214.339523},
        {x: -2185.401611, y: -1048.112183, z: 133.417038},
        {x: -2293.402832, y: -423.982544, z: 90.569992}
      ],
      [ESpot.CORUNDUM_VEIN]: [
        {x: -1941.948242, y: -1474.171509, z: 171.999725},
        {x: -1779.251709, y: -1682.033691, z: 182.268967},
        {x: -1989.638306, y: -1680.362183, z: 185.531555},
        {x: -1854.897827, y: -1443.248901, z: 62.938381},
        {x: -1692.824219, y: -1500.352905, z: 50.079952},
        {x: -1546.381714, y: -1258.802246, z: 73.475365},
        {x: -1498.011841, y: -1409.532349, z: 58.010212},
        {x: -1504.911987, y: -1464.97644, z: 104.453911},
        {x: -1469.037598, y: -1268.934204, z: 41.153336},
        {x: -1210.692505, y: -700.321838, z: 36.269997},
        {x: -1215.645996, y: -380.52301, z: 171.657639},
        {x: -1851.303833, y: -115.833786, z: 15.55},
        {x: -2202.584229, y: -13.481461, z: 156.971786},
        {x: -2142.663818, y: -344.403748, z: 49.105183},
        {x: -1819.843994, y: -410.306519, z: 11.800283},
        {x: -1564.35022, y: -329.802063, z: 108.538307},
        {x: -1645.341675, y: -414.984039, z: 59.237637},
        {x: -2259.072266, y: 147.788574, z: 142.659988},
        {x: -2247.552979, y: -49.952114, z: 160.446838},
        {x: -1993.606079, y: -199.200592, z: 39.958889},
        {x: -1691.780151, y: -356.183258, z: 57.145374},
        {x: -1642.395264, y: -733.540527, z: 60.489697},
        {x: -1567.356201, y: -775.027161, z: 69.643547},
        {x: -1574.789917, y: -1004.867615, z: 149.599106},
        {x: -1122.566284, y: -1176.102417, z: -56.254807},
        {x: -2145.215576, y: 20.629419, z: 149.425964},
        {x: -1997.271118, y: -187.952637, z: 19.612907},
        {x: -1942.457764, y: -139.963852, z: 12.826054},
        {x: -1624.124878, y: -400.357147, z: 51.770554},
        {x: -1749.254639, y: -507.416229, z: 16.451571},
        {x: -2003.793213, y: -713.916382, z: 59.934502},
        {x: -1836.90918, y: -923.41333, z: 52.562248},
        {x: -1968.191895, y: -1033.130127, z: 105.149994},
        {x: -1987.25415, y: -1199.906616, z: 58.531979},
        {x: -1925.127563, y: -1124.346436, z: 42.591564},
        {x: -1815.234863, y: -1257.240234, z: 56.882706},
        {x: -1879.268921, y: -1243.754395, z: 40.732117},
        {x: -1711.587891, y: -1268.396362, z: 99.42643},
        {x: -1619.020996, y: -1407.628052, z: 82.677452},
        {x: -1676.593994, y: -1393.490845, z: 49.550076},
        {x: -1827.287109, y: -1506.061401, z: 63.696674},
        {x: -1456.639893, y: -818.343628, z: 16.616611},
        {x: -1485.265503, y: -928.509766, z: -19.54332},
        {x: -1111.325073, y: -1084.151855, z: -102.80616},
        {x: -1245.117188, y: -1359.094604, z: -72.723587},
        {x: -1232.034546, y: -910.934753, z: -66.245773},
        {x: -1636.855835, y: -821.606812, z: 93.445633},
        {x: -1609.05188, y: -703.832336, z: 35.596878},
        {x: -1996.661255, y: -872.634949, z: 95.838676},
        {x: -2093.561279, y: -1076.564087, z: 181.875198},
        {x: -1819.74585, y: -222.049896, z: 11.225136},
        {x: -1845.98291, y: -293.942566, z: 10.540156},
        {x: -1927.741577, y: -437.545715, z: 9.851808},
        {x: -1995.032959, y: -549.135864, z: 8.793857},
        {x: -2075.123291, y: -454.832642, z: 10.88},
        {x: -2031.528687, y: -485.610199, z: 8.262036},
        {x: -1991.149292, y: -244.569061, z: 14.879383},
        {x: -1818.650757, y: -201.23613, z: 13.561245},
        {x: -2118.287109, y: 129.778625, z: 133.497116},
        {x: -2135.125488, y: -422.482819, z: 47.289997},
        {x: -1966.2948, y: -534.371521, z: 34.682114},
        {x: -1737.078003, y: -9.535253, z: 61.431},
        {x: -1394.37085, y: -134.613037, z: 23.235111},
        {x: -1523.996216, y: -161.474945, z: 23.072836},
        {x: -1936.737549, y: -235.250198, z: 10.46},
        {x: -1932.188232, y: -521.409119, z: 11.051389},
        {x: -1830.57373, y: -577.088074, z: 20.153154},
        {x: -1752.462646, y: -332.120117, z: 48.396},
        {x: -1657.915771, y: -177.774277, z: 27.295071},
        {x: -1576.828491, y: -156.517761, z: 23.447014},
        {x: -1545.511841, y: 20.559868, z: 52.274712},
        {x: -1926.110229, y: -47.496124, z: 30.549999},
        {x: -1949.022461, y: -149.601685, z: 25.180653},
        {x: -1989.132935, y: -276.909241, z: 7.663737},
        {x: -1710.519653, y: -427.239624, z: 51.945789},
        {x: -2103.55542, y: -266.893463, z: 46.970001},
        {x: -2188.915771, y: -292.099365, z: 47.225319},
        {x: -1852.087769, y: -263.625031, z: 10.538406},
        {x: -1822.152222, y: -247.835571, z: 31.353642},
        {x: -1833.059326, y: -157.058136, z: 11.249983}
      ],
    
      // ECategory.HERBALISM
      [ESpot.CHAMPIGNON]: [
        {x: 4834.942383, y: -2002.458008, z: 31.530153},
        {x: 4882.078613, y: -2041.713379, z: 42.948685},
        {x: 4920.633789, y: -1917.362183, z: 30.616247},
        {x: 4958.235352, y: -1873.148071, z: 29.792519},
        {x: 5042.434082, y: -1821.789307, z: 40.484756},
        {x: 5027.946289, y: -1897.895386, z: 29.022038},
        {x: 5057.775879, y: -1887.68103, z: 27.529768},
        {x: 5011.312012, y: -1940.081421, z: 41.061436},
        {x: 5189.293457, y: -2032.456909, z: 33.093269},
        {x: 5248.826172, y: -2040.000122, z: 18.452253},
        {x: 5169.425781, y: -1973.189575, z: 36.084461},
        {x: 5137.303223, y: -1974.863037, z: 35.458916},
        {x: 4886.131348, y: -2055.342529, z: 39.855598},
        {x: 4857.273438, y: -2000.776367, z: 31.679781},
        {x: 4981.850586, y: -2020.564575, z: 44.483974},
        {x: 5013.289551, y: -1982.381104, z: 42.318466},
        {x: 5060.976562, y: -1941.614624, z: 35.122498},
        {x: 5035.328125, y: -1962.953857, z: 44.78352},
        {x: 5110.162598, y: -1990.67688, z: 35.16494},
        {x: 4967.758301, y: -2062.697754, z: 69.846474},
        {x: 4950.893555, y: -1988.94043, z: 42.255077},
        {x: 4811.147949, y: -1851.553101, z: 27.616703},
        {x: 4774.470703, y: -1853.441772, z: 29.822521},
        {x: 4798.503418, y: -1759.295532, z: 27.154057},
        {x: 4832.788086, y: -1764.477905, z: 27.50771},
        {x: 4885.797363, y: -1867.327393, z: 29.674149},
        {x: 5037.974121, y: -1845.143799, z: 38.392899},
        {x: 5118.383789, y: -1874.5448, z: 28.473055},
        {x: 5052.289062, y: -1755.963623, z: 53.600109},
        {x: 4899.660645, y: -1731.037109, z: 37.971924},
        {x: 4787.692871, y: -1882.927124, z: 30.246029},
        {x: 4701.538086, y: -1978.442139, z: 33.108643},
        {x: 4724.774414, y: -2028.508179, z: 33.599651},
        {x: 4791.821777, y: -2017.85083, z: 39.102859},
        {x: 4842.990723, y: -2043.45166, z: 43.455181},
        {x: 4849.746582, y: -2114.548584, z: 62.134907},
        {x: 4931.859863, y: -2141.450195, z: 99.449554},
        {x: 4926.17627, y: -2120.823975, z: 75.474411},
        {x: 4807.619141, y: -1996.434692, z: 40.443371},
        {x: 4852.110352, y: -1953.458984, z: 31.111675},
        {x: 4840.802734, y: -1880.888916, z: 29.593784},
        {x: 4929.366699, y: -1830.584717, z: 28.633747},
        {x: 4964.166016, y: -1819.979614, z: 27.903553},
        {x: 5117.914062, y: -1906.324463, z: 28.565741},
        {x: 5062.665039, y: -1998.830444, z: 55.102585},
        {x: 4932.369629, y: -1719.974365, z: 61.171368},
        {x: 5153.696, y: -1866.176, z: 94.251},
        {x: 4980.876465, y: -1918.94043, z: 41.046143},
        {x: 4918.483887, y: -1998.802124, z: 40.034527},
        {x: 4866.572266, y: -1722.199341, z: 27.191095},
        {x: 5083.916016, y: -1771.533813, z: 37.83091},
        {x: 5109.015625, y: -1841.915283, z: 30.908293},
        {x: 5022.796387, y: -1822.104858, z: 33.305145},
        {x: 4954.147461, y: -1738.952271, z: 57.9221},
        {x: 4989.110352, y: -1851.81897, z: 28.871229},
        {x: 4668.494141, y: -1928.600098, z: 39.213715},
        {x: 4730.164551, y: -1862.786499, z: 35.567543},
        {x: 4815.196777, y: -1758.055176, z: 28.658684},
        {x: 5003.041504, y: -1943.776245, z: 42.446285},
        {x: 5153.639648, y: -2010.998291, z: 55.132656},
        {x: 4854.192871, y: -2059.771973, z: 44.643967},
        {x: 4928.774414, y: -1957.192993, z: 40.237816},
        {x: 4868.430664, y: -1972.148193, z: 38.243343},
        {x: 4959.316895, y: -2034.706543, z: 53.923508},
        {x: 5113.03418, y: -1951.78186, z: 33.876282},
        {x: 4813.047363, y: -1904.921265, z: 30.866211},
        {x: 4876.446289, y: -1929.174805, z: 40.130672},
        {x: 4960.540527, y: -2029.272461, z: 52.149269},
        {x: 5058.115723, y: -1977.192017, z: 45.814949},
        {x: 5197.256348, y: -2039.216431, z: 29.967367},
        {x: 5224.84082, y: -1998.238037, z: 28.802069},
        {x: 5167.623047, y: -1954.959961, z: 39.219559},
        {x: 5171.056152, y: -1965.684937, z: 41.202751},
        {x: 5049.347656, y: -1896.467407, z: 35.604935},
        {x: 4982.180664, y: -1956.526123, z: 41.580181},
        {x: 4732.505859, y: -1938.421631, z: 29.562149},
        {x: 4773.81543, y: -1993.414307, z: 40.881618},
        {x: 5049.183105, y: -1930.920898, z: 43.843899},
        {x: 4942.14209, y: -2047.957886, z: 51.558311},
        {x: 4869.40332, y: -1903.929565, z: 31.675589}
      ],
      [ESpot.ROSEHIP]: [
        {x: 4884.10791, y: -1172.710571, z: 139.696381},
        {x: 4859.544922, y: -1061.671997, z: 126.885193},
        {x: 4765.258301, y: -1147.183716, z: 122.465485},
        {x: 4880.38916, y: -1039.475464, z: 122.444321},
        {x: 5248.395, y: -1495.429, z: -0.027},
        {x: 5893.13, y: -1737.16, z: 0.14},
        {x: 5853.705, y: -1763.764, z: 0.375},
        {x: 5789.169, y: -1759.6, z: 41.709},
        {x: 6234.99, y: -1954.91, z: 1.08},
        {x: 5989.173, y: -1848.57, z: 4.007},
        {x: 6283.553, y: -2161.037, z: 0.39},
        {x: 6325.608, y: -2059.152, z: 70.262},
        {x: 6469.915, y: -2033.61, z: 65.707},
        {x: 6394.18, y: -2202.85, z: 0.15},
        {x: 5991.953, y: -1714.765, z: 26.838},
        {x: 6101.188, y: -1659.971, z: 76.535},
        {x: 6002.866, y: -1658.946, z: 29.518},
        {x: 6040.606, y: -1457.56, z: 71.51},
        {x: 6115.488, y: -1482.394, z: 99.566},
        {x: 6093.203, y: -1411.391, z: 93.892},
        {x: 6207.479, y: -1660.014, z: 142.865},
        {x: 6151.756, y: -1707.375, z: 103.192},
        {x: 6063.929, y: -1434.843, z: 98.636},
        {x: 5989.093, y: -1583.309, z: 0.982},
        {x: 6079.701, y: -1526.008, z: 61.243},
        {x: 6182.143, y: -1615.953, z: 99.847},
        {x: 6123.87, y: -1720.799, z: 80.574},
        {x: 6100.188, y: -1840.163, z: 53.748},
        {x: 6167.883, y: -1824.285, z: 95.026},
        {x: 6375.049, y: -1784.263, z: 276.367},
        {x: 6233.201, y: -1725.269, z: 159.355},
        {x: 6481.49, y: -1787.7, z: 278.55},
        {x: 6348.343262, y: -1535.4729, z: 193.22876},
        {x: 6315.135254, y: -1466.187988, z: 219.044266},
        {x: 6079.078613, y: -1440.651245, z: 97.99395},
        {x: 5957.4, y: -1726.65, z: 0.67},
        {x: 6010.284668, y: -1519.565063, z: 25.68581},
        {x: 6018.815918, y: -1482.722412, z: 48.93018},
        {x: 5719.330078, y: -1486.233032, z: 3.109492},
        {x: 5773.998535, y: -1556.346436, z: 17.916315},
        {x: 5766.441406, y: -1616.629883, z: 9.069999},
        {x: 5808.343262, y: -1624.654419, z: 13.899929},
        {x: 5863.878418, y: -1649.929443, z: 35.478222},
        {x: 5823.982422, y: -1675.869019, z: 24.892151},
        {x: 5841.322266, y: -1549.43103, z: 57.352291},
        {x: 6036.625977, y: -1649.60437, z: 28.134401},
        {x: 5535.059082, y: -2016.148315, z: 9.2},
        {x: 5438.728516, y: -1262.697021, z: 55.566704},
        {x: 5423.442871, y: -1248.120728, z: 53.888958},
        {x: 5453.84375, y: -1200.816284, z: 109.758011},
        {x: 5571.069824, y: -1278.296875, z: 53.740021},
        {x: 5663.358398, y: -1285.0448, z: 4.578335},
        {x: 5659.226074, y: -1190.635864, z: 14.304027},
        {x: 5697.035156, y: -1186.539917, z: 15.158524},
        {x: 5667.352539, y: -1236.27063, z: 10.214156},
        {x: 5604.899902, y: -1284.76355, z: 6.755874},
        {x: 5670.15, y: -1429.96, z: 2.21},
        {x: 5771.230957, y: -1656.210693, z: 1.926665},
        {x: 5257.701172, y: -1489.648804, z: 0.30606},
        {x: 5107.266602, y: -1437.347656, z: 0.497267},
        {x: 4758.737305, y: 102.992599, z: 148.444138},
        {x: 4817.777344, y: 221.700623, z: 160.174789},
        {x: 4848.23291, y: 194.138351, z: 148.329987},
        {x: 4800.001953, y: 160.189163, z: 142.849991},
        {x: 4665.129883, y: 120.0299, z: 152.459015},
        {x: 4587.558594, y: 53.22303, z: 446.508606},
        {x: 4643.859863, y: 153.08757, z: 211.071182},
        {x: 4772.045898, y: 67.39817, z: 72.489372},
        {x: 4700.207031, y: 99.466423, z: 127.620056},
        {x: 4781.917969, y: -8.84659, z: 127.25602},
        {x: 4742.466797, y: 231.521698, z: 154.930588},
        {x: 4802.074219, y: 107.631912, z: 142.748108},
        {x: 4846.05957, y: 115.471397, z: 142.84938},
        {x: 5006.325195, y: 190.575928, z: 125.996857},
        {x: 4977.548828, y: 50.329636, z: 0.783462},
        {x: 4985.050293, y: 223.306381, z: 9.71383},
        {x: 4940.336914, y: 198.158829, z: 124.63488},
        {x: 4895.339844, y: 221.198151, z: 88.413887},
        {x: 4846.018555, y: 43.955467, z: 74.493324},
        {x: 4720.284668, y: 106.834908, z: 148.827454},
        {x: 6101.239258, y: -1660.473389, z: 76.666565},
        {x: 6043.248535, y: -1899.577881, z: 1.099495},
        {x: 5324.679688, y: -1953.471924, z: 7.176002},
        {x: 5227.173828, y: -1632.189209, z: 1.403186},
        {x: 5186.25293, y: -1437.965942, z: 3.784627},
        {x: 5824.841309, y: -1589.716675, z: 19.292692},
        {x: 5831.018555, y: -1708.739136, z: 34.552032},
        {x: 5866.675293, y: -1677.307983, z: 41.588478},
        {x: 5809.12207, y: -1742.143433, z: 37.820076},
        {x: 6035.3, y: -1796.01, z: 34.3},
        {x: 5917.341797, y: -1636.845703, z: 30.629999},
        {x: 5992.015625, y: -1686.178101, z: 28.175768},
        {x: 6004.746094, y: -1740.013306, z: 25.343401},
        {x: 6069.294922, y: -1816.738525, z: 46.009773},
        {x: 6163.501953, y: -1922.055176, z: 3.317595},
        {x: 5954.39, y: -1779.8, z: 11.99},
        {x: 5856.153809, y: -1759.086792, z: 1.321661},
        {x: 5746.645996, y: -1509.282837, z: 1.688072},
        {x: 5825.229004, y: -1558.84668, z: 49.529873},
        {x: 5890.938965, y: -1594.593994, z: 42.928581}
      ],
      [ESpot.FERN]: [
        {x: 5897.436523, y: 307.481567, z: 0.46812},
        {x: 5639.047363, y: 218.125763, z: 0.194272},
        {x: 5639.45166, y: 116.515587, z: 0.584503},
        {x: 5621.67627, y: 164.911346, z: 0.539134},
        {x: 5706.339844, y: 342.910461, z: 0.269346},
        {x: 5572.099121, y: 429.281738, z: 0.108405},
        {x: 5529.296387, y: 318.709137, z: 0.054403},
        {x: 5581.57959, y: 407.143311, z: -0.224699},
        {x: 5743.869629, y: 479.285309, z: -0.081451},
        {x: 5736.48877, y: 630.336426, z: -0.287361},
        {x: 5836.540039, y: 688.412964, z: 0.00259},
        {x: 5658.299316, y: 703.707031, z: 0.013875},
        {x: 5571.432129, y: 545.883789, z: 1.921242},
        {x: 5412.247559, y: 466.951172, z: 0.017119},
        {x: 5345.654297, y: 397.895264, z: -0.018666},
        {x: 5341.881836, y: 384.62851, z: 0.06219},
        {x: 5289.562012, y: 313.435303, z: -0.073617},
        {x: 5271.810059, y: 271.700958, z: -0.181129},
        {x: 5238.557617, y: 323.866394, z: 0.258095},
        {x: 5563.834473, y: 473.061798, z: 6.511024},
        {x: 5392.21875, y: 260.045166, z: -0.034371},
        {x: 5487.999023, y: 255.082642, z: -0.196392},
        {x: 5654.836914, y: 576.844482, z: -0.032636},
        {x: 5646.444336, y: 784.502625, z: 1.151345},
        {x: 5585.430176, y: 793.895935, z: 30.294796},
        {x: 5749.952148, y: 745.355408, z: 22.313927},
        {x: 5862.125488, y: 593.161255, z: -0.077889},
        {x: 5940.928711, y: 636.351562, z: 0.837731},
        {x: 5988.645996, y: 577.96637, z: -0.106525},
        {x: 5909.73877, y: 530.70697, z: 0.590096},
        {x: 5798.067383, y: 720.758179, z: -0.06627},
        {x: 5841.534668, y: 787.780273, z: 1.095367},
        {x: 5861.720703, y: 885.56604, z: 25.467247},
        {x: 5785.323242, y: 863.49823, z: 0.007071},
        {x: 5534.724121, y: 401.875244, z: 0.470006},
        {x: 5593.666504, y: 405.738983, z: -0.213698},
        {x: 5604.692383, y: 428.692627, z: -0.218519},
        {x: 5592.983398, y: 531.641968, z: 0.86},
        {x: 5742.316406, y: 557.268616, z: 1.139394},
        {x: 5940.717773, y: 748.862244, z: -0.326992},
        {x: 5994.565918, y: 678.004639, z: 0.531106},
        {x: 6004.552246, y: 667.994324, z: -0.067418},
        {x: 5976.586426, y: 685.055603, z: -0.06842},
        {x: 5986.615234, y: 620.106262, z: -0.060602},
        {x: 5979.533203, y: 739.38269, z: 0.75001},
        {x: 5974.950684, y: 459.881592, z: -0.178284},
        {x: 5857.311035, y: 302.980927, z: -0.112874},
        {x: 5815.522461, y: 232.358215, z: -0.145821},
        {x: 5854.026855, y: 234.596146, z: 0.699999},
        {x: 5786.037598, y: 220.265289, z: -0.248699},
        {x: 5631.26123, y: 295.302582, z: -0.227725},
        {x: 5548.134277, y: 272.962372, z: -0.225459},
        {x: 5435.536621, y: 341.559601, z: 3.603006},
        {x: 5744.567871, y: 215.232101, z: -0.079483},
        {x: 5738.729004, y: 186.02507, z: -0.239588},
        {x: 5757.466309, y: 227.676086, z: 0.195687},
        {x: 5829.82373, y: 785.594482, z: 0.271923},
        {x: 5803.269531, y: 758.52948, z: -0.111824},
        {x: 5656.677734, y: 393.516205, z: 0.128225},
        {x: 5761.975586, y: 477.94693, z: -0.071082},
        {x: 5505.701172, y: 117.24334, z: -0.239653},
        {x: 5537.419434, y: 1.86294, z: -0.03072},
        {x: 5560.945801, y: 21.658611, z: 0.182854},
        {x: 5625.30127, y: 256.804291, z: 0.133784},
        {x: 5780.487793, y: 428.121796, z: -0.245583},
        {x: 5896.490723, y: 709.336426, z: 0.670288},
        {x: 5724.929688, y: 518.426392, z: 0.504597},
        {x: 5807.430176, y: 601.733704, z: -0.052354},
        {x: 5726.94043, y: 671.059448, z: 0.00502},
        {x: 5657.654297, y: 418.547455, z: -0.103217},
        {x: 5798.239746, y: 285.927551, z: -0.217798},
        {x: 5716.939941, y: 207.91655, z: -0.260874},
        {x: 5613.187012, y: 564.596741, z: 1.014467},
        {x: 5426.192871, y: 415.565948, z: -0.002578},
        {x: 5868.026855, y: 359.91394, z: -0.189288},
        {x: 5859.899414, y: 468.858887, z: 0.668772},
        {x: 5709.306641, y: 384.928009, z: 0.000392},
        {x: 5823.057617, y: 715.227783, z: 0.004635},
        {x: 5473.710449, y: 286.755859, z: -0.010323},
        {x: 5490.211426, y: 209.936981, z: -0.050824}
      ],
      [ESpot.GINSENG]: [
        {x: 4860.818359, y: 103.03019, z: 139.796021},
        {x: 4793.940918, y: 246.097687, z: 172.141464},
        {x: 4943.962891, y: 125.334579, z: 64.117035},
        {x: 5018.21875, y: 146.687683, z: 8.417816},
        {x: 4957.393555, y: 213.091827, z: 64.654076},
        {x: 4899.658203, y: 223.087708, z: 88.326744},
        {x: 4928.351562, y: 201.29631, z: 107.955627},
        {x: 4875.594238, y: 215.239044, z: 67.276291},
        {x: 4877.348633, y: 207.800781, z: 37.161053},
        {x: 5122.870605, y: 173.553543, z: 0.15},
        {x: 4910.012695, y: -28.055197, z: 34.782475},
        {x: 4897.403809, y: -87.794983, z: 51.877777},
        {x: 4887.702637, y: -156.812363, z: 35.040001},
        {x: 4942.868652, y: 138.223221, z: 91.566521},
        {x: 4909.484375, y: 344.608459, z: 5.213193},
        {x: 4890.397461, y: 329.875427, z: 88.383034},
        {x: 4865.490723, y: 302.360168, z: 0.699029},
        {x: 4886.975586, y: 468.000427, z: 9.17923},
        {x: 4782.824219, y: 420.449493, z: 7.93},
        {x: 4929.428223, y: 268.546326, z: 13.180569},
        {x: 4858.495117, y: 201.581223, z: 152.138809},
        {x: 4858.304688, y: 93.170006, z: 74.730003},
        {x: 4695.237793, y: -137.227997, z: 211.314056},
        {x: 4673.536133, y: -212.349411, z: 292.221588},
        {x: 4627.521484, y: -163.87738, z: 257.864227},
        {x: 4529.202148, y: 22.575333, z: 184.719391},
        {x: 4515.098145, y: 18.118109, z: 225.888336},
        {x: 4741.109375, y: 212.293564, z: 372.052673},
        {x: 4693.64209, y: 297.312103, z: 180.65686},
        {x: 4698.335938, y: 244.069229, z: 165.770737},
        {x: 4709.530762, y: 192.621185, z: 156.1828},
        {x: 4716.404297, y: 112.072609, z: 157.12146},
        {x: 4651.548828, y: 117.250191, z: 143.915726},
        {x: 4663.519043, y: 108.64016, z: 142.330948},
        {x: 4866.351074, y: -136.310684, z: 73.552856},
        {x: 4876.558594, y: -9.283104, z: 56.600193},
        {x: 4998.768066, y: 243.579559, z: 5.732413},
        {x: 4787.574219, y: 88.731285, z: 72.713142},
        {x: 4780.382324, y: -217.146713, z: 172.409668},
        {x: 4492.572266, y: -68.170929, z: 372.885712},
        {x: 4586.179688, y: 113.809227, z: 196.078232},
        {x: 4686.641113, y: 93.602859, z: 121.184334},
        {x: 4934.413086, y: 204.337997, z: 126.21769},
        {x: 4802.525879, y: 106.440392, z: 142.724991},
        {x: 4770.510254, y: 96.254158, z: 135.705368},
        {x: 4492.194336, y: 55.870041, z: 306.453186},
        {x: 4421.972656, y: 47.413105, z: 306.312988},
        {x: 4468.021484, y: 164.951324, z: 258.594788},
        {x: 4708.958984, y: -104.327934, z: 127.006073},
        {x: 4808.524414, y: -19.803003, z: 121.181908},
        {x: 4872.380859, y: 133.933563, z: 114.141479},
        {x: 4927.312012, y: 172.141708, z: 58.203777},
        {x: 4914.469727, y: -149.127396, z: 1.057576},
        {x: 5070.400391, y: 329.0896, z: 1.986533},
        {x: 4897.466309, y: -159.328812, z: 39.390881},
        {x: 4909.463867, y: -73.662964, z: 38.470303},
        {x: 4841.003906, y: 279.644958, z: 207.893921},
        {x: 4778.430664, y: 391.626709, z: 54.918751},
        {x: 4786.93457, y: 318.09375, z: 238.968384},
        {x: 4851.848633, y: 414.329376, z: 44.63657},
        {x: 4779.302734, y: 223.422302, z: 158.305527},
        {x: 4894.568359, y: 54.556068, z: 37.870647},
        {x: 4911.880371, y: 17.475462, z: 30.138348},
        {x: 4823.680176, y: 110.550095, z: 144.312576},
        {x: 4700.722656, y: 112.408089, z: 145.787582},
        {x: 4995.041016, y: 127.267105, z: 5.375186},
        {x: 4929.504883, y: -83.15844, z: 0.671287},
        {x: 4933.445801, y: 144.298508, z: 126.688522},
        {x: 5012.138184, y: -47.292305, z: 0.53},
        {x: 5077.347168, y: 124.056442, z: 0.934668},
        {x: 4927.849121, y: 32.657459, z: 0.465723},
        {x: 4783.294922, y: 223.805389, z: 148.329819},
        {x: 4697.192383, y: 152.773514, z: 148.329987},
        {x: 5066.584961, y: 94.067924, z: 0.53033},
        {x: 4379.062988, y: 144.753418, z: 72.986977},
        {x: 4273.346191, y: 169.076828, z: 79.951332},
        {x: 4286.162598, y: -319.330811, z: 283.580841},
        {x: 4130.682617, y: -159.611038, z: 310.593292},
        {x: 4239.436035, y: 166.035004, z: 174.914627},
        {x: 4487.791992, y: 131.73645, z: 266.182739}
      ],
      [ESpot.NASTURTIUM]: [
        {x: 4259.456543, y: -2186.995361, z: 52.95396},
        {x: 4269.246094, y: -2254.362061, z: 43.484207},
        {x: 4217.229004, y: -2377.631348, z: 31.484264},
        {x: 4137.978027, y: -2390.457275, z: 32.83337},
        {x: 4738.581543, y: -2368.455811, z: 43.596889},
        {x: 4732.001953, y: -2478.576416, z: 42.431992},
        {x: 4611.025391, y: -2411.912842, z: 22.725668},
        {x: 4637.007324, y: -2493.158936, z: 24.423079},
        {x: 4770.753906, y: -2383.733398, z: 45.655396},
        {x: 4767.839355, y: -2443.961426, z: 49.080898},
        {x: 4789.037598, y: -2483.058594, z: 39.84494},
        {x: 4839.323242, y: -2513.354736, z: 32.624729},
        {x: 4961.75, y: -2470.450195, z: 45.547325},
        {x: 5259.277832, y: -2583.690186, z: 46.150002},
        {x: 5304.658203, y: -2541.890625, z: 46.150002},
        {x: 5290.32959, y: -2502.597656, z: 46.149998},
        {x: 5285.025879, y: -2605.741699, z: 49.150974},
        {x: 5338.289551, y: -2657.635254, z: 53.899216},
        {x: 5200.374023, y: -2275.744385, z: 66.559998},
        {x: 5199.541016, y: -2260.281006, z: 66.532776},
        {x: 5170.334961, y: -2276.784912, z: 66.530594},
        {x: 5161.329102, y: -2253.584473, z: 66.420654},
        {x: 5154.606934, y: -2393.437256, z: 62.66745},
        {x: 5098.79541, y: -2530.89917, z: 52.534275},
        {x: 5034.967773, y: -2476.783447, z: 51.607456},
        {x: 4960.167969, y: -2613.806641, z: 44.981754},
        {x: 4914.082031, y: -2532.455078, z: 40.544167},
        {x: 4892.520996, y: -2454.139404, z: 45.28421},
        {x: 4834.05127, y: -2465.8125, z: 38.841747},
        {x: 4792.337891, y: -2419.123047, z: 51.214607},
        {x: 4717.879883, y: -2358.302734, z: 41.710144},
        {x: 4696.155762, y: -2426.702393, z: 40.689999},
        {x: 4723.717285, y: -2396.041748, z: 42.20998},
        {x: 4678.118164, y: -2376.841797, z: 33.343102},
        {x: 4565.496582, y: -2390.22168, z: 15.265032},
        {x: 4525.763672, y: -2470.857666, z: 9.681622},
        {x: 4532.425293, y: -2546.759766, z: 14.82591},
        {x: 4575.927734, y: -2619.101074, z: 29.652435},
        {x: 4463.025391, y: -2614.026123, z: 3.543532},
        {x: 4600.743164, y: -2587.185547, z: 31.049465},
        {x: 4691.761719, y: -2573.357666, z: 24.713747},
        {x: 4886.975586, y: -2494.378662, z: 38.918823},
        {x: 4959.345703, y: -2531.730713, z: 42.745934},
        {x: 5066.626953, y: -2691.800049, z: 36.515266},
        {x: 5138.761719, y: -2665.968506, z: 35.635544},
        {x: 5159.922852, y: -2533.941895, z: 52.718822},
        {x: 5093.977051, y: -2575.770264, z: 46.619156},
        {x: 5124.599609, y: -2695.193848, z: 32.207764},
        {x: 5198.080078, y: -2722.546143, z: 15.741697},
        {x: 5419.15332, y: -2626.275391, z: 67.256233},
        {x: 5385.04541, y: -2556.658447, z: 70.330154},
        {x: 5380.049805, y: -2518.178711, z: 69.079994},
        {x: 5324.786133, y: -2432.98584, z: 66.859375},
        {x: 5329.318848, y: -2399.297607, z: 67.101517},
        {x: 5377.209473, y: -2615.706543, z: 64.494514},
        {x: 5345.588867, y: -2590.038086, z: 56.749462},
        {x: 5179.246582, y: -2455.516113, z: 52.942802},
        {x: 5263.621094, y: -2440.858887, z: 50.959061},
        {x: 5043.28125, y: -2347.112305, z: 61.420803},
        {x: 5072.015625, y: -2416.933594, z: 59.40667},
        {x: 4892.745605, y: -2336.855957, z: 75.980537},
        {x: 5297.475098, y: -2627.782471, z: 47.929363},
        {x: 5019.016113, y: -2442.618164, z: 52.963272},
        {x: 4950.0625, y: -2576.625244, z: 41.375347},
        {x: 4704.898438, y: -2544.472656, z: 31.16556},
        {x: 4583.058594, y: -2507.997803, z: 20.188078},
        {x: 4818.492676, y: -2519.588379, z: 29.598398},
        {x: 5041.085938, y: -2553.151367, z: 47.440182},
        {x: 5113.228516, y: -2453.0, z: 57.107471},
        {x: 4904.72998, y: -2483.718994, z: 41.905499},
        {x: 4530.89209, y: -2592.104492, z: 17.081894},
        {x: 4609.606445, y: -2495.838379, z: 19.415817},
        {x: 5065.093262, y: -2309.028564, z: 61.526672},
        {x: 5129.956055, y: -2623.185547, z: 40.597847},
        {x: 5245.695801, y: -2440.470215, z: 50.604588},
        {x: 5209.287109, y: -2426.788086, z: 53.386547},
        {x: 5035.027832, y: -2513.377441, z: 48.91296},
        {x: 4979.002441, y: -2512.813965, z: 43.410732},
        {x: 4762.829102, y: -2483.241699, z: 41.205589},
        {x: 4877.135254, y: -2513.266602, z: 37.159615},
        {x: 4850.030273, y: -2432.225342, z: 43.946293}
      ],
      [ESpot.RATTAN]: [
        {x: 4688.314453, y: 1463.178955, z: 5.203362},
        {x: 4649.17334, y: 1446.203247, z: 12.6},
        {x: 4678.906738, y: 1496.165039, z: 19.047146},
        {x: 4602.895996, y: 1494.977051, z: 33.767899},
        {x: 4825.992676, y: 1729.480347, z: 30.85},
        {x: 5044.175781, y: 1467.039185, z: 19.530001},
        {x: 4944.397461, y: 1289.1604, z: 32.657486},
        {x: 4860.34375, y: 1303.154785, z: 10.256698},
        {x: 4877.166504, y: 1354.918213, z: 29.490746},
        {x: 4936.457031, y: 1693.738647, z: 46.673088},
        {x: 4855.616699, y: 1766.531372, z: 32.196735},
        {x: 4537.790527, y: 1694.685547, z: 198.791},
        {x: 4457.238281, y: 1464.445068, z: 233.468808},
        {x: 4418.861816, y: 1380.067871, z: 246.061996},
        {x: 4753.105957, y: 1660.36499, z: 27.41},
        {x: 4710.637695, y: 1613.11792, z: 28.180649},
        {x: 4651.157715, y: 1647.248047, z: 33.110451},
        {x: 4656.243164, y: 1724.362427, z: 58.896561},
        {x: 4739.105957, y: 1523.501953, z: 10.521111},
        {x: 4597.296387, y: 1484.977417, z: 38.403625},
        {x: 4677.426758, y: 1467.265381, z: 13.571573},
        {x: 4576.959473, y: 1637.023926, z: 37.883423},
        {x: 4655.604004, y: 1639.272217, z: 23.976725},
        {x: 4642.883301, y: 1314.766724, z: 26.719999},
        {x: 4688.37793, y: 1426.329224, z: 27.804539},
        {x: 4804.071289, y: 1474.988159, z: 5.411122},
        {x: 4991.475098, y: 1560.15332, z: 67.406151},
        {x: 5016.79834, y: 1744.303223, z: 131.555161},
        {x: 4979.729004, y: 1764.604492, z: 145.75293},
        {x: 4946.713379, y: 1735.302368, z: 123.250946},
        {x: 4946.674316, y: 1793.831055, z: 168.743805},
        {x: 4734.041504, y: 1642.228271, z: 27.443136},
        {x: 4847.562988, y: 1381.597778, z: 23.233677},
        {x: 4715.217773, y: 1446.720093, z: 4.30408},
        {x: 4872.606445, y: 1400.058472, z: 18.921833},
        {x: 4964.244629, y: 1323.046265, z: 59.956768},
        {x: 5230.448242, y: 1780.889404, z: 102.061653},
        {x: 5006.16748, y: 1811.52356, z: 194.358276},
        {x: 4978.818359, y: 1778.57019, z: 175.881226},
        {x: 4871.107422, y: 2023.200073, z: 199.058487},
        {x: 4834.068848, y: 1689.886597, z: 28.701977},
        {x: 4651.861328, y: 1706.517334, z: 40.721581},
        {x: 4626.361816, y: 1739.022949, z: 86.367134},
        {x: 4587.196777, y: 1646.67749, z: 96.319046},
        {x: 4911.319824, y: 1581.872559, z: 13.384886},
        {x: 4804.580566, y: 1418.68103, z: 8.6891},
        {x: 4990.757813, y: 1473.401001, z: 13.951099},
        {x: 4819.055664, y: 1772.682251, z: -9.798273},
        {x: 4952.397461, y: 1505.791382, z: 10.999715},
        {x: 4749.776367, y: 1746.674316, z: 27.896624},
        {x: 4610.570801, y: 1645.426758, z: 80.094772},
        {x: 4612.666016, y: 1493.204468, z: 42.801849},
        {x: 4578.501953, y: 1602.075684, z: 24.02091},
        {x: 4840.894043, y: 1731.022827, z: -42.638374},
        {x: 4822.632324, y: 1204.077148, z: 25.343576},
        {x: 4645.06543, y: 1430.802856, z: 28.473072},
        {x: 4661.941406, y: 1663.292847, z: 43.526077},
        {x: 4694.106445, y: 1491.518799, z: 19.23992},
        {x: 4605.144531, y: 1654.524414, z: 128.292496},
        {x: 4459.830078, y: 1518.242554, z: 168.948517},
        {x: 4784.161621, y: 1499.825684, z: 9.284033},
        {x: 4761.575684, y: 1576.965088, z: 16.724476},
        {x: 4822.950195, y: 1628.32605, z: 22.17},
        {x: 4814.758301, y: 1676.371582, z: 27.733438},
        {x: 4599.983398, y: 1544.382202, z: 11.280461},
        {x: 4532.633301, y: 1459.518311, z: 30.463352},
        {x: 4791.251953, y: 1396.794312, z: 13.166175},
        {x: 4676.914551, y: 1737.244629, z: 39.809223},
        {x: 4686.553223, y: 1507.744995, z: 17.583651},
        {x: 4781.477539, y: 1433.364014, z: 5.417853},
        {x: 4795.65332, y: 1359.00647, z: 19.530001},
        {x: 4922.064453, y: 1299.93457, z: 6.136235},
        {x: 4673.251465, y: 1609.882202, z: 19.809999},
        {x: 4741.651855, y: 1494.062012, z: 12.004128},
        {x: 4740.213379, y: 1401.876221, z: 15.28124},
        {x: 4901.299316, y: 1366.271362, z: 18.546768},
        {x: 4666.997559, y: 1714.680664, z: 39.244091},
        {x: 4657.560547, y: 1619.847168, z: 19.809998},
        {x: 4965.891113, y: 1534.912476, z: 15.363153},
        {x: 4744.427246, y: 1579.963867, z: 16.586294}
      ],
      [ESpot.CORIANDER]: [
        {x: 3013.286377, y: 310.848419, z: 138.308731},
        {x: 2977.399414, y: 328.772095, z: 137.009933},
        {x: 2877.427734, y: 339.035858, z: 136.985931},
        {x: 2848.628174, y: 268.277771, z: 138.270096},
        {x: 3106.985107, y: 258.54303, z: 139.18576},
        {x: 3140.570068, y: 363.37738, z: 135.571472},
        {x: 2999.69043, y: 184.709259, z: 81.006027},
        {x: 3138.832275, y: 1.823429, z: 85.404633},
        {x: 3209.500977, y: -56.004261, z: 84.858521},
        {x: 3299.597412, y: 62.827145, z: 75.434128},
        {x: 3428.212402, y: 228.123764, z: 77.510857},
        {x: 3480.386963, y: 286.59906, z: 79.508736},
        {x: 3551.516357, y: 135.557083, z: 74.835045},
        {x: 3603.83374, y: 155.480728, z: 76.396881},
        {x: 3295.855957, y: 208.530838, z: 78.465034},
        {x: 3136.516113, y: 152.075439, z: 77.457962},
        {x: 3119.745361, y: 106.691101, z: 74.502174},
        {x: 2991.325195, y: -59.799648, z: 94.587646},
        {x: 2891.28833, y: 105.997299, z: 93.639168},
        {x: 3093.085449, y: 187.840607, z: 80.001831},
        {x: 3183.299805, y: 302.841461, z: 140.249161},
        {x: 3042.897949, y: 409.794434, z: 137.009872},
        {x: 2942.150391, y: 401.708771, z: 137.65773},
        {x: 2927.369629, y: 360.028717, z: 156.042984},
        {x: 2928.218018, y: 83.017632, z: 85.148338},
        {x: 3051.0, y: 235.92, z: 137.99},
        {x: 3008.183594, y: 267.659668, z: 137.023087},
        {x: 2839.729248, y: 340.960754, z: 135.648666},
        {x: 2933.680176, y: 310.733002, z: 137.190002},
        {x: 2849.812744, y: 168.164764, z: 152.456619},
        {x: 2913.501221, y: -177.207733, z: 110.031441},
        {x: 2890.298584, y: -38.255703, z: 76.546486},
        {x: 3061.848389, y: 6.464819, z: 85.995003},
        {x: 3089.618408, y: -6.481946, z: 85.637962},
        {x: 3294.730713, y: -231.014282, z: 124.654541},
        {x: 3330.109375, y: -138.560364, z: 73.864098},
        {x: 3309.041016, y: 54.260185, z: 74.40966},
        {x: 3490.653564, y: 176.60199, z: 74.08831},
        {x: 3507.92749, y: 125.287209, z: 74.366501},
        {x: 3277.971924, y: 126.869209, z: 78.734497},
        {x: 3265.587891, y: 82.261406, z: 75.084717},
        {x: 3321.778076, y: 299.854065, z: 80.171562},
        {x: 3359.590576, y: 574.835205, z: 82.212914},
        {x: 3414.907715, y: 510.999817, z: 75.194565},
        {x: 3494.474609, y: 376.781738, z: 78.552826},
        {x: 3248.442627, y: 453.110107, z: 101.753571},
        {x: 3360.123535, y: 380.967834, z: 75.478699},
        {x: 3248.124268, y: 242.486633, z: 83.501007},
        {x: 3236.047119, y: 356.266357, z: 97.059669},
        {x: 3217.554932, y: 454.836853, z: 117.707085},
        {x: 3088.36792, y: 318.595886, z: 137.009995},
        {x: 3033.252686, y: 452.70224, z: 140.086166},
        {x: 2856.055664, y: 370.21283, z: 159.330017},
        {x: 3092.986328, y: 368.212402, z: 137.009995},
        {x: 3201.058105, y: 430.866394, z: 120.052681},
        {x: 3196.957275, y: -95.985878, z: 122.616074},
        {x: 3211.556641, y: -76.208755, z: 89.096146},
        {x: 3408.383301, y: 73.337151, z: 75.494904},
        {x: 3300.242188, y: 164.150833, z: 77.488495},
        {x: 3633.650879, y: -177.984848, z: 110.523346},
        {x: 3254.63501, y: -3.771707, z: 76.07534},
        {x: 3350.257812, y: -37.212025, z: 84.29882},
        {x: 3343.922363, y: 462.900452, z: 79.129578},
        {x: 3070.788086, y: 555.14386, z: 160.691544},
        {x: 3009.115234, y: 393.319214, z: 136.967514},
        {x: 3066.294678, y: 394.790344, z: 137.009995},
        {x: 3235.86377, y: 398.8526, z: 115.535713},
        {x: 3241.476807, y: 65.600777, z: 74.25766},
        {x: 3485.407959, y: 209.32692, z: 74.292259},
        {x: 3163.77124, y: 339.210602, z: 136.891647},
        {x: 3410.689453, y: 364.873993, z: 74.48513},
        {x: 3396.873779, y: 229.586121, z: 77.777275},
        {x: 3326.679199, y: 270.07666, z: 79.077682},
        {x: 3045.69043, y: 73.070709, z: 76.602409},
        {x: 2945.984131, y: 27.039671, z: 76.616386},
        {x: 2785.876953, y: -28.753124, z: 77.515228},
        {x: 2549.793945, y: 13.131586, z: 79.136276},
        {x: 2455.165771, y: -87.6082, z: 80.097244},
        {x: 2839.815918, y: -43.920673, z: 74.617462},
        {x: 2843.108643, y: 23.210733, z: 75.767403}
      ],
      [ESpot.ALMOND]: [
        {x: 498.481201, y: 241.252533, z: 34.008999},
        {x: 617.178528, y: 340.730469, z: 41.616104},
        {x: 562.049866, y: 394.780121, z: 51.892826},
        {x: 467.863129, y: 288.643433, z: 51.804993},
        {x: 449.563477, y: 168.099533, z: 51.718178},
        {x: 161.204498, y: 296.362671, z: 63.642467},
        {x: 111.9263, y: 340.216095, z: 85.026466},
        {x: 293.411865, y: 509.901581, z: 63.073421},
        {x: 191.26384, y: 516.683777, z: 63.498455},
        {x: 665.141296, y: 137.177094, z: 18.64941},
        {x: 752.828735, y: 154.436981, z: 19.292126},
        {x: 714.120483, y: 376.532715, z: 38.788723},
        {x: 502.018005, y: 341.954437, z: 51.870182},
        {x: 406.304657, y: 295.707336, z: 52.342419},
        {x: 167.379654, y: 232.327164, z: 52.322727},
        {x: 558.679932, y: 303.112305, z: 34.089828},
        {x: 512.474854, y: 313.003265, z: 51.714985},
        {x: 334.300415, y: 364.546722, z: 52.302567},
        {x: 319.1185, y: 415.484619, z: 56.853737},
        {x: 254.436493, y: 562.679626, z: 62.718044},
        {x: 38.017387, y: 596.098572, z: 75.596001},
        {x: 66.248787, y: 478.622528, z: 63.32682},
        {x: 148.975754, y: 359.854126, z: 78.343018},
        {x: 221.828552, y: 294.615356, z: 52.662136},
        {x: 273.579834, y: 333.373596, z: 55.047386},
        {x: 401.014771, y: 397.787567, z: 51.212616},
        {x: 376.299591, y: 346.753845, z: 52.968143},
        {x: 368.04184, y: 79.238129, z: 51.999176},
        {x: 572.526611, y: 258.901489, z: 28.904161},
        {x: 279.067566, y: 398.349487, z: 60.35815},
        {x: 453.856354, y: 403.576996, z: 51.348145},
        {x: 584.686523, y: 480.804169, z: 30.62421},
        {x: 425.060608, y: 390.526123, z: 51.710003},
        {x: 203.262161, y: 179.16713, z: 92.275108},
        {x: 763.078064, y: 326.156342, z: 47.161812},
        {x: 4724.753418, y: -2534.183594, z: 32.077145},
        {x: 5078.538086, y: -2514.95752, z: 53.585812},
        {x: 5045.384766, y: -2396.816895, z: 57.642319},
        {x: 5200.523926, y: -2270.08252, z: 66.595978},
        {x: 4742.228027, y: -2561.137207, z: 24.88448},
        {x: 4197.390137, y: -2350.203613, z: 32.591038},
        {x: 4252.136719, y: -2233.432373, z: 45.92635},
        {x: 4140.275391, y: -2388.784424, z: 32.336582},
        {x: 4547.751953, y: -2513.135742, z: 15.815598},
        {x: 5396.822266, y: -2587.803467, z: 69.551773},
        {x: 5239.670898, y: -2413.693604, z: 54.255989},
        {x: 5117.068848, y: -2319.683105, z: 65.516426},
        {x: 4934.144043, y: -2315.42749, z: 74.052483},
        {x: 4591.412598, y: -2599.532959, z: 30.878925},
        {x: 5186.560547, y: -2391.918945, z: 61.188419},
        {x: 4490.677734, y: -2621.322021, z: 6.954762},
        {x: 5149.961426, y: -2552.659912, z: 50.830368},
        {x: 5142.771973, y: -2241.764893, z: 101.35273},
        {x: 4933.102051, y: -2358.270264, z: 73.065117},
        {x: 4845.517578, y: -2409.72168, z: 48.597855}
      ],
      [ESpot.BLUE_ORCHID]: [
        {x: 340.270966, y: 2008.37915, z: 24.481588},
        {x: 282.994476, y: 1967.40918, z: 19.021637},
        {x: 370.078278, y: 2005.983887, z: 30.833374},
        {x: 427.928925, y: 1964.691406, z: 17.980621},
        {x: 455.593811, y: 1945.684448, z: 15.675477},
        {x: 550.091675, y: 1992.448608, z: 1.076481},
        {x: 404.75119, y: 1935.961426, z: 40.36343},
        {x: 474.199127, y: 1830.278564, z: 18.949999},
        {x: 341.99115, y: 1687.997437, z: 19.236023},
        {x: 459.932129, y: 1845.493408, z: 18.953747},
        {x: 276.915314, y: 1783.187744, z: 18.949999},
        {x: 97.328026, y: 1968.90625, z: 21.099998},
        {x: 248.09845, y: 2042.682373, z: 29.867363},
        {x: 301.544312, y: 1915.760742, z: 18.812452},
        {x: 270.63208, y: 1878.70813, z: 18.949999},
        {x: 181.044022, y: 1855.476807, z: 18.321428},
        {x: 75.964096, y: 1740.770752, z: 18.539663},
        {x: 32.990482, y: 1923.103149, z: 28.869999},
        {x: 93.973427, y: 1872.707642, z: 17.689999},
        {x: 209.323898, y: 1916.065308, z: 19.29768},
        {x: 601.48407, y: 3766.149414, z: 0.26},
        {x: 540.516541, y: 3806.34082, z: 0.220387},
        {x: 521.185364, y: 3762.304932, z: 0.28683},
        {x: 349.902313, y: 4055.437012, z: 1.725892},
        {x: 545.101868, y: 4221.739258, z: 1.575316},
        {x: 842.355713, y: 3997.923828, z: 37.910252},
        {x: 758.276123, y: 3941.054443, z: 27.414366},
        {x: 359.465363, y: 3875.126465, z: 0.26},
        {x: 710.115051, y: 3744.706055, z: 0.259922},
        {x: 679.263428, y: 3797.345215, z: 0.26},
        {x: 788.46936, y: 3984.691406, z: 40.271214},
        {x: 677.075867, y: 4128.444336, z: 0.26},
        {x: 483.848236, y: 4194.917969, z: 4.887486},
        {x: 420.64212, y: 4193.270508, z: 0.25971},
        {x: 248.662689, y: 3884.039307, z: 0.256577},
        {x: 636.063538, y: 2065.958252, z: -1.321258},
        {x: 288.883392, y: 2173.575439, z: 30.510384},
        {x: 455.327667, y: 1975.130005, z: 46.169418},
        {x: 439.459808, y: 1938.068481, z: 18.406004},
        {x: 503.086884, y: 1965.485596, z: 12.679802},
        {x: 215.673721, y: 1905.050171, z: 18.949999},
        {x: 149.413025, y: 1864.369385, z: 17.795301},
        {x: 374.086731, y: 1116.522583, z: 25.12915},
        {x: 373.801086, y: 1066.279053, z: 27.756113},
        {x: 329.0448, y: 1023.612549, z: 37.846035},
        {x: 387.747742, y: 1126.178467, z: 25.200401},
        {x: 351.850647, y: 1144.066162, z: 22.968546},
        {x: 386.782501, y: 1087.581787, z: 26.945114},
        {x: 568.006775, y: 2681.922852, z: 19.98418},
        {x: 575.93927, y: 2735.256836, z: 9.241342},
        {x: 602.815735, y: 2839.897949, z: 1.04137},
        {x: 567.923523, y: 2847.760254, z: 1.70759},
        {x: 713.705139, y: 2947.582275, z: 5.364844},
        {x: 542.059692, y: 2909.01416, z: 0.033343},
        {x: 336.438629, y: 1143.471924, z: 22.683393},
        {x: 357.446747, y: 1087.934692, z: 24.335045},
        {x: 146.069611, y: 1826.087402, z: 17.774473},
        {x: 474.716187, y: 1973.13623, z: 11.516806},
        {x: 494.63089, y: 1968.325806, z: 10.514791}
      ],
      [ESpot.SNAPDRAGON]: [
        {x: -2099.618164, y: 651.88623, z: 122.900856},
        {x: -1922.317505, y: 706.554565, z: 98.246284},
        {x: -1833.355713, y: 502.41098, z: 107.860001},
        {x: -1959.6698, y: 398.93158, z: 113.506042},
        {x: -1610.895142, y: 121.20536, z: 66.964592},
        {x: -1613.40564, y: 68.84063, z: 57.809185},
        {x: -1864.535156, y: 441.928925, z: 103.58062},
        {x: -1769.958496, y: 584.085999, z: 101.102364},
        {x: -1520.981567, y: 782.886292, z: 170.89534},
        {x: -1497.465942, y: 662.025635, z: 196.292664},
        {x: -1189.204102, y: 752.501282, z: 219.980774},
        {x: -1400.021729, y: 777.127808, z: 217.726547},
        {x: -1613.05188, y: 799.802979, z: 213.164658},
        {x: -1620.207031, y: 729.588684, z: 215.407135},
        {x: -1715.849243, y: 553.631531, z: 100.454346},
        {x: -1858.931396, y: 556.604309, z: 101.732307},
        {x: -2132.671631, y: 594.312317, z: 153.125122},
        {x: -1918.937134, y: 639.654602, z: 100.378761},
        {x: -2303.259277, y: 788.494141, z: 80.105537},
        {x: -2302.957031, y: 427.732178, z: 187.002045},
        {x: -1814.201416, y: 532.101013, z: 104.12706},
        {x: -1854.848511, y: 775.667419, z: 191.484848},
        {x: -1922.709473, y: 738.620483, z: 155.150787},
        {x: -2052.016113, y: 806.296448, z: 110.010887},
        {x: -2076.712646, y: 545.971863, z: 154.061264},
        {x: -1975.157104, y: 467.661682, z: 106.456619},
        {x: -1955.949707, y: 351.654541, z: 107.391068},
        {x: -1817.375854, y: 425.689911, z: 150.234055},
        {x: -1923.447266, y: -503.973694, z: 4.328272},
        {x: -2008.738525, y: -117.140228, z: 33.224121},
        {x: -1723.396973, y: -127.881241, z: 16.081831},
        {x: -1711.311401, y: -443.293396, z: 26.064859},
        {x: -1173.77771, y: -864.435364, z: -67.219101},
        {x: -1282.103638, y: -935.148987, z: -48.284893},
        {x: -1389.775635, y: -838.683044, z: -20.099998},
        {x: -1494.568848, y: -631.300964, z: 21.627438},
        {x: -1828.978516, y: 26.42631, z: 32.006695},
        {x: -1933.729736, y: 176.075882, z: 116.250252},
        {x: -1453.50647, y: -14.525492, z: 16.46839},
        {x: -1187.086792, y: -328.499847, z: 167.957748},
        {x: -1498.665771, y: -102.246277, z: 18.29781},
        {x: -1676.588989, y: -198.827454, z: 26.133797},
        {x: -1678.277588, y: -538.218567, z: 16.8437},
        {x: -1810.544678, y: -593.460632, z: 19.542629},
        {x: -1731.743652, y: -595.292114, z: 15.357597},
        {x: -1924.98645, y: -418.614349, z: 5.695282},
        {x: -1987.693359, y: -510.018158, z: 8.217387},
        {x: -869.668274, y: 67.288124, z: 27.149788},
        {x: -1658.949097, y: -105.465721, z: 16.238653},
        {x: -1341.738037, y: -841.821411, z: -21.779724},
        {x: -1815.748535, y: -218.610489, z: 19.009541},
        {x: -1489.697388, y: 700.023254, z: 200.804611},
        {x: -1933.482178, y: -178.890671, z: 8.84},
        {x: -2107.347412, y: 93.291695, z: 83.954063},
        {x: -2450.374023, y: 34.289436, z: 119.29203},
        {x: -2740.682617, y: 166.257324, z: 156.50235},
        {x: -3004.647461, y: 428.911377, z: 100.651306},
        {x: -3145.740479, y: 754.500916, z: 65.860031},
        {x: -3220.513428, y: 488.599243, z: 67.490921},
        {x: -3354.497314, y: 420.122742, z: 73.754745},
        {x: -3242.052002, y: 294.029846, z: 79.906876},
        {x: -2903.669434, y: 342.77063, z: 82.648155},
        {x: -2891.990234, y: 53.873394, z: 102.649696},
        {x: -2732.107666, y: 92.299942, z: 222.919937},
        {x: -2683.118896, y: -136.085663, z: 140.684891},
        {x: -2560.412598, y: -146.41745, z: 127.944336},
        {x: -2303.254639, y: 53.841953, z: 108.21283},
        {x: -2532.068848, y: 238.067963, z: 119.430176},
        {x: -2675.129639, y: 217.624924, z: 112.259346},
        {x: -2762.571045, y: 271.640076, z: 98.603752},
        {x: -2718.436279, y: 505.510254, z: -3.88093},
        {x: -2858.046387, y: 253.565491, z: 97.332497},
        {x: -2793.55127, y: 172.832489, z: 104.545326},
        {x: -2877.206299, y: -4.499681, z: 128.046814},
        {x: -2974.655518, y: 6.621651, z: 153.185852},
        {x: -2991.724854, y: -60.166649, z: 156.859268},
        {x: -2775.467773, y: -158.623215, z: 144.437286},
        {x: -2567.629639, y: -27.224466, z: 127.611214},
        {x: -1715.684204, y: 624.843262, z: 173.597015},
        {x: -1745.50061, y: 655.491089, z: 187.200943},
        {x: -2358.253174, y: -1781.256958, z: 105.742569},
        {x: -2429.868652, y: -2311.359375, z: 72.372704},
        {x: -2673.510498, y: -2473.959717, z: 95.705688},
        {x: -2786.640381, y: -2717.311035, z: 128.29744},
        {x: -2787.972656, y: -2825.942383, z: 136.978195},
        {x: -2910.202881, y: -2865.927002, z: 122.674126},
        {x: -3036.486084, y: -2220.829834, z: 103.838257},
        {x: -1816.846069, y: -505.674194, z: 5.5},
        {x: -1903.727661, y: -351.110352, z: 5.137557},
        {x: -1935.422119, y: -278.584106, z: 8.99052},
        {x: -1533.454834, y: -681.332336, z: 21.780222},
        {x: -1252.411987, y: -969.270081, z: -63.119701},
        {x: -1475.07605, y: -614.145508, z: 23.119076},
        {x: -1785.597656, y: -630.541199, z: 20.359503},
        {x: -1759.320801, y: -484.784485, z: 12.462876},
        {x: -1711.723022, y: -494.312195, z: 12.6176},
        {x: -1903.868286, y: -250.558899, z: 7.69004},
        {x: -1914.866211, y: -226.907074, z: 9.545648},
        {x: -1822.811157, y: -171.290344, z: 10.044728},
        {x: -1520.805176, y: -131.466827, z: 16.420469},
        {x: -1967.292969, y: -23.257151, z: 38.400696},
        {x: -2056.413818, y: 61.232342, z: 78.084831},
        {x: -2212.666504, y: 82.695724, z: 102.129997},
        {x: -2121.085693, y: -224.223633, z: 40.7747},
        {x: -2189.38916, y: -468.409729, z: 50.483784},
        {x: -2147.349365, y: -452.574799, z: 47.595165},
        {x: -1876.063965, y: -476.041138, z: 4.309044}
      ],
      [ESpot.MULBERRY_TREE]: [
        {x: -2476.548584, y: -675.43927, z: 105.87262},
        {x: -2355.689697, y: -737.895325, z: 91.861214},
        {x: -2340.109619, y: -842.335144, z: 87.883926},
        {x: -2588.468506, y: -821.430176, z: 122.970612},
        {x: -2613.668213, y: -716.057556, z: 116.734062},
        {x: -2585.375, y: -660.373962, z: 115.483894},
        {x: -2514.523682, y: -265.623199, z: 123.179993},
        {x: -2506.805908, y: -363.144989, z: 130.393524},
        {x: -2575.105225, y: -393.68692, z: 121.102402},
        {x: -2539.000244, y: -488.003448, z: 102.471115},
        {x: -2987.398193, y: -781.8255, z: 147.221085},
        {x: -2990.585205, y: -186.142548, z: 149.804626},
        {x: -2614.859619, y: -420.102112, z: 122.247795},
        {x: -2455.400879, y: -527.580872, z: 94.388084},
        {x: -2344.983398, y: -448.663574, z: 92.525887},
        {x: -2372.695068, y: -685.434509, z: 89.612732},
        {x: -2514.260498, y: -1011.043213, z: 98.545547},
        {x: -2507.741211, y: -1077.569946, z: 97.690002},
        {x: -2607.402832, y: -1212.381348, z: 107.099251},
        {x: -2962.394287, y: -1647.745483, z: 146.962662},
        {x: -2421.077148, y: -1622.360474, z: 99.042641},
        {x: -2377.504395, y: -1643.338623, z: 93.124374},
        {x: -2342.934326, y: -1600.384277, z: 91.735077},
        {x: -2325.527832, y: -1558.637573, z: 90.222649},
        {x: -2259.154297, y: -1357.442749, z: 94.942192},
        {x: -2177.708496, y: -1210.42395, z: 119.134544},
        {x: -2219.994385, y: -1155.612915, z: 100.161697},
        {x: -2280.038574, y: -1024.259888, z: 93.666183},
        {x: -2588.709473, y: -941.721008, z: 121.894051},
        {x: -2453.506592, y: -857.929443, z: 95.326904},
        {x: -2341.135742, y: -668.992554, z: 88.345856},
        {x: -2325.594727, y: -565.164795, z: 82.13739},
        {x: -2553.327881, y: -443.390594, z: 120.694427},
        {x: -2858.249023, y: -668.099243, z: 146.531677},
        {x: -2720.462891, y: -672.040466, z: 141.829208},
        {x: -2753.520752, y: -965.5401, z: 183.132965},
        {x: -3034.732422, y: -1082.891357, z: 161.565094},
        {x: -2952.394043, y: -738.704285, z: 150.693573},
        {x: -2687.725342, y: -823.346375, z: 163.97995},
        {x: -2572.69043, y: -867.584045, z: 123.450523},
        {x: -2557.512939, y: -896.577515, z: 116.931519},
        {x: -2561.977295, y: -1005.050964, z: 105.550163},
        {x: -2319.468262, y: -1079.68103, z: 86.780281},
        {x: -2152.487061, y: -1111.512207, z: 118.971695},
        {x: -2379.893311, y: -1402.285767, z: 91.281982},
        {x: -1279.007568, y: 11.495996, z: 21.423298},
        {x: -1347.773438, y: 6.941522, z: 16.629118},
        {x: -1199.634399, y: -191.689453, z: 31.470203},
        {x: -1327.144287, y: -114.397888, z: 28.391436},
        {x: -1433.375, y: -85.257248, z: 16.011641},
        {x: -753.827576, y: -100.412682, z: 15.443075},
        {x: -1670.802612, y: -145.489334, z: 18.497429},
        {x: -1664.421387, y: -1502.441406, z: 30.619347},
        {x: -1804.369263, y: -1472.053833, z: 32.896919},
        {x: -1720.321045, y: -1344.937378, z: 35.05735},
        {x: -1865.477051, y: -1210.566162, z: 23.744431},
        {x: -1830.908813, y: -1130.605957, z: 25.264021},
        {x: -1757.319336, y: -984.46759, z: 23.200001},
        {x: -1869.991089, y: -1100.584351, z: 23.394911},
        {x: -1855.053101, y: -1165.086792, z: 23.229109},
        {x: -2429.912109, y: -1138.856567, z: 92.025261},
        {x: -2441.812256, y: -1077.092651, z: 92.259315},
        {x: -2506.682373, y: -837.43689, z: 102.511963},
        {x: -2300.505371, y: -491.304871, z: 90.569977},
        {x: -2558.356201, y: -324.36554, z: 121.090416},
        {x: -1518.808228, y: -25.71452, z: 16.0667},
        {x: -2475.550781, y: -590.602966, z: 104.45401},
        {x: -2368.006104, y: -574.498474, z: 86.188385},
        {x: -2499.178955, y: -730.178833, z: 110.937386},
        {x: -2585.445068, y: -701.797546, z: 117.284813},
        {x: -2661.032227, y: -584.235107, z: 124.723763},
        {x: -2637.796631, y: -750.694397, z: 122.5},
        {x: -2214.807861, y: -972.699341, z: 95.515793},
        {x: -2263.934326, y: -804.400269, z: 108.19828},
        {x: -2392.377441, y: -1333.468506, z: 87.463394},
        {x: -2308.671387, y: -1374.315063, z: 88.950485},
        {x: -2270.061279, y: -1439.147583, z: 94.483551},
        {x: -2199.144775, y: -1180.247925, z: 111.650002},
        {x: -2234.413818, y: -1123.194458, z: 97.160126},
        {x: -2322.721924, y: -1129.830688, z: 87.58107}
      ],
    
      // ECategory.WOODCRAFTING
      [ESpot.BAMBOO]: [
        {x: 5509.825195, y: -425.842102, z: 1.297448},
        {x: 5509.617676, y: -420.618683, z: 1.549799},
        {x: 5501.573242, y: -425.587646, z: 1.464648},
        {x: 5504.157715, y: -431.263214, z: 1.21984},
        {x: 5479.686035, y: -321.147766, z: 3.420003},
        {x: 5442.894043, y: -354.418854, z: 3.422879},
        {x: 5440.248535, y: -346.101044, z: 3.419999},
        {x: 5491.748047, y: -326.891388, z: 3.42},
        {x: 5517.870117, y: -284.923309, z: 3.708911},
        {x: 5549.001953, y: -284.195312, z: 5.060685},
        {x: 5576.751465, y: -312.873627, z: 3.876154},
        {x: 5536.491699, y: -326.479248, z: 22.495216},
        {x: 5538.824219, y: -351.460297, z: 13.633529},
        {x: 5564.536621, y: -383.151031, z: 3.711641},
        {x: 5449.376465, y: -447.490112, z: 1.830014},
        {x: 5509.693848, y: -459.424164, z: 1.042061},
        {x: 5623.361328, y: -555.777344, z: 1.755408},
        {x: 5633.48584, y: -669.931824, z: 2.184756},
        {x: 5684.909668, y: -698.030762, z: 3.965965},
        {x: 5695.224609, y: -734.313416, z: 2.907465},
        {x: 5752.208008, y: -764.460388, z: 6.561016},
        {x: 5720.345215, y: -778.157837, z: 2.321636},
        {x: 5741.432617, y: -747.211121, z: 5.396605},
        {x: 5720.205566, y: -722.742371, z: 6.465215},
        {x: 5729.666016, y: -801.836304, z: 4.565552},
        {x: 5747.211914, y: -818.000793, z: 6.195745},
        {x: 5762.720215, y: -802.835571, z: 7.197027},
        {x: 5854.10498, y: -1007.015747, z: 30.369999},
        {x: 5881.808105, y: -950.865845, z: 29.248703},
        {x: 5806.013184, y: -909.78772, z: 24.814796},
        {x: 5808.476562, y: -937.312988, z: 28.999659},
        {x: 5808.336914, y: -934.808594, z: 28.498247},
        {x: 5852.731445, y: -967.254883, z: 33.712925},
        {x: 5815.774414, y: -1133.599121, z: 25.477142},
        {x: 5795.599609, y: -1132.696899, z: 25.201567},
        {x: 5849.033691, y: -895.671814, z: 26.937939},
        {x: 5790.068848, y: -861.103638, z: 15.733731},
        {x: 5823.922852, y: -826.598572, z: 15.214429},
        {x: 5603.854004, y: -625.931458, z: 2.025965},
        {x: 5638.757812, y: -602.92334, z: 1.596518},
        {x: 5633.855469, y: -632.740906, z: 1.620882},
        {x: 5588.877441, y: -501.773132, z: 5.798339},
        {x: 5518.274414, y: -486.024017, z: 3.138651},
        {x: 5561.439453, y: -448.927612, z: 5.298124},
        {x: 5562.705078, y: -471.849701, z: 2.507436},
        {x: 5551.325195, y: -525.788147, z: 2.23541},
        {x: 5538.83252, y: -541.640381, z: 8.511578},
        {x: 5596.58252, y: -575.237427, z: 2.493032},
        {x: 5566.720215, y: -635.794983, z: 15.981452},
        {x: 5613.291992, y: -702.227051, z: 4.410143},
        {x: 5617.368164, y: -519.706848, z: 0.542604},
        {x: 5531.036133, y: -437.818268, z: 1.816615},
        {x: 5481.128906, y: -389.68811, z: 4.088821},
        {x: 5487.164062, y: -353.105316, z: 3.42},
        {x: 5438.893555, y: -241.10553, z: 0.975467},
        {x: 5394.567383, y: -291.922638, z: 3.420048},
        {x: 5410.85498, y: -337.609131, z: 3.449055},
        {x: 5345.479004, y: -314.762268, z: 4.153107},
        {x: 5441.82373, y: -385.381104, z: 3.794024},
        {x: 3044.417236, y: 125.383583, z: 76.477676},
        {x: 3179.045898, y: 179.370773, z: 77.562164},
        {x: 3428.410889, y: 473.912964, z: 76.170006},
        {x: 3460.064453, y: 565.332947, z: 75.530464},
        {x: 2765.929199, y: -94.600731, z: 76.481789},
        {x: 2896.652588, y: 12.550861, z: 74.729637},
        {x: 2854.925293, y: 70.086914, z: 81.387947},
        {x: 3112.853516, y: 64.073082, z: 76.569267},
        {x: 3385.227051, y: 209.426865, z: 75.746483},
        {x: 3285.648682, y: 232.858231, z: 78.971939},
        {x: 3245.7854, y: 285.820648, z: 88.542259},
        {x: 3132.582031, y: 272.250671, z: 140.04837},
        {x: 3149.086426, y: 390.356476, z: 133.339722},
        {x: 3336.342529, y: 353.378448, z: 76.151901},
        {x: 3310.265381, y: 466.096832, z: 79.330383},
        {x: 3377.843262, y: 401.846436, z: 75.000938},
        {x: 3253.313965, y: 192.023651, z: 77.273918},
        {x: 3165.42749, y: 122.737282, z: 76.182182},
        {x: 3292.919922, y: -4.213012, z: 75.859848},
        {x: 3218.28833, y: 78.860649, z: 73.637711},
        {x: 3343.94, y: 424.41, z: 76.47},
        {x: 3348.1, y: 322.57, z: 76.33},
        {x: 3246.28, y: 218.98, z: 78.75},
        {x: 3250.53, y: 318.29, z: 90.39},
        {x: 3120.02, y: 348.59, z: 137.31},
        {x: 3231.21, y: 342.86, z: 97.99},
        {x: 3025.65, y: 106.18, z: 75.18},
        {x: 2888.9, y: -62.16, z: 77.78},
        {x: 2986.49, y: 2.34, z: 85.59},
        {x: 3178.99, y: 42.89, z: 76.6},
        {x: 3095.94, y: 138.34, z: 76.45},
        {x: 2836.24, y: -4.49, z: 76.29}
      ],
      [ESpot.PEACH_TREE]: [
        {x: 5279.480957, y: -2017.219727, z: 19.912952},
        {x: 5299.270996, y: -1968.923584, z: 11.044482},
        {x: 5304.08, y: -1731.21, z: 1.86},
        {x: 5294.193359, y: -1944.0177, z: 6.663995},
        {x: 5270.981445, y: -1947.457764, z: 29.324541},
        {x: 5272.741699, y: -1927.389893, z: 24.195801},
        {x: 5239.130859, y: -2023.852783, z: 23.92672},
        {x: 5254.634277, y: -1984.192627, z: 27.846731},
        {x: 5115.989746, y: -1461.083374, z: 8.25},
        {x: 5329.500488, y: -1823.053833, z: 3.077211},
        {x: 5285.319824, y: -1729.775757, z: 0.758342},
        {x: 5346.52832, y: -1922.006226, z: 1.747054},
        {x: 5337.679688, y: -1905.353516, z: 0.460793},
        {x: 5343.82959, y: -1860.405273, z: 3.335479},
        {x: 5352.859375, y: -1838.795776, z: 4.235955},
        {x: 5145.806641, y: -1419.809448, z: 32.370819},
        {x: 5315.18457, y: -1774.020874, z: 1.133933},
        {x: 5310.075195, y: -1744.175903, z: 1.813622},
        {x: 5161.29834, y: -1472.713013, z: 14.890517},
        {x: 5271.591309, y: -1761.024414, z: 1.723037},
        {x: 5260.715332, y: -1857.392944, z: 24.827524},
        {x: 5242.546875, y: -1464.339233, z: 4.231425},
        {x: 2331.276123, y: 451.001526, z: 1.300148},
        {x: 2134.498291, y: 310.715363, z: 2.757063},
        {x: 5274.78125, y: -1799.11145, z: 37.12117},
        {x: 5268.126465, y: -1989.231812, z: 21.252428},
        {x: 5244.484863, y: -2007.39209, z: 22.652651},
        {x: 5321.745605, y: -1976.739136, z: 9.275264},
        {x: 5338.561035, y: -1952.452271, z: 9.199999},
        {x: 5361.219238, y: -1928.587158, z: 0.777759},
        {x: 5287.560059, y: -1834.953857, z: 7.835205},
        {x: 5254.55957, y: -1690.758423, z: 1.918475},
        {x: 5271.211426, y: -1716.451416, z: 1.198955},
        {x: 5248.411621, y: -1724.395386, z: 4.511645},
        {x: 5326.266602, y: -1870.233276, z: 2.338671},
        {x: 5267.914062, y: -1934.477295, z: 38.020462},
        {x: 5299.376465, y: -1889.173706, z: 4.575152},
        {x: 5257.940918, y: -1223.029419, z: 5.256677},
        {x: 5338.467285, y: -1875.263794, z: 1.348751},
        {x: 5307.958008, y: -1860.434204, z: 5.293815},
        {x: 5321.069824, y: -1911.200439, z: 3.884751},
        {x: 5316.551758, y: -1756.454102, z: 1.473845},
        {x: 5362.728027, y: -2031.845093, z: 0.504805},
        {x: 5244.770996, y: -2042.215942, z: 18.538298},
        {x: 5281.000977, y: -1854.731079, z: 11.858056},
        {x: 1558.001099, y: 695.280029, z: 14.577651},
        {x: 5240.477539, y: -1770.085327, z: 23.442749},
        {x: 5233.75293, y: -1747.533081, z: 18.853207},
        {x: 5275.421387, y: -1822.127686, z: 27.410374},
        {x: 5433.11, y: -1944.99, z: 3.49},
        {x: 5323.131348, y: -1796.124146, z: 2.16328},
        {x: 5338.463379, y: -1823.716064, z: 2.052661},
        {x: 1699.509399, y: 201.546921, z: 1.19004},
        {x: 5258.730957, y: -1797.808594, z: 42.172775},
        {x: 5304.259766, y: -1833.906372, z: 3.363738},
        {x: 1502.418457, y: 171.148163, z: 1.142004},
        {x: 5320.959473, y: -1726.182129, z: 1.317832},
        {x: 5257.523438, y: -1675.133179, z: 0.630395},
        {x: 5244.557617, y: -1461.633789, z: 0.410243},
        {x: 5210.838867, y: -1474.090942, z: 0.609545},
        {x: 5198.716309, y: -1403.680786, z: 2.82},
        {x: 5221.974121, y: -1404.308594, z: 2.55},
        {x: 5097.094238, y: -1492.497437, z: 8.25},
        {x: 1378.367065, y: 778.085938, z: 3.13293},
        {x: 1322.593628, y: 787.456177, z: 3.508956},
        {x: 1344.304565, y: 176.680466, z: 4.771542},
        {x: 1612.924927, y: 175.88765, z: 1.154966},
        {x: 1744.917236, y: 217.387848, z: 7.380203},
        {x: 1753.812134, y: 614.391113, z: 246.503036},
        {x: 1716.780029, y: 669.643494, z: 246.53595},
        {x: 2445.878418, y: 545.624268, z: 6.400797},
        {x: 2397.868896, y: 449.41214, z: 6.49343},
        {x: 1873.431274, y: 256.518707, z: 7.614563},
        {x: 2014.064819, y: 271.825073, z: 1.693535},
        {x: 1674.699829, y: 133.780319, z: 66.299759},
        {x: 1439.695557, y: 147.503754, z: 1.80806},
        {x: 2062.544434, y: 137.918411, z: 61.018673},
        {x: 2308.30957, y: 356.291962, z: 6.652849},
        {x: 2189.79248, y: 722.581421, z: 12.639627},
        {x: 2001.352173, y: 722.635071, z: 37.692528},
        {x: 2203.5271, y: 677.399658, z: 2.723316},
        {x: 1537.371094, y: 640.285217, z: 13.433568},
        {x: 1506.732422, y: 676.138306, z: 5.819247}
      ],
      [ESpot.TERMITE_MOUND]: [
        {x: 4300.330078, y: -1667.212524, z: 52.514828},
        {x: 4289.649902, y: -1735.807129, z: 51.662971},
        {x: 4280.226562, y: -1754.730469, z: 58.661831},
        {x: 4294.806641, y: -1719.507446, z: 43.04364},
        {x: 4280.538574, y: -1720.218994, z: 58.493851},
        {x: 4437.913574, y: -1797.395874, z: 54.967667},
        {x: 4418.928223, y: -1820.623779, z: 46.752201},
        {x: 4299.956055, y: -1903.077026, z: 37.166679},
        {x: 4377.938477, y: -1947.51416, z: 45.117619},
        {x: 4290.377441, y: -1955.523315, z: 35.848835},
        {x: 4191.061523, y: -1956.021484, z: 46.540287},
        {x: 4253.407715, y: -1802.445068, z: 57.980335},
        {x: 4287.453125, y: -1826.158936, z: 37.358433},
        {x: 4210.044434, y: -1720.855713, z: 58.580791},
        {x: 4238.90332, y: -1843.912476, z: 41.543045},
        {x: 4216.041504, y: -1959.76001, z: 45.975826},
        {x: 4170.95166, y: -2007.023438, z: 56.710197},
        {x: 4180.845215, y: -2001.850952, z: 44.93},
        {x: 4231.156738, y: -2058.77002, z: 44.773556},
        {x: 4254.939941, y: -1994.134399, z: 36.342808},
        {x: 4194.485352, y: -2062.165039, z: 45.21909},
        {x: 4459.887695, y: -1897.909302, z: 47.000889},
        {x: 4578.100586, y: -1799.561279, z: 59.866989},
        {x: 4560.277344, y: -1919.526978, z: 62.660023},
        {x: 4571.418457, y: -1908.821533, z: 60.958847},
        {x: 4495.695312, y: -1891.598511, z: 60.229317},
        {x: 4395.460449, y: -1906.623535, z: 33.272881},
        {x: 4373.473145, y: -1885.136353, z: 33.864861},
        {x: 4451.198242, y: -1821.564941, z: 52.208767},
        {x: 4339.063477, y: -1829.554443, z: 35.7299},
        {x: 4351.601074, y: -1911.538086, z: 32.252449},
        {x: 4138.498047, y: -1984.601929, z: 110.700157},
        {x: 4126.830078, y: -1879.553345, z: 86.247406},
        {x: 4128.243164, y: -1875.18042, z: 85.88295},
        {x: 4148.268066, y: -1646.255005, z: 130.542099},
        {x: 4185.19873, y: -1561.662598, z: 130.067764},
        {x: 4160.177246, y: -1611.730713, z: 133.220184},
        {x: 4196.806641, y: -1586.957764, z: 125.06601},
        {x: 4218.726562, y: -1627.75354, z: 162.785294},
        {x: 4306.06543, y: -1613.719116, z: 131.545547},
        {x: 4268.17334, y: -1579.761597, z: 89.038383},
        {x: 4206.956543, y: -1571.081177, z: 119.672195},
        {x: 4227.52832, y: -1749.760254, z: 53.259953},
        {x: 4253.528809, y: -1820.944824, z: 40.766312},
        {x: 4188.136719, y: -1853.777954, z: 42.415474},
        {x: 4249.8125, y: -2065.052979, z: 84.028229},
        {x: 4432.903809, y: -1668.097656, z: 70.132324},
        {x: 4446.810059, y: -1747.093384, z: 61.800514},
        {x: 4546.174316, y: -1868.449585, z: 61.214478},
        {x: 4495.892578, y: -1934.484497, z: 66.030472},
        {x: 4511.67334, y: -1858.964722, z: 59.990082},
        {x: 4527.92041, y: -1838.501099, z: 63.47401},
        {x: 4502.105469, y: -1726.807739, z: 67.189011},
        {x: 4250.59375, y: -1780.91748, z: 47.900078},
        {x: 4184.019531, y: -2031.198853, z: 44.93},
        {x: 4473.515137, y: -1918.970459, z: 60.014225},
        {x: 4494.718262, y: -1969.677368, z: 96.717316},
        {x: 4574.026367, y: -1870.252563, z: 89.184319},
        {x: 4203.047852, y: -1693.789307, z: 102.509575}
      ],
      [ESpot.SANDALWOOD]: [
        {x: 5312.800293, y: 49.700241, z: -99.861176},
        {x: 5102.498535, y: -49.590153, z: 0.1452},
        {x: 5105.647949, y: 28.572151, z: -11.726593},
        {x: 5362.845703, y: 40.528774, z: -78.159584},
        {x: 5376.493164, y: 156.164047, z: -44.097656},
        {x: 5344.03418, y: 187.386673, z: -44.09996},
        {x: 5286.355469, y: 134.875824, z: -120.285355},
        {x: 5261.316406, y: -120.580345, z: 0.15},
        {x: 5247.904785, y: -113.437675, z: 16.993103},
        {x: 5176.848633, y: -101.656731, z: 7.15708},
        {x: 5164.5, y: -101.98745, z: 0.51769},
        {x: 5320.657227, y: -113.534111, z: 1.120965},
        {x: 5381.529297, y: -225.433289, z: 4.120193},
        {x: 5363.897461, y: -102.988899, z: 0.149691},
        {x: 5345.525391, y: -157.763428, z: 0.770025},
        {x: 5284.421875, y: -186.193756, z: 1.26},
        {x: 5267.553223, y: -108.720306, z: -14.519047},
        {x: 5209.152832, y: -86.701233, z: -36.366299},
        {x: 5112.15332, y: 35.968151, z: -39.277775},
        {x: 5383.866699, y: -43.311218, z: -11.515635},
        {x: 5134.474121, y: -38.758945, z: -10.677864},
        {x: 5117.515137, y: 129.044388, z: -44.099995},
        {x: 5169.013672, y: 176.673965, z: -44.099995},
        {x: 5137.746582, y: 111.685753, z: -21.318686},
        {x: 5080.613281, y: 77.749611, z: 4.873544},
        {x: 5094.225098, y: -17.00559, z: 0.150881},
        {x: 5149.40625, y: -78.126442, z: 20.362457},
        {x: 5318.92041, y: -242.318481, z: 3.471877},
        {x: 5553.090332, y: -42.445305, z: 0.699547},
        {x: 5418.835938, y: 163.318558, z: 3.061655},
        {x: 5083.141602, y: -162.137268, z: 2.939977},
        {x: 5329.460449, y: -249.132111, z: 15.63866},
        {x: 5493.257324, y: -177.768097, z: 0.448079},
        {x: 5394.353516, y: -93.225304, z: 0.599755},
        {x: 5431.840332, y: 70.352631, z: 0.15},
        {x: 5483.972656, y: 314.331543, z: 0.458632},
        {x: 5313.273438, y: 238.730942, z: 10.146177},
        {x: 5234.838379, y: 244.164856, z: 1.933021},
        {x: 4932.442871, y: 38.321205, z: 0.234009},
        {x: 5085.136719, y: 11.096995, z: 8.111182},
        {x: 5092.57666, y: 127.259697, z: 18.355764},
        {x: 5239.583984, y: 214.613892, z: -6.954572},
        {x: 5277.480957, y: 205.133591, z: -44.099991},
        {x: 5190.883789, y: 95.03315, z: -90.035202},
        {x: 5190.93457, y: 70.520218, z: -121.926262},
        {x: 5237.166504, y: -16.110357, z: -114.044182},
        {x: 5228.772461, y: -21.234959, z: -115.672989},
        {x: 5265.895996, y: -4.921127, z: -105.090729},
        {x: 5321.541992, y: 93.369423, z: -120.684921},
        {x: 5384.064453, y: 99.847755, z: -44.099995},
        {x: 5079.620117, y: 130.56633, z: 0.685068},
        {x: 5384.862305, y: 72.172646, z: -43.865971},
        {x: 5406.370605, y: 354.949982, z: 8.028451},
        {x: 5604.012207, y: 190.780838, z: 19.248837},
        {x: 5676.828125, y: 110.088234, z: 15.795902},
        {x: 5417.250977, y: 27.423862, z: 2.539505},
        {x: 5497.182129, y: -45.01733, z: -0.494997},
        {x: 5400.388184, y: -242.033707, z: 26.622133},
        {x: 5449.896484, y: -78.577034, z: 0.281197},
        {x: 4957.252441, y: -19.869333, z: 2.912216},
        {x: 4918.742676, y: -156.14682, z: 1.840047},
        {x: 4888.506836, y: -154.955658, z: 35.040001},
        {x: 5004.566406, y: -278.034637, z: 0.206957},
        {x: 5186.265137, y: -271.463287, z: 38.596317},
        {x: 5442.063477, y: -260.753021, z: 3.42},
        {x: 5772.674805, y: -158.289139, z: 1.104855},
        {x: 5498.519043, y: -225.007324, z: 0.145544},
        {x: 5291.314453, y: -113.542847, z: 9.093272},
        {x: 5329.033691, y: 210.889221, z: 7.446132},
        {x: 5287.045898, y: 233.719742, z: 0.127792},
        {x: 5171.289062, y: -205.029282, z: 2.319961},
        {x: 5025.749512, y: 26.512142, z: 0.458191},
        {x: 5063.222168, y: 254.522888, z: 0.816346},
        {x: 5160.753418, y: 245.735947, z: 0.139557},
        {x: 5445.438477, y: -126.023598, z: 0.709569},
        {x: 5546.830078, y: 15.560431, z: 0.670992},
        {x: 5463.794434, y: 200.514221, z: 1.344439},
        {x: 5534.955078, y: 359.414154, z: 4.556082},
        {x: 5130.333008, y: 299.157928, z: 0.620316},
        {x: 5349.071777, y: 259.380035, z: 0.772988},
        {x: 5521.591309, y: 78.131729, z: 0.62085},
        {x: 5258.553223, y: -258.00119, z: 5.156166},
        {x: 5091.27002, y: -275.409241, z: 23.79373},
        {x: 5370.931152, y: -198.363571, z: 0.459014},
        {x: 5554.644043, y: -304.534088, z: 14.689847}
      ],
      [ESpot.CEDAR]: [
        {x: 4753.301758, y: 1002.666199, z: -6.281491},
        {x: 4760.283691, y: 1064.788574, z: 10.142629},
        {x: 4753.26416, y: 1165.705566, z: 25.657972},
        {x: 4675.812012, y: 1281.530029, z: 9.273555},
        {x: 4544.937988, y: 1389.452881, z: 31.069231},
        {x: 4608.321289, y: 1206.683472, z: 31.170366},
        {x: 4538.697754, y: 1025.733887, z: 18.657923},
        {x: 4500.437988, y: 822.119324, z: 19.450006},
        {x: 4415.087402, y: 821.657532, z: 11.765571},
        {x: 4328.589844, y: 875.385315, z: 12.359771},
        {x: 4514.078613, y: 952.724915, z: 0.527036},
        {x: 4536.478516, y: 1066.07373, z: 14.964442},
        {x: 4473.847168, y: 1151.946533, z: 0.985942},
        {x: 4562.35498, y: 1190.812134, z: 30.77},
        {x: 4720.640625, y: 1222.861572, z: 30.940111},
        {x: 4668.472656, y: 1100.375488, z: -15.300202},
        {x: 4630.614258, y: 1327.040771, z: 26.706263},
        {x: 4695.096191, y: 1415.940674, z: 30.879663},
        {x: 4746.687012, y: 1306.387817, z: 14.363894},
        {x: 4843.63623, y: 1011.034546, z: 77.644463},
        {x: 5119.165039, y: 719.137146, z: 39.449211},
        {x: 4982.416016, y: 797.963257, z: 1.325952},
        {x: 4931.125488, y: 889.247498, z: 19.217321},
        {x: 4946.071289, y: 949.267273, z: 25.085447},
        {x: 4944.52832, y: 953.040344, z: 21.441137},
        {x: 4998.252441, y: 1016.94635, z: 13.522937},
        {x: 5202.537109, y: 966.070862, z: 11.47438},
        {x: 5404.356445, y: 894.997253, z: 43.116661},
        {x: 5666.390625, y: 1046.230103, z: 82.69725},
        {x: 5126.600098, y: 1368.544556, z: 9.052632},
        {x: 5069.979004, y: 1300.152954, z: 32.921509},
        {x: 4983.290039, y: 1167.502319, z: 86.489998},
        {x: 5204.522949, y: 1088.569702, z: 8.366419},
        {x: 5200.0, y: 1254.526489, z: 1.69442},
        {x: 5133.112793, y: 1420.590088, z: 12.324054},
        {x: 5120.659668, y: 1409.160645, z: 17.849819},
        {x: 5113.71582, y: 1401.557739, z: 16.196756},
        {x: 4745.117676, y: 1022.865662, z: -15.163995},
        {x: 4839.734863, y: 870.409424, z: 33.899731},
        {x: 4905.553223, y: 436.140228, z: 9.021796},
        {x: 5050.323242, y: 409.332245, z: 9.881803},
        {x: 5086.637207, y: 495.998444, z: 8.224116},
        {x: 5106.718262, y: 377.544098, z: 4.871988},
        {x: 5162.041016, y: 561.299988, z: 34.32769},
        {x: 5279.161133, y: 676.672607, z: 39.597229},
        {x: 5212.816406, y: 644.997681, z: 67.872353},
        {x: 4473.089355, y: 1031.351685, z: -4.406932},
        {x: 4543.585449, y: 831.158081, z: -15.131186},
        {x: 4302.428223, y: 934.287354, z: 0.421057},
        {x: 4847.048828, y: 1207.800415, z: 25.662029},
        {x: 4670.182617, y: 936.872742, z: 2.286494},
        {x: 4988.655762, y: 971.370117, z: 32.529278},
        {x: 5021.629395, y: 901.802612, z: 11.038098},
        {x: 4877.691406, y: 825.03064, z: 21.204782},
        {x: 5314.407227, y: 1344.269287, z: 3.506397},
        {x: 5028.353027, y: 1382.667114, z: 6.025226},
        {x: 5030.077637, y: 1086.868042, z: 111.158432},
        {x: 5112.466309, y: 1393.9198, z: 8.086065},
        {x: 5063.931152, y: 480.698547, z: 14.48043},
        {x: 5262.662598, y: 427.210236, z: 14.138165},
        {x: 5380.875977, y: 748.645691, z: 6.985828},
        {x: 5431.03418, y: 942.640137, z: 23.953335},
        {x: 5298.769531, y: 784.212158, z: 1.160078},
        {x: 4659.147949, y: 1214.589966, z: 0.427011},
        {x: 4276.210938, y: 909.0979, z: 64.831093},
        {x: 4449.635742, y: 1009.081909, z: -3.699748},
        {x: 4513.033203, y: 1071.116821, z: 2.062051},
        {x: 4564.953613, y: 1250.746094, z: 29.743523},
        {x: 4808.081543, y: 1168.81958, z: 19.487183},
        {x: 4816.129395, y: 970.393433, z: 2.838346},
        {x: 4718.501953, y: 1088.368164, z: -16.403728},
        {x: 4390.182129, y: 991.402222, z: -1.654639},
        {x: 4555.974121, y: 949.158936, z: 0.536328},
        {x: 4904.928711, y: 922.967102, z: 15.932472},
        {x: 4977.196777, y: 903.756348, z: 21.511808},
        {x: 5123.494141, y: 796.696777, z: 23.000841},
        {x: 5139.641113, y: 1047.906128, z: 3.35},
        {x: 4724.59082, y: 976.481262, z: -1.342699},
        {x: 4846.035645, y: 973.413574, z: 9.305758},
        {x: 5423.255371, y: 702.033447, z: 6.232586}
      ],
      [ESpot.SPRUCE]: [
        {x: 4003.484375, y: 939.102966, z: 149.226898},
        {x: 3983.834961, y: 817.608826, z: 174.152588},
        {x: 3981.497803, y: 837.309631, z: 192.668869},
        {x: 3793.760986, y: 731.420044, z: 53.285362},
        {x: 3787.517578, y: 776.18927, z: 88.944},
        {x: 3838.696533, y: 790.977722, z: 97.153702},
        {x: 3868.007324, y: 862.669495, z: 105.727478},
        {x: 3965.814453, y: 867.260864, z: 108.579506},
        {x: 3718.194824, y: 654.393433, z: 23.870127},
        {x: 3948.831299, y: 565.421265, z: 182.237564},
        {x: 3898.741699, y: 606.456116, z: 203.020142},
        {x: 3682.570801, y: 571.461853, z: 56.919827},
        {x: 3786.36377, y: 854.123291, z: 200.981476},
        {x: 3892.34668, y: 1142.171875, z: 71.380608},
        {x: 3731.278564, y: 1028.465088, z: 18.700039},
        {x: 3918.242676, y: 1243.646851, z: 127.407005},
        {x: 3872.578857, y: 1209.532593, z: 68.716675},
        {x: 3869.537842, y: 1135.768799, z: 38.767918},
        {x: 3684.779541, y: 1070.991455, z: 0.785544},
        {x: 3671.942627, y: 1167.757935, z: 29.20001},
        {x: 3826.703857, y: 1251.211792, z: 70.35759},
        {x: 3803.999512, y: 1149.466431, z: 47.310177},
        {x: 3874.776367, y: 941.389099, z: 160.767731},
        {x: 3819.098877, y: 716.191528, z: 88.99614},
        {x: 4040.593994, y: 283.349945, z: 24.147085},
        {x: 4155.55957, y: 373.350342, z: 49.369999},
        {x: 4135.729004, y: 489.369171, z: 133.349152},
        {x: 3737.879883, y: 1213.286499, z: 61.477329},
        {x: 3661.922852, y: 1200.899292, z: 58.486374},
        {x: 3836.175293, y: 619.246826, z: 104.032028},
        {x: 3776.119629, y: 818.091064, z: 94.517761},
        {x: 3971.635498, y: 698.254944, z: 233.631638},
        {x: 4260.788086, y: 515.270447, z: 166.024811},
        {x: 4176.28125, y: 704.705261, z: 192.682953},
        {x: 4151.17627, y: 817.038818, z: 180.773926},
        {x: 4164.188477, y: 959.039917, z: 78.65152},
        {x: 4241.234863, y: 865.546021, z: 115.889023},
        {x: 4202.677734, y: 746.622131, z: 87.146683},
        {x: 4218.921387, y: 698.298889, z: 147.397324},
        {x: 3768.09375, y: 835.598633, z: 131.239487},
        {x: 3947.60791, y: 751.093262, z: 137.891708},
        {x: 3728.082764, y: 927.324524, z: 125.308769},
        {x: 3673.135986, y: 943.23291, z: 0.695304},
        {x: 3910.923584, y: 755.044495, z: 114.827789},
        {x: 4234.120117, y: 845.386414, z: 129.913727},
        {x: 3926.596924, y: 992.263672, z: 182.687912},
        {x: 3885.009766, y: 1075.851929, z: 147.886932},
        {x: 3841.136475, y: 713.990234, z: 103.458763},
        {x: 4266.338867, y: 864.624756, z: 75.519569},
        {x: 3749.051025, y: 1271.790039, z: 115.768364},
        {x: 3733.062988, y: 1123.141357, z: 2.54629},
        {x: 3649.531494, y: 817.630188, z: 4.843601},
        {x: 3931.390381, y: 732.064575, z: 147.348114},
        {x: 4109.838867, y: 932.202271, z: 173.496384},
        {x: 3916.786133, y: 923.646301, z: 143.94278},
        {x: 4051.681885, y: 614.801514, z: 267.329285},
        {x: 4022.837891, y: 834.071716, z: 261.185791},
        {x: 4071.296143, y: 299.166656, z: 62.777153},
        {x: 4259.137695, y: 874.925415, z: 67.735458},
        {x: 4002.477051, y: 922.1828, z: 122.443527},
        {x: 4258.403809, y: 952.639099, z: 18.962194},
        {x: 4037.450684, y: 963.48291, z: 223.812607},
        {x: 3807.579102, y: 920.98053, z: 247.363831},
        {x: 3657.370361, y: 728.361023, z: 78.675072},
        {x: 3858.742676, y: 826.427368, z: 102.152634},
        {x: 4226.742676, y: 921.160522, z: 33.390602},
        {x: 4034.687012, y: 903.795044, z: 122.405014},
        {x: 3890.431885, y: 855.314697, z: 104.512108},
        {x: 3831.428223, y: 816.736816, z: 100.515572},
        {x: 3857.17627, y: 690.556335, z: 103.553825},
        {x: 3779.831543, y: 1214.176636, z: 56.205605},
        {x: 3846.822754, y: 756.561462, z: 102.843979},
        {x: 3934.792969, y: 576.798523, z: 196.801102},
        {x: 3968.496338, y: 719.734741, z: 250.510788},
        {x: 3743.900146, y: 1001.158386, z: 117.741989},
        {x: 3915.845703, y: 740.823059, z: 138.562286},
        {x: 3796.456299, y: 615.116211, z: 107.014725},
        {x: 4006.612305, y: 817.508362, z: 210.248413},
        {x: 4141.833008, y: 1000.382568, z: 249.451309},
        {x: 4227.354004, y: 1081.904541, z: 224.478546}
      ],
      [ESpot.GLOWING_MUSHROOM]: [
        {x: 642.673157, y: 1956.883423, z: 37.231552},
        {x: 603.646301, y: 2119.452637, z: -56.796383},
        {x: 691.131958, y: 2107.006592, z: 49.271202},
        {x: 499.335449, y: 2145.565918, z: 18.039085},
        {x: 609.325806, y: 2080.129883, z: -31.30859},
        {x: 496.592163, y: 1914.970093, z: 49.079857},
        {x: 480.733337, y: 2030.994263, z: 44.054691},
        {x: 439.931793, y: 2007.711548, z: 61.151688},
        {x: 370.839569, y: 2073.165039, z: 54.387337},
        {x: 164.344574, y: 1800.104492, z: 25.169998},
        {x: 197.739502, y: 1945.692383, z: 29.379997},
        {x: 228.605545, y: 1814.952393, z: 30.951082},
        {x: 216.915924, y: 1755.674438, z: 49.149998},
        {x: 391.155457, y: 1650.68811, z: 45.384193},
        {x: 482.720093, y: 1612.921631, z: 62.359314},
        {x: 539.875488, y: 1589.232788, z: 101.313751},
        {x: 658.48761, y: 1819.067261, z: 114.962662},
        {x: 773.164978, y: 1693.77356, z: 81.28157},
        {x: 511.651337, y: 1452.145874, z: 180.9841},
        {x: 438.552643, y: 1429.168213, z: 180.204834},
        {x: 193.426987, y: 1592.803955, z: 98.173325},
        {x: 192.344391, y: 1698.109375, z: 81.809685},
        {x: 262.613281, y: 1672.844604, z: 51.750072},
        {x: 325.054871, y: 1904.215698, z: 29.21151},
        {x: 341.376343, y: 1985.061523, z: 27.546539},
        {x: 225.080185, y: 2072.723877, z: 41.499466},
        {x: 190.584518, y: 2008.578491, z: 40.369091},
        {x: 148.18782, y: 1959.750366, z: 29.478802},
        {x: 326.752838, y: 1480.226074, z: 127.715141},
        {x: 218.42247, y: 1418.11853, z: 45.705524},
        {x: 350.312592, y: 1189.131714, z: 49.653149},
        {x: 435.32782, y: 1192.965088, z: 73.111794},
        {x: 307.927917, y: 1266.152466, z: 54.293056},
        {x: 269.681549, y: 1176.973389, z: 35.413757},
        {x: 245.393661, y: 1074.826782, z: 37.807735},
        {x: 365.794739, y: 1006.24469, z: 57.030552},
        {x: 561.767456, y: 1113.884766, z: 103.291779},
        {x: 691.157471, y: 1376.654907, z: 122.7379},
        {x: 528.119934, y: 1339.479492, z: 195.798737},
        {x: 597.242065, y: 1349.900513, z: 206.150406},
        {x: 835.399231, y: 1375.550049, z: 74.421173},
        {x: 726.506775, y: 1109.56604, z: 213.832825},
        {x: 999.50647, y: 1062.00354, z: 167.81749},
        {x: 985.206238, y: 1297.017822, z: 167.905502},
        {x: 926.347351, y: 1824.663574, z: 207.229324},
        {x: 789.626953, y: 1842.22229, z: 151.233948},
        {x: 643.390015, y: 2096.087158, z: 31.53562},
        {x: 445.49118, y: 2097.116211, z: 75.321938},
        {x: 460.492035, y: 2222.024414, z: 28.589283},
        {x: 397.26709, y: 2131.784424, z: 60.616402},
        {x: 364.144623, y: 1915.82019, z: 41.029995},
        {x: 110.989357, y: 1553.813477, z: 37.905155},
        {x: 168.179367, y: 1435.984253, z: 67.622726},
        {x: 300.449951, y: 1565.613525, z: 90.424637},
        {x: 218.262955, y: 1999.067139, z: 38.010754},
        {x: 325.259277, y: 1380.884888, z: 90.328484},
        {x: 599.520203, y: 1681.600464, z: 63.167713},
        {x: 276.114166, y: 1573.624023, z: 88.822327},
        {x: 319.022552, y: 1581.683105, z: 83.784569},
        {x: 833.598572, y: 1498.866821, z: 32.847366}
      ],
      [ESpot.MAPLE]: [
        {x: 538.903625, y: 179.930252, z: 18.150618},
        {x: 502.928284, y: 275.554779, z: 51.712624},
        {x: 617.796326, y: 402.492798, z: 35.704357},
        {x: 367.225525, y: 427.062256, z: 50.057781},
        {x: 362.790436, y: 370.649872, z: 51.782902},
        {x: 437.664215, y: 208.478104, z: 51.802814},
        {x: 458.964081, y: 262.563232, z: 62.890003},
        {x: 467.562988, y: 388.883209, z: 51.467758},
        {x: 212.136429, y: 423.201172, z: 71.305038},
        {x: 139.891724, y: 560.004211, z: 74.060081},
        {x: 118.732864, y: 386.347717, z: 63.461853},
        {x: 243.772949, y: 369.709198, z: 62.500927},
        {x: 251.94397, y: 270.052765, z: 52.152191},
        {x: 168.784409, y: 237.789932, z: 51.872601},
        {x: 278.475494, y: 434.700775, z: 62.122261},
        {x: 138.813904, y: 180.558121, z: 99.629356},
        {x: 295.022461, y: 367.879852, z: 53.053722},
        {x: 394.231323, y: -12.628775, z: 40.851032},
        {x: 466.653473, y: 15.098372, z: 37.932598},
        {x: 365.047577, y: 43.135838, z: 52.447742},
        {x: 446.84436, y: 80.41787, z: 38.512596},
        {x: 461.20163, y: 118.403175, z: 40.169094},
        {x: 521.760193, y: 120.391457, z: 20.769367},
        {x: 490.402588, y: 168.377991, z: 24.32988},
        {x: 572.243103, y: 199.541153, z: 28.260992},
        {x: 606.337402, y: 277.829315, z: 21.483732},
        {x: 672.582642, y: 295.558716, z: 30.041412},
        {x: 753.227478, y: 299.862213, z: 36.322586},
        {x: 743.989258, y: 180.561676, z: 18.313494},
        {x: 636.001709, y: 203.395737, z: 18.847776},
        {x: 585.715759, y: 107.271309, z: 19.658484},
        {x: 683.483337, y: 108.382011, z: 18.819958},
        {x: 680.891968, y: -5.545093, z: 18.139997},
        {x: 624.675903, y: -18.494162, z: 17.5819},
        {x: 656.29126, y: -165.136383, z: 22.649437},
        {x: 882.408142, y: -0.341975, z: 9.333238},
        {x: 833.866455, y: 203.726761, z: 56.419518},
        {x: 777.107849, y: 109.61615, z: 32.375481},
        {x: 766.921875, y: 308.401764, z: 46.923985},
        {x: 577.809631, y: 460.79306, z: 51.701015},
        {x: 271.27121, y: 636.059875, z: 65.091087},
        {x: 350.058533, y: 750.516052, z: 64.799431},
        {x: 252.02301, y: 657.656372, z: 64.509071},
        {x: 42.210224, y: 402.640594, z: 103.448906},
        {x: 408.642853, y: -93.291359, z: 26.579077},
        {x: 501.94342, y: -144.093536, z: 20.939421},
        {x: 435.728394, y: -78.698547, z: 24.475111},
        {x: 265.969147, y: 87.714127, z: 52.379528},
        {x: 407.119965, y: 87.47522, z: 51.683151},
        {x: 598.502319, y: 197.020401, z: 21.389997},
        {x: 851.274902, y: 470.370422, z: 49.493374},
        {x: 100.280708, y: 218.75647, z: 100.068359},
        {x: 76.082787, y: 467.77655, z: 63.344177},
        {x: 269.130463, y: 570.994934, z: 62.805691},
        {x: 375.584045, y: 714.857544, z: 52.576878},
        {x: 143.777344, y: 636.192383, z: 94.884048},
        {x: 31.195662, y: 257.937042, z: 127.575455},
        {x: 309.899414, y: 24.812613, z: 53.260494},
        {x: 598.327515, y: 462.702301, z: 31.940001},
        {x: 409.320068, y: 836.773071, z: 112.602951},
        {x: 379.539154, y: 88.386696, z: 52.236668},
        {x: 370.619751, y: 412.719818, z: 51.640034},
        {x: 230.290802, y: 489.638855, z: 62.995533},
        {x: 303.32663, y: 656.316711, z: 64.708328},
        {x: 300.044678, y: 725.823792, z: 65.063629},
        {x: 213.034515, y: 2099.410889, z: 37.626156},
        {x: 221.913116, y: 2210.206787, z: 26.871862},
        {x: 122.208939, y: 2169.743652, z: 42.412407},
        {x: 166.408524, y: 2025.814941, z: 40.413689},
        {x: 57.084171, y: 2066.871338, z: 44.989216},
        {x: 35.41338, y: 2113.40332, z: 62.989998},
        {x: -1.292668, y: 2239.057373, z: 76.650093},
        {x: 191.70575, y: 2083.203125, z: 40.073559},
        {x: 538.092529, y: 241.766403, z: 33.959995},
        {x: 485.834869, y: 124.020195, z: 29.375938},
        {x: 279.40979, y: 13.997451, z: 54.241711},
        {x: 258.465485, y: 276.388397, z: 51.945965},
        {x: 417.96109, y: 294.928314, z: 52.238754},
        {x: 435.727478, y: 125.920319, z: 51.718155},
        {x: 403.74939, y: 46.97319, z: 39.908489}
      ],
      [ESpot.GOLDEN_OAK]: [
        {x: -2274.156738, y: 603.816101, z: 85.069679},
        {x: -2527.112793, y: 408.62854, z: 91.041542},
        {x: -3120.86792, y: 278.370178, z: 137.657486},
        {x: -3203.734375, y: 273.788391, z: 114.875328},
        {x: -2926.842529, y: -157.183044, z: 148.558105},
        {x: -2836.687012, y: -128.503387, z: 144.036743},
        {x: -2550.90918, y: -144.031357, z: 126.110001},
        {x: -2934.867188, y: 342.29126, z: 98.049995},
        {x: -2740.423828, y: 56.124218, z: 219.735611},
        {x: -2787.880615, y: -6.352771, z: 193.922363},
        {x: -2829.477295, y: -23.986071, z: 181.815643},
        {x: -2915.773193, y: 9.682993, z: 109.514893},
        {x: -2905.639648, y: 209.728485, z: 102.395378},
        {x: -2805.454102, y: 250.928558, z: 101.476891},
        {x: -2652.319824, y: 371.483215, z: 90.712181},
        {x: -2438.19873, y: 380.448059, z: 95.921509},
        {x: -2362.29248, y: 407.437775, z: 110.877258},
        {x: -2019.087891, y: 745.911011, z: 148.45903},
        {x: -2319.952148, y: 346.60788, z: 222.96788},
        {x: -2422.780762, y: 294.335052, z: 162.993835},
        {x: -2640.647217, y: 330.299835, z: 111.959999},
        {x: -2723.912842, y: 284.449524, z: 103.93},
        {x: -2839.28418, y: 307.293579, z: 98.30999},
        {x: -2968.524658, y: 72.697006, z: 112.648643},
        {x: -3050.209229, y: 102.591568, z: 152.043945},
        {x: -3018.626221, y: 35.816471, z: 150.119766},
        {x: -3084.94043, y: -111.106094, z: 220.27417},
        {x: -2904.67749, y: -197.172272, z: 165.974579},
        {x: -2758.993652, y: -252.184738, z: 229.268967},
        {x: -2743.958008, y: -212.255005, z: 200.348083},
        {x: -2680.95752, y: 41.357311, z: 184.663269},
        {x: -2543.537842, y: 103.05835, z: 119.296379},
        {x: -2615.748047, y: 220.479797, z: 113.423203},
        {x: -2505.41626, y: 287.514709, z: 132.599991},
        {x: -2611.916992, y: 374.466492, z: 93.806274},
        {x: -3048.45459, y: -39.019085, z: 150.452469},
        {x: -2954.647949, y: -121.012894, z: 149.844421},
        {x: -2886.462158, y: 8.387936, z: 114.760597},
        {x: -2806.567139, y: 95.607239, z: 204.591293},
        {x: -2655.032227, y: 158.667526, z: 127.769997},
        {x: -2562.395996, y: 163.804092, z: 112.631889},
        {x: -2277.663086, y: 111.44558, z: 132.919571},
        {x: -2408.53125, y: 142.65744, z: 117.621193},
        {x: -2695.874023, y: -49.584854, z: 168.655396},
        {x: -2756.175293, y: -51.597511, z: 185.227341},
        {x: -2764.986816, y: 34.150925, z: 215.746017},
        {x: -2682.035889, y: 151.089661, z: 143.910004},
        {x: -2618.651123, y: 28.997904, z: 127.761909},
        {x: -2625.835938, y: -35.798389, z: 130.180817},
        {x: -2836.306885, y: -54.347599, z: 155.561295},
        {x: -2625.697266, y: -295.407898, z: 152.249939},
        {x: -2605.399902, y: -348.004242, z: 133.646683},
        {x: -2418.351318, y: -310.928772, z: 135.149384},
        {x: -2313.504639, y: -145.198914, z: 155.945404},
        {x: -2493.415527, y: 48.417274, z: 118.153305},
        {x: -3353.534424, y: 410.738617, z: 72.23703},
        {x: -3190.375, y: 443.594299, z: 68.652031},
        {x: -3279.211426, y: 537.732971, z: 65.276093},
        {x: -3115.352539, y: 558.78241, z: 185.956329},
        {x: -2619.898926, y: -210.941376, z: 138.578934},
        {x: -2502.977051, y: -36.447113, z: 121.911568},
        {x: -2557.64502, y: 312.874756, z: 104.812225},
        {x: -2499.125977, y: 374.221924, z: 94.493782},
        {x: -2549.677246, y: -339.871552, z: 120.914742},
        {x: -2831.943848, y: 15.498067, z: 187.498642},
        {x: -2923.418213, y: 157.932953, z: 102.157265},
        {x: -2976.052979, y: 315.356445, z: 103.797791},
        {x: -3067.197754, y: 291.895172, z: 100.950294},
        {x: -3317.251465, y: 289.004822, z: 64.302132},
        {x: -3293.754639, y: 407.40506, z: 64.587242},
        {x: -3224.2854, y: 606.633972, z: 64.407135},
        {x: -2869.076416, y: 230.563766, z: 98.339996},
        {x: -2622.352295, y: 289.454529, z: 113.889999},
        {x: -2598.349365, y: 226.768951, z: 111.652969},
        {x: -2460.808838, y: 86.547729, z: 117.342751},
        {x: -2518.436279, y: -95.769783, z: 120.870003},
        {x: -2442.626709, y: -169.212921, z: 137.879654},
        {x: -2389.826416, y: -211.97583, z: 139.396912},
        {x: -2536.960938, y: -199.893768, z: 124.019997}
      ],
      [ESpot.DEAD_TREE]: [
        {x: -3726.033203, y: -3961.740479, z: 83.238541},
        {x: -3591.89624, y: -3705.695068, z: 52.363491},
        {x: -3558.373535, y: -3718.493408, z: 51.011402},
        {x: -3560.311279, y: -3757.886475, z: 60.544495},
        {x: -3826.234131, y: -3832.080322, z: 88.650681},
        {x: -3996.067139, y: -4046.748535, z: 130.210022},
        {x: -3906.799561, y: -4327.144043, z: 164.631592},
        {x: -3668.461426, y: -4481.742188, z: 141.396606},
        {x: -3527.893066, y: -4400.555664, z: 146.165939},
        {x: -3434.428711, y: -4342.272949, z: 102.278397},
        {x: -3599.5979, y: -3507.343506, z: 104.694809},
        {x: -3415.892822, y: -3590.762695, z: 93.607727},
        {x: -3463.300537, y: -3613.15625, z: 88.304596},
        {x: -3434.745117, y: -3666.334473, z: 72.621231},
        {x: -3359.398438, y: -3808.63916, z: 15.732034},
        {x: -3392.717529, y: -3769.09668, z: 55.972599},
        {x: -3428.789307, y: -3741.468506, z: 46.555069},
        {x: -3544.594727, y: -3839.785645, z: 79.881813},
        {x: -3653.661377, y: -3936.532471, z: 81.633286},
        {x: -3835.301514, y: -4368.177734, z: 176.920547},
        {x: -3381.34082, y: -4245.431641, z: 94.362259},
        {x: -3278.286865, y: -3918.689941, z: 41.424965},
        {x: -3212.118896, y: -3961.841797, z: 45.818642},
        {x: -3129.19165, y: -3920.700684, z: 66.158806},
        {x: -3117.89624, y: -4063.507324, z: 26.43087},
        {x: -3143.949951, y: -4128.507812, z: 8.986939},
        {x: -3097.318115, y: -4129.643555, z: 23.57877},
        {x: -3230.272217, y: -4181.716797, z: 36.45599},
        {x: -3455.291504, y: -4195.001953, z: 131.992645},
        {x: -3886.145752, y: -3956.351074, z: 115.082222},
        {x: -3969.365723, y: -4130.265625, z: 154.230225},
        {x: -3963.260742, y: -4108.865234, z: 155.000137},
        {x: -2798.611572, y: -3922.368408, z: 196.050095},
        {x: -2807.419434, y: -3801.751953, z: 261.638733},
        {x: -2667.236328, y: -3883.239502, z: 260.977875},
        {x: -3489.481445, y: -3598.405518, z: 96.421638},
        {x: -3261.514404, y: -3332.746338, z: 117.178154},
        {x: -3208.551025, y: -3210.972168, z: 136.949203},
        {x: -3308.981445, y: -3046.453613, z: 189.399551},
        {x: -3310.166016, y: -2989.85498, z: 177.01683},
        {x: -3467.066162, y: -3089.515137, z: 175.847473},
        {x: -3607.179199, y: -3050.925049, z: 146.370285},
        {x: -3683.229492, y: -3033.922119, z: 139.605713},
        {x: -3753.002686, y: -2969.683105, z: 131.082413},
        {x: -3713.932617, y: -2989.225098, z: 129.273407},
        {x: -3701.967041, y: -2968.42749, z: 131.51889},
        {x: -3823.725342, y: -2829.382324, z: 130.292374},
        {x: -3793.786865, y: -3056.562256, z: 141.902298},
        {x: -3601.583008, y: -3222.392822, z: 130.896423},
        {x: -3426.727539, y: -3183.16748, z: 167.425079},
        {x: -3298.112549, y: -3166.527588, z: 155.93367},
        {x: -3115.397461, y: -3260.088135, z: 121.217804},
        {x: -3084.13623, y: -3148.383789, z: 131.435532},
        {x: -3000.956787, y: -2982.155518, z: 122.779999},
        {x: -2971.258545, y: -2933.451904, z: 110.599365},
        {x: -3065.286621, y: -2940.640137, z: 161.892105},
        {x: -2768.393799, y: -2775.240479, z: 134.255798},
        {x: -2709.359863, y: -2635.470703, z: 115.495049},
        {x: -3033.675537, y: -2873.966309, z: 161.659256},
        {x: -3575.668457, y: -4058.132812, z: 77.023849},
        {x: -2992.536133, y: -2861.264893, z: 159.358902},
        {x: -3509.745361, y: -3718.502441, z: 46.519485},
        {x: -3419.558105, y: -3775.987793, z: 38.249664},
        {x: -3248.224609, y: -4006.98999, z: 35.829498},
        {x: -3161.624756, y: -4042.826172, z: 28.470469},
        {x: -3622.704102, y: -3612.056641, z: 72.427429},
        {x: -3375.590088, y: -3338.560303, z: 119.796257},
        {x: -3399.78418, y: -3304.134033, z: 121.262573},
        {x: -3464.105957, y: -3243.866211, z: 123.109932},
        {x: -3544.697266, y: -3237.945801, z: 137.522751},
        {x: -3632.538086, y: -3182.764648, z: 136.619919},
        {x: -3638.48877, y: -3142.578857, z: 136.600006},
        {x: -3722.316162, y: -3033.771973, z: 136.600006},
        {x: -3355.550781, y: -3174.734863, z: 161.801727},
        {x: -3182.924561, y: -3234.264648, z: 128.096649},
        {x: -3128.600342, y: -3210.842773, z: 124.71463},
        {x: -3126.943359, y: -3180.00708, z: 132.856674},
        {x: -3083.788574, y: -3103.035645, z: 135.875107},
        {x: -2994.396484, y: -3098.497559, z: 130.780045},
        {x: -2943.103271, y: -2951.349609, z: 112.472099}
      ],
    
      // ECategory.MERCHANT
      [ESpot.RETAILER]: [
        {x: 5543, y: -1682, z: 20},
        {x: 1705, y: 552, z: 6},
        {x: -2797, y: 1169, z: 337},
      ],
      [ESpot.M1]: [
        {x: 5536, y: -1236, z: 56},
        {x: 2124, y: 637, z: 6}
      ],
      [ESpot.M2]: [
        {x: 5592, y: -2358, z: 17},
        {x: 2115, y: 587, z: 3}
      ],
      [ESpot.M3]: [
        {x: 4960, y: -1923, z: 40},
        {x: 2100, y: 575, z: 4}
      ],
      [ESpot.M4]: [
        {x: 5422, y: -303, z: 3},
        {x: 2111, y: 657, z: 6}
      ],
      [ESpot.M5]: [
        {x: 4818, y: 1648, z: 28},
        {x: 1983, y: 559, z: 6}
      ],
      [ESpot.M6]: [
        {x: 5169, y: 1170, z: 12},
        {x: 2166, y: 668, z: 3}
      ],
      [ESpot.M7]: [
        {x: 4519, y: 869, z: 19},
        {x: 1994, y: 516, z: 6}
      ],
      [ESpot.M8]: [
        {x: 4764, y: 136, z: 151},
        {x: 2004, y: 563, z: 6}
      ],
      [ESpot.M9]: [
        {x: 273, y: 1808, z: 24},
        {x: 2059, y: 561, z: 6}
      ],
      [ESpot.M10]: [
        {x: 2041, y: 562, z: 6}
      ],
      [ESpot.M11]: [
        {x: 574, y: 3900, z: 35},
        {x: 1941, y: 534, z: 6}
      ],
      [ESpot.M12]: [
        {x: -2855, y: -1344, z: 30},
        {x: 2031, y: 656, z: 6}
      ],
      [ESpot.M13]: [
        {x: -2794, y: 1122, z: 338},
        {x: 2064, y: 639, z: 6}
      ],
    
      // ECategory.FISHING
    
      
      // ECategory.SHADOW
      [ESpot.SHADOW_1]: [
        {x: 5182.0, y: -2351.0, z: 62.0},
        {x: 4941.0, y: -2510.0, z: 43.0},
        {x: 4781.0, y: -2437.0, z: 49.0},
        {x: 4641.0, y: -2545.0, z: 27.0},
        {x: 4714.0, y: -2449.0, z: 45.0},
        {x: 4906.0, y: -2549.0, z: 39.0},
        {x: 5020.0, y: -2624.0, z: 49.0},
        {x: 5302.0, y: -2601.0, z: 48.0},
        {x: 5438.0, y: -2660.0, z: 63.0},
        {x: 5378.0, y: -2554.0, z: 69.0},
        {x: 5280.0, y: -2448.0, z: 51.0},
        {x: 5328.0, y: -2354.0, z: 65.0},
        {x: 5154.0, y: -2425.0, z: 60.0},
        {x: 5052.0, y: -2361.0, z: 60.0},
        {x: 5012.0, y: -2448.0, z: 52.0},
        {x: 5082.0, y: -2523.0, z: 53.0},
        {x: 5168.0, y: -2538.0, z: 52.0},
        {x: 5183.0, y: -2652.0, z: 51.0},
        {x: 5013.0, y: -2538.0, z: 45.0},
        {x: 4955.0, y: -2344.0, z: 73.0},
        {x: 4755.0, y: -2383.0, z: 44.0},
        {x: 4864.0, y: -2460.0, z: 42.0},
        {x: 4742.0, y: -2518.0, z: 34.0},
        {x: 5170.0, y: -2599.0, z: 52.0},
        {x: 5221.0, y: -2462.0, z: 51.0},
        {x: 5086.0, y: -2436.0, z: 58.0},
        {x: 4997.0, y: -2512.0, z: 44.0},
        {x: 5022.0, y: -2605.0, z: 49.0},
        {x: 5217.0, y: -2571.0, z: 46.0},
        {x: 5296.0, y: -2562.0, z: 46.0},
        {x: 5336.0, y: -2700.0, z: 54.0},
        {x: 5382.0, y: -2685.0, z: 57.0},
        {x: 5403.0, y: -2596.0, z: 69.0},
        {x: 5372.0, y: -2505.0, z: 69.0},
        {x: 5339.0, y: -2439.0, z: 67.0},
        {x: 5248.0, y: -2454.0, z: 49.0},
        {x: 5152.0, y: -2382.0, z: 62.0},
        {x: 5158.0, y: -2476.0, z: 51.0},
        {x: 5102.0, y: -2412.0, z: 59.0}
      ],
      [ESpot.SHADOW_2]: [
        {x: 4255.0, y: -1967.0, z: 34.0},
        {x: 4275.0, y: -2013.0, z: 37.0},
        {x: 4238.0, y: -2033.0, z: 43.0},
        {x: 4406.0, y: -1869.0, z: 33.0},
        {x: 4460.0, y: -1808.0, z: 53.0},
        {x: 4478.0, y: -1754.0, z: 59.0},
        {x: 4437.0, y: -1689.0, z: 66.0},
        {x: 4319.0, y: -1743.0, z: 38.0},
        {x: 4279.0, y: -1825.0, z: 37.0},
        {x: 4240.0, y: -1834.0, z: 40.0},
        {x: 4217.0, y: -1878.0, z: 36.0},
        {x: 4205.0, y: -2005.0, z: 44.0},
        {x: 4338.0, y: -1943.0, z: 32.0},
        {x: 4365.0, y: -1906.0, z: 31.0},
        {x: 4525.0, y: -1882.0, z: 59.0},
        {x: 4516.0, y: -1791.0, z: 59.0},
        {x: 4340.0, y: -1807.0, z: 33.0},
        {x: 4223.0, y: -1909.0, z: 37.0},
        {x: 4347.0, y: -1870.0, z: 33.0},
        {x: 4298.0, y: -1867.0, z: 33.0},
        {x: 4317.0, y: -1828.0, z: 35.0},
        {x: 4317.0, y: -1902.0, z: 35.0},
        {x: 4260.0, y: -1941.0, z: 34.0},
        {x: 4240.0, y: -1873.0, z: 36.0},
        {x: 4326.0, y: -1784.0, z: 35.0},
        {x: 4560.0, y: -1894.0, z: 60.0},
        {x: 4565.0, y: -1804.0, z: 60.0},
        {x: 4499.0, y: -1768.0, z: 60.0},
        {x: 4478.0, y: -1774.0, z: 58.0}
      ],
      [ESpot.SHADOW_3]: [
        {x: 5068.0, y: 117.0, z: 0.0},
        {x: 5015.0, y: 21.0, z: 0.0},
        {x: 5419.0, y: -66.0, z: -0.0},
        {x: 5202.0, y: 112.0, z: -34.0},
        {x: 5305.0, y: 111.0, z: -34.0},
        {x: 5399.0, y: 60.0, z: -38.0},
        {x: 5307.0, y: 7.0, z: -35.0},
        {x: 5184.0, y: -9.0, z: -34.0},
        {x: 5236.0, y: 57.0, z: -75.0},
        {x: 5217.0, y: -56.0, z: -35.0},
        {x: 5209.0, y: -124.0, z: 0.0},
        {x: 5453.0, y: 16.0, z: -0.0},
        {x: 5455.0, y: 94.0, z: -0.0},
        {x: 5436.0, y: 158.0, z: -0.0},
        {x: 5357.0, y: 226.0, z: -0.0},
        {x: 5282.0, y: 249.0, z: 0.0},
        {x: 5202.0, y: 248.0, z: 0.0},
        {x: 5147.0, y: 230.0, z: 0.0},
        {x: 5147.0, y: 230.0, z: 0.0},
        {x: 5045.0, y: 177.0, z: 1.0},
        {x: 4968.0, y: 75.0, z: 4.0},
        {x: 5493.0, y: -5.0, z: 0.0},
        {x: 5504.0, y: 92.0, z: 0.0},
        {x: 5478.0, y: 184.0, z: 1.0},
        {x: 5253.0, y: 167.0, z: -35.0},
        {x: 5441.0, y: -127.0, z: 0.0},
        {x: 5532.0, y: 144.0, z: 1.0}
      ],
      [ESpot.SHADOW_4]: [
        {x: 4755.0, y: 1380.0, z: 12.0},
        {x: 4826.0, y: 1502.0, z: 9.0},
        {x: 4916.0, y: 1542.0, z: 9.0},
        {x: 4744.0, y: 1512.0, z: 9.0},
        {x: 4704.0, y: 1549.0, z: 12.0},
        {x: 4663.0, y: 1503.0, z: 16.0},
        {x: 4628.0, y: 1573.0, z: 9.0},
        {x: 4726.0, y: 1656.0, z: 38.0},
        {x: 4665.0, y: 1682.0, z: 39.0},
        {x: 4776.0, y: 1688.0, z: 38.0},
        {x: 4850.0, y: 1451.0, z: 5.0},
        {x: 4931.0, y: 1471.0, z: 5.0},
        {x: 4928.0, y: 1391.0, z: 11.0},
        {x: 4899.0, y: 1621.0, z: 20.0},
        {x: 4754.0, y: 1341.0, z: 12.0},
        {x: 4675.0, y: 1635.0, z: 38.0},
        {x: 4803.0, y: 1345.0, z: 19.0},
        {x: 4841.0, y: 1483.0, z: 5.0},
        {x: 4806.0, y: 1643.0, z: 27.0},
        {x: 4676.0, y: 1560.0, z: 12.0},
        {x: 4802.0, y: 1707.0, z: 41.0},
        {x: 4763.0, y: 1712.0, z: 38.0},
        {x: 4714.0, y: 1338.0, z: 11.0},
        {x: 4898.0, y: 1304.0, z: 7.0},
        {x: 4762.0, y: 1301.0, z: 14.0},
        {x: 4659.0, y: 1412.0, z: 28.0}
      ],
      [ESpot.SHADOW_5]: [
        {x: -2757.0, y: 264.0, z: 99.0},
        {x: -2524.0, y: 386.0, z: 93.0},
        {x: -2597.0, y: 303.0, z: 117.0},
        {x: -2582.0, y: 217.0, z: 111.0},
        {x: -2528.0, y: 112.0, z: 119.0},
        {x: -2466.0, y: 82.0, z: 117.0},
        {x: -2513.0, y: 32.0, z: 118.0},
        {x: -2575.0, y: -64.0, z: 128.0},
        {x: -2599.0, y: -149.0, z: 131.0},
        {x: -2785.0, y: -140.0, z: 143.0},
        {x: -2866.0, y: -98.0, z: 148.0},
        {x: -2912.0, y: -141.0, z: 147.0},
        {x: -2953.0, y: -115.0, z: 150.0},
        {x: -3054.0, y: 22.0, z: 148.0},
        {x: -2895.0, y: 203.0, z: 103.0},
        {x: -2833.0, y: 208.0, z: 98.0},
        {x: -2573.0, y: 104.0, z: 119.0},
        {x: -2560.0, y: 253.0, z: 111.0},
        {x: -2665.0, y: 251.0, z: 107.0},
        {x: -2732.0, y: 296.0, z: 103.0},
        {x: -2857.0, y: 275.0, z: 98.0},
        {x: -2930.0, y: 160.0, z: 102.0}
      ],
      [ESpot.SHADOW_6]: [
        {x: -1870.0, y: -172.0, z: 9.0},
        {x: -1891.0, y: -202.0, z: 9.0},
        {x: -1815.0, y: -77.0, z: 22.0},
        {x: -1946.0, y: -268.0, z: 8.0},
        {x: -1876.0, y: -240.0, z: 7.0},
        {x: -1882.0, y: -301.0, z: 4.0},
        {x: -1887.0, y: -371.0, z: 4.0},
        {x: -1966.0, y: -310.0, z: 7.0},
        {x: -1959.0, y: -386.0, z: 4.0},
        {x: -1971.0, y: -436.0, z: 4.0},
        {x: -1865.0, y: -442.0, z: 6.0},
        {x: -2027.0, y: -385.0, z: 6.0},
        {x: -1944.0, y: -363.0, z: 4.0},
        {x: -1793.0, y: -109.0, z: 23.0},
        {x: -1922.0, y: -101.0, z: 24.0},
        {x: -1953.0, y: -216.0, z: 10.0},
        {x: -1990.0, y: -288.0, z: 7.0},
        {x: -1995.0, y: -339.0, z: 5.0},
        {x: -1915.0, y: -456.0, z: 4.0}
      ],
      [ESpot.SHADOW_7]: [
        {x: -1803.0, y: -854.0, z: 23.0},
        {x: -1837.0, y: -944.0, z: 23.0},
        {x: -1818.0, y: -1051.0, z: 23.0},
        {x: -1851.0, y: -1090.0, z: 23.0},
        {x: -1850.0, y: -1202.0, z: 23.0},
        {x: -1847.0, y: -1271.0, z: 23.0},
        {x: -1811.0, y: -1168.0, z: 26.0},
        {x: -1787.0, y: -981.0, z: 23.0},
        {x: -1787.0, y: -820.0, z: 23.0},
        {x: -1800.0, y: -797.0, z: 22.0},
        {x: -1872.0, y: -688.0, z: 28.0},
        {x: -1842.0, y: -999.0, z: 23.0},
        {x: -1814.0, y: -1096.0, z: 24.0},
        {x: -1859.0, y: -1151.0, z: 23.0},
        {x: -1823.0, y: -1136.0, z: 25.0}
      ],
      [ESpot.SHADOW_8]: [
        {x: -2333.0, y: -1310.0, z: 89.0},
        {x: -2365.0, y: -1214.0, z: 88.0},
        {x: -2379.0, y: -1182.0, z: 88.0},
        {x: -2322.0, y: -1249.0, z: 90.0},
        {x: -2406.0, y: -1214.0, z: 92.0},
        {x: -2432.0, y: -1118.0, z: 92.0},
        {x: -2463.0, y: -1217.0, z: 93.0},
        {x: -2337.0, y: -1354.0, z: 88.0},
        {x: -2301.0, y: -1369.0, z: 88.0},
        {x: -2399.0, y: -1034.0, z: 90.0},
        {x: -2342.0, y: -1405.0, z: 88.0},
        {x: -2460.0, y: -1081.0, z: 92.0},
        {x: -2507.0, y: -1141.0, z: 100.0},
        {x: -2395.0, y: -1251.0, z: 91.0},
        {x: -2256.0, y: -1297.0, z: 103.0}
      ],
      [ESpot.SHADOW_9]: [
        {x: -3726.0, y: -4134.0, z: 55.0},
        {x: -3834.0, y: -4146.0, z: 66.0},
        {x: -3802.0, y: -4262.0, z: 66.0},
        {x: -3661.0, y: -4263.0, z: 66.0},
        {x: -3602.0, y: -4118.0, z: 66.0},
        {x: -3649.0, y: -4010.0, z: 73.0},
        {x: -3651.0, y: -4107.0, z: 61.0},
        {x: -3643.0, y: -4064.0, z: 66.0},
        {x: -3845.0, y: -4191.0, z: 66.0},
        {x: -3717.0, y: -4193.0, z: 55.0}
      ],
      [ESpot.SHADOW_10]: [
        {x: -2747.0, y: -3744.0, z: 261.0},
        {x: -2767.0, y: -3808.0, z: 260.0},
        {x: -2758.0, y: -3890.0, z: 259.0},
        {x: -2692.0, y: -3900.0, z: 259.0},
        {x: -2709.0, y: -3849.0, z: 260.0},
        {x: -2681.0, y: -3749.0, z: 260.0},
        {x: -2717.0, y: -3736.0, z: 260.0},
        {x: -2783.0, y: -3754.0, z: 260.0},
        {x: -2771.0, y: -3841.0, z: 260.0},
        {x: -2659.0, y: -3901.0, z: 259.0},
        {x: -2659.0, y: -3901.0, z: 259.0}
      ],
      [ESpot.SHADOW_11]: [
        {x: -1879.0, y: -2791.0, z: 8.0},
        {x: -1714.0, y: -2421.0, z: -6.0},
        {x: -1868.0, y: -3120.0, z: -15.0},
        {x: -1844.0, y: -3178.0, z: 9.0},
        {x: -1821.0, y: -3047.0, z: -23.0},
        {x: -1894.0, y: -2933.0, z: -28.0},
        {x: -1864.0, y: -2859.0, z: -5.0},
        {x: -1881.0, y: -2668.0, z: -20.0},
        {x: -1798.0, y: -2588.0, z: -21.0},
        {x: -1760.0, y: -2501.0, z: -15.0}
      ],
      [ESpot.SHADOW_12]: [
        {x: 708.0, y: -268.0, z: 18.0},
        {x: 844.0, y: -260.0, z: 14.0},
        {x: 965.0, y: -305.0, z: 11.0},
        {x: 1064.0, y: -221.0, z: 11.0},
        {x: 939.0, y: -464.0, z: 12.0},
        {x: 1200.0, y: -246.0, z: 18.0},
        {x: 1142.0, y: -550.0, z: 35.0},
        {x: 1218.0, y: -371.0, z: 35.0},
        {x: 1166.0, y: -177.0, z: 14.0},
        {x: 934.0, y: -180.0, z: 11.0}
      ],
      [ESpot.SHADOW_13]: [
        {x: 1843.0, y: 71.0, z: 60.0},
        {x: 1823.0, y: 295.0, z: 55.0},
        {x: 1952.0, y: 136.0, z: 57.0},
        {x: 2115.0, y: 69.0, z: 64.0},
        {x: 2031.0, y: 191.0, z: 55.0},
        {x: 1734.0, y: -50.0, z: 68.0},
        {x: 2037.0, y: -74.0, z: 88.0},
        {x: 1866.0, y: -12.0, z: 63.0},
        {x: 2292.0, y: -44.0, z: 86.0},
        {x: 1680.0, y: -16.0, z: 68.0}
      ],
      [ESpot.SHADOW_14]: [
        {x: 3006.0, y: 66.0, z: 75.0},
        {x: 3254.0, y: 175.0, z: 76.0},
        {x: 3386.0, y: 217.0, z: 75.0},
        {x: 3433.0, y: 502.0, z: 75.0},
        {x: 3211.0, y: 413.0, z: 119.0},
        {x: 2853.0, y: 333.0, z: 134.0},
        {x: 3342.0, y: 571.0, z: 78.0},
        {x: 2945.0, y: 97.0, z: 100.0},
        {x: 2682.0, y: 14.0, z: 84.0},
        {x: 3108.0, y: 195.0, z: 77.0}
      ],
      [ESpot.SHADOW_15]: [
        {x: 2826.0, y: -604.0, z: -2.0},
        {x: 2706.0, y: -506.0, z: -28.0},
        {x: 2799.0, y: -461.0, z: -22.0},
        {x: 2469.0, y: -427.0, z: 18.0},
        {x: 2781.0, y: -598.0, z: -21.0},
        {x: 2595.0, y: -327.0, z: 62.0},
        {x: 2473.0, y: -552.0, z: 62.0}
      ],
    
      // ECategory.OTHER
      [ESpot.PORTAL]: [
        {x: 5939, y: -1781, z: 10}, {x: 5360, y: -1534, z: 3}, {x: 5473, y: -1984, z: 9},
        {x: 5454, y: -1191, z: 111}, {x: 4367, y: -1866, z: 36}, {x: 5405, y: -2435, z: 3},
        {x: 5184, y: -2745, z: 21}, {x: 5843, y: -2978, z: 1}, {x: 4950, y: -2491, z: 43},
        {x: 5123, y: -1967, z: 35}, {x: 4106, y: -1010, z: 2}, {x: 5587, y: -665, z: 1},
        {x: 5351, y: -80, z: 13}, {x: 4807, y: 136, z: 143}, {x: 4775, y: 1390, z: 13},
        {x: 3275, y: 246, z: 80}, {x: 1929, y: 200, z: 56}, {x: 2127, y: 573, z: 3},
        {x: 1573, y: 1352, z: 133}, {x: 2078, y: 1527, z: 183}, {x: 903, y: -418, z: 12},
        {x: 219, y: 256, z: 52}, {x: 172, y: 1822, z: 18}, {x: -1349, y: 3270, z: 1},
        {x: 403, y: 3712, z: 16}, {x: -2304, y: 872, z: 80}, {x: -2672, y: 886, z: 233},
        {x: -2986, y: 955, z: 241}, {x: -1593, y: -791, z: 23}, {x: -1853, y: -129, z: 13},
        {x: -604, y: 55, z: 27}, {x: -1885, y: -3303, z: 19}, {x: -1177, y: -2436, z: 51},
        {x: 195, y: -1895, z: 0}, {x: 2814, y: -475, z: -22}, {x: 1760, y: -1920, z: -67},
        {x: -2768, y: -3742, z: 262}, {x: -3412, y: -3478, z: 91}, {x: 674, y: -2820, z: -50},
        {x: -44, y: -3300, z: -140}, {x: 5098, y: 2896, z: 278}, {x: -2711, y: 3145, z: -18},
        {x: -6095, y: 2899, z: 122}, {x: -3642, y: 202, z: 234}, {x: -4720, y: -3662, z: 8},
        {x: -446, y: -3761, z: -288}, {x: 1700, y: -3265, z: 29}, {x: 3399, y: -1884, z: 16},
        {x: 3249, y: -269, z: 147}
      ]
}